
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3Zqmb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FiltersDirectory", () => $0d1498ba14553dee$export$c47481051d3723fd);
$parcel$export(module.exports, "default", () => $0d1498ba14553dee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $iFYlf = parcelRequire("iFYlf");

var $4041n = parcelRequire("4041n");

var $yxvUH = parcelRequire("yxvUH");

var $kUACW = parcelRequire("kUACW");

var $dRl24 = parcelRequire("dRl24");

var $5qVrc = parcelRequire("5qVrc");

var $4dRjY = parcelRequire("4dRjY");

var $9OXo1 = parcelRequire("9OXo1");

var $l8ruj = parcelRequire("l8ruj");

var $2YP9W = parcelRequire("2YP9W");
var $1bQGJ = parcelRequire("1bQGJ");

var $bRTld = parcelRequire("bRTld");
const $0d1498ba14553dee$var$useFiltersDirectoryResource = (0, $kUACW.withSuspense)(()=>(0, $2YP9W.useResource)((0, $dRl24.filtersDirectoryResource)));
const $0d1498ba14553dee$export$c47481051d3723fd = ({ location: location })=>{
    const state = $0d1498ba14553dee$var$useFiltersDirectoryResource();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $yxvUH.default), {
        location: location
    }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "filters-directory"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bRTld.default), {
                tenantContext: tenantContext,
                prefetchResult: {
                    ...state
                },
                favoriteChangeContext: favoriteChangeContext,
                query: query,
                onQueryChanged: onQueryChanged
            }))));
};
// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0d1498ba14553dee$var$RouterWrapper = (0, $1bQGJ.withRouter)($0d1498ba14553dee$export$c47481051d3723fd);
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$0d1498ba14553dee$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qVrc.default), {
        id: "spa-app-bootstrap.directories.filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFYlf.default), {
        appNameSuffixForV2Event: "directory.filters",
        appNameForV3OperationalEvent: "filtersDirectory"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1498ba14553dee$var$RouterWrapper, props)));

});
parcelRegister("iFYlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d4f9fac2e290ba9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
const $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d4f9fac2e290ba9$export$2e2bcd8739ae039 = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("yxvUH", function(module, exports) {

$parcel$export(module.exports, "default", () => $155570b6ec56a1d1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iJPdQ = parcelRequire("iJPdQ");

var $aRmgJ = parcelRequire("aRmgJ");

var $2J2h7 = parcelRequire("2J2h7");

var $kSlYX = parcelRequire("kSlYX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$155570b6ec56a1d1$export$2e2bcd8739ae039 = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJPdQ.default), {
        location: location,
        sortFieldToParam: (0, $kSlYX.sortFieldToParam),
        sortFieldFromParam: (0, $kSlYX.sortFieldFromParam),
        filterFromParams: (0, $2J2h7.filterFromParams),
        filterToParams: (0, $2J2h7.filterToParams),
        defaultQuery: (0, $aRmgJ.initialQuery)
    }, children);

});
parcelRegister("iJPdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34933f66e78f501b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $67TwH = parcelRequire("67TwH");

var $4P5qU = parcelRequire("4P5qU");

var $cd2Ri = parcelRequire("cd2Ri");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34933f66e78f501b$export$2e2bcd8739ae039 = ({ location: location, children: children, sortFieldFromParam: sortFieldFromParam, filterFromParams: filterFromParams, sortFieldToParam: sortFieldToParam, filterToParams: filterToParams, defaultQuery: defaultQuery })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67TwH.default), {
        location: location,
        queryFromUrl: (0, $cd2Ri.default)(sortFieldFromParam, filterFromParams),
        queryToUrl: (0, $4P5qU.default)(sortFieldToParam, filterToParams),
        defaultQuery: defaultQuery
    }, children);

});
parcelRegister("67TwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e75e9a90d3818a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hJCUd = parcelRequire("hJCUd");

var $8Rkzz = parcelRequire("8Rkzz");

var $ebyGx = parcelRequire("ebyGx");

var $5y0F0 = parcelRequire("5y0F0");

var $6wlPy = parcelRequire("6wlPy");

var $aJXmP = parcelRequire("aJXmP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41e75e9a90d3818a$export$2e2bcd8739ae039 = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))((0, $6wlPy.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJXmP.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};

});
parcelRegister("6wlPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c011c7ab8644dae0$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $dPSWJ = parcelRequire("dPSWJ");
const $c011c7ab8644dae0$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c011c7ab8644dae0$export$2e2bcd8739ae039 = $c011c7ab8644dae0$var$fromUrlTransformerFactory;

});

parcelRegister("aJXmP", function(module, exports) {

$parcel$export(module.exports, "AdapterWithState", () => $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ebyGx = parcelRequire("ebyGx");
class $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args), this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        }, this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("4P5qU", function(module, exports) {

$parcel$export(module.exports, "default", () => $053ceb3ca02e043a$export$2e2bcd8739ae039);

var $27NS3 = parcelRequire("27NS3");

var $aud83 = parcelRequire("aud83");
const $053ceb3ca02e043a$var$toUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const valueTransformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>({
                page: (0, $aud83.number).stringify(page)
            }),
        // @ts-expect-error - TS7006 - Parameter 'dir' implicitly has an 'any' type.
        sortDirection: (dir)=>({
                sortOrder: (0, $aud83.string).stringify(dir)
            }),
        // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
        sortField: (field)=>({
                sortKey: sortFieldTransformer(field)
            }),
        filter: filterTransformer
    };
    return (query)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(query, (params, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'.
            valueTransformers[key] ? {
                ...params,
                ...valueTransformers[key](value)
            } : params, {});
};
var $053ceb3ca02e043a$export$2e2bcd8739ae039 = $053ceb3ca02e043a$var$toUrlTransformerFactory;

});
parcelRegister("27NS3", function(module, exports) {

var $2YkAc = parcelRequire("2YkAc");

var $e7pfQ = parcelRequire("e7pfQ");

var $bxDef = parcelRequire("bxDef");

var $87mh8 = parcelRequire("87mh8");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
    var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
    return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
}
module.exports = $18c2eb891b6f17d9$var$reduce;

});
parcelRegister("87mh8", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $5e90419f1ca7764f$var$baseReduce;

});



parcelRegister("cd2Ri", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae9eca70c694773$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $dPSWJ = parcelRequire("dPSWJ");

var $27NS3 = parcelRequire("27NS3");

var $k15gu = parcelRequire("k15gu");

var $aud83 = parcelRequire("aud83");
const $5ae9eca70c694773$var$fromUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const transformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>(0, $k15gu.validatePageNumber)((0, $aud83.number).parse(page)) ? {
                page: (0, $aud83.number).parse(page)
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
        sortOrder: (order)=>(0, $k15gu.validateSortDirection)(order) ? {
                sortDirection: order
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type.
        sortKey: (key)=>sortFieldTransformer(key) ? {
                sortField: sortFieldTransformer(key)
            } : {}
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(params, (query, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'.
                transformers[key] ? {
                    ...query,
                    ...transformers[key](value)
                } : query, {
                filter: filterTransformer(params)
            })
    ]);
};
var $5ae9eca70c694773$export$2e2bcd8739ae039 = $5ae9eca70c694773$var$fromUrlTransformerFactory;

});
parcelRegister("k15gu", function(module, exports) {

$parcel$export(module.exports, "calculateTotalPages", () => $871ef586a0cb0e22$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $871ef586a0cb0e22$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $871ef586a0cb0e22$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $871ef586a0cb0e22$export$407c10b4791d7a16);

const $871ef586a0cb0e22$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $871ef586a0cb0e22$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $871ef586a0cb0e22$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $871ef586a0cb0e22$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $871ef586a0cb0e22$export$407c10b4791d7a16 = (input)=>[
        (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    ].includes(input);

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';




parcelRegister("aRmgJ", function(module, exports) {

$parcel$export(module.exports, "ITEMS_PER_PAGE", () => $5fe1f06734b48f8e$export$ec93a669a20aa982);
$parcel$export(module.exports, "initialQuery", () => $5fe1f06734b48f8e$export$8af7177c92ae79e3);
$parcel$export(module.exports, "EXPAND_PARAMETERS", () => $5fe1f06734b48f8e$export$ac5ed0fd17aacb1c);


var $e9yg4 = parcelRequire("e9yg4");
const $5fe1f06734b48f8e$export$ec93a669a20aa982 = 25;
const $5fe1f06734b48f8e$export$8af7177c92ae79e3 = {
    sortField: (0, $e9yg4.NAME),
    sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    page: 1,
    filter: {
        query: undefined,
        project: undefined,
        group: undefined,
        owner: undefined
    }
};
const $5fe1f06734b48f8e$export$ac5ed0fd17aacb1c = [
    'owner',
    'favourite',
    'favouritedCount',
    'sharePermissions',
    'editPermissions',
    'description',
    'isWritable'
];

});
parcelRegister("e9yg4", function(module, exports) {

$parcel$export(module.exports, "FAVOURITED", () => $4b8a21f619a20b61$export$fdb541a0853ce91e);
$parcel$export(module.exports, "NAME", () => $4b8a21f619a20b61$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "OWNER", () => $4b8a21f619a20b61$export$8c6af90262e3c6cd);
$parcel$export(module.exports, "POPULARITY", () => $4b8a21f619a20b61$export$baf77a5a5061f88f);
const $4b8a21f619a20b61$export$fdb541a0853ce91e = 'favourite';
const $4b8a21f619a20b61$export$3c5e605ca7ade9f2 = 'name';
const $4b8a21f619a20b61$export$8c6af90262e3c6cd = 'owner';
const $4b8a21f619a20b61$export$baf77a5a5061f88f = 'popularity';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b8a21f619a20b61$export$2e2bcd8739ae039 = [
    $4b8a21f619a20b61$export$3c5e605ca7ade9f2,
    $4b8a21f619a20b61$export$8c6af90262e3c6cd,
    $4b8a21f619a20b61$export$baf77a5a5061f88f,
    $4b8a21f619a20b61$export$fdb541a0853ce91e
];

});


parcelRegister("2J2h7", function(module, exports) {

$parcel$export(module.exports, "filterToParams", () => $fb2a70bfcb5bf9f1$export$cb128e46cc7ba0f1);
$parcel$export(module.exports, "filterFromParams", () => $fb2a70bfcb5bf9f1$export$f6542f27c27241c6);

var $g5X3G = parcelRequire("g5X3G");
const $fb2a70bfcb5bf9f1$export$cb128e46cc7ba0f1 = (filter = {})=>({
        name: filter.query || undefined,
        owner: filter.owner && filter.owner.accountId || undefined,
        selectedProject: filter.project && filter.project.value || 'anything',
        selectedGroup: filter.group && filter.group.value || 'anything'
    });
const $fb2a70bfcb5bf9f1$var$transformSelectedOwner = (input)=>input ? {
        accountId: (0, $g5X3G.toAccountId)(input)
    } : undefined;
const $fb2a70bfcb5bf9f1$var$transformSelectedProject = (input)=>input && input !== 'anything' ? {
        value: input
    } : undefined;
const $fb2a70bfcb5bf9f1$var$transformSelectedGroup = (input)=>input && input !== 'anything' ? {
        value: input,
        name: input
    } : undefined;
const $fb2a70bfcb5bf9f1$export$f6542f27c27241c6 = (params)=>({
        query: params.name || params.searchName || undefined,
        owner: $fb2a70bfcb5bf9f1$var$transformSelectedOwner(params.owner),
        project: $fb2a70bfcb5bf9f1$var$transformSelectedProject(params.selectedProject),
        group: $fb2a70bfcb5bf9f1$var$transformSelectedGroup(params.selectedGroup)
    });

});

parcelRegister("kSlYX", function(module, exports) {

$parcel$export(module.exports, "sortFieldToParam", () => $78da06d69c5b9374$export$9a7ae3517c7d79c2);
$parcel$export(module.exports, "sortFieldFromParam", () => $78da06d69c5b9374$export$307ee63ec20d9c92);

var $e9yg4 = parcelRequire("e9yg4");
const $78da06d69c5b9374$var$sortFieldMap = {
    [(0, $e9yg4.NAME).toLowerCase()]: (0, $e9yg4.NAME),
    [(0, $e9yg4.OWNER).toLowerCase()]: (0, $e9yg4.OWNER),
    [(0, $e9yg4.POPULARITY).toLowerCase()]: (0, $e9yg4.POPULARITY),
    [(0, $e9yg4.FAVOURITED).toLowerCase()]: (0, $e9yg4.FAVOURITED)
};
const $78da06d69c5b9374$export$9a7ae3517c7d79c2 = (field)=>field.toLowerCase();
const $78da06d69c5b9374$export$307ee63ec20d9c92 = (param)=>$78da06d69c5b9374$var$sortFieldMap[param] ? $78da06d69c5b9374$var$sortFieldMap[param] : null;

});


parcelRegister("kUACW", function(module, exports) {

$parcel$export(module.exports, "withSuspense", () => $4c5a941fc6e9229e$export$a3bce93d4fb4eda6);
const $4c5a941fc6e9229e$var$isDataEmpty = (data)=>data == null;
function $4c5a941fc6e9229e$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $4c5a941fc6e9229e$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});

parcelRegister("5qVrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $34104383eeaa69f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $bVDE5 = parcelRequire("bVDE5");
const $34104383eeaa69f9$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
        id: "spa-apps.error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bVDE5.default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
        const extraEventData = {
            transitionsCount: transitionsCount,
            lastTransition: lastTransition,
            navigationStart: navigationStart
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
            id: id,
            extraEventData: extraEventData
        }, children);
    }));
const $34104383eeaa69f9$var$SpaErrorBoundary = $34104383eeaa69f9$var$ErrorBoundaryWithExtraEventData;
var $34104383eeaa69f9$export$2e2bcd8739ae039 = $34104383eeaa69f9$var$SpaErrorBoundary;

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("bRTld", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8aff1b63f49f92$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $9dbF6 = parcelRequire("9dbF6");

var $bibyx = parcelRequire("bibyx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a8aff1b63f49f92$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    });
var $3a8aff1b63f49f92$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $bibyx.default), {
    Updater: $3a8aff1b63f49f92$var$Updater
});

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("bibyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $87506a67be7d894a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jzjy1 = parcelRequire("jzjy1");

var $i2Rm5 = parcelRequire("i2Rm5");

var $7iJwP = parcelRequire("7iJwP");

var $4QISh = parcelRequire("4QISh");


var $8PRuf = parcelRequire("8PRuf");

var $5rqex = parcelRequire("5rqex");

var $g5X3G = parcelRequire("g5X3G");

var $cFtGt = parcelRequire("cFtGt");

var $fhVq7 = parcelRequire("fhVq7");

var $cJXov = parcelRequire("cJXov");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $87506a67be7d894a$var$noop = ()=>{};
function $87506a67be7d894a$var$FiltersDirectory({ Updater: Updater, tenantContext: tenantContext, prefetchResult: prefetchResult, favoriteChangeContext: favoriteChangeContext, query: query, onQueryChanged: onQueryChanged }) {
    const { baseUrl: baseUrl, xsrfToken: xsrfToken, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { error: prefetchError, loading: loading, data: data } = prefetchResult;
    if (prefetchError && !loading) // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | null'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "directories-filters",
        error: prefetchError
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cFtGt.FiltersDirectorySkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhVq7.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsDirectoriesFilters",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QISh.default), {
        isServer: false,
        baseUrl: baseUrl,
        atlassianAccountId: atlassianAccountId ? (0, $g5X3G.toAccountId)(atlassianAccountId) : undefined,
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
        xsrfToken: xsrfToken,
        query: query,
        favoriteChangeContext: favoriteChangeContext,
        prefetchedData: data,
        onQueryChanged: onQueryChanged,
        onUnmount: $87506a67be7d894a$var$noop,
        withPageReadyMetrics: false,
        withoutHeader: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        metricKey: "jira.directories.filters",
        metric: (0, $cJXov.filtersDirectoryPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $8PRuf.appBundleReadyMark),
            (0, $8PRuf.prefetchApiReadyMark)
        ]
    })));
}
var $87506a67be7d894a$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('filters', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($87506a67be7d894a$var$FiltersDirectory);

});
parcelRegister("4QISh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c201c0b6db69c4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $hZHze = parcelRequire("hZHze");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");

var $97Kan = parcelRequire("97Kan");

var $id7K0 = parcelRequire("id7K0");

var $aWse0 = parcelRequire("aWse0");

var $itmJb = parcelRequire("itmJb");

var $2DwI3 = parcelRequire("2DwI3");

var $aRmgJ = parcelRequire("aRmgJ");

var $ds4d2 = parcelRequire("ds4d2");

var $lgrrw = parcelRequire("lgrrw");

var $9U2WO = parcelRequire("9U2WO");

var $2UX9B = parcelRequire("2UX9B");

var $g81jz = parcelRequire("g81jz");

var $hGfxd = parcelRequire("hGfxd");

var $4biUB = parcelRequire("4biUB");

var $64LCo = parcelRequire("64LCo");

var $jTnv2 = parcelRequire("jTnv2");
// eslint-disable-next-line jira/react/no-class-components
class $b6c201c0b6db69c4$var$Filters extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            query: undefined,
            prefetchedData: {},
            withoutHeader: false,
            withPageReadyMetrics: true,
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isAdmin: false
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $hGfxd.default)((0, $lgrrw.default));
        const { filters: filters } = props.prefetchedData;
        const { dispatch: dispatch } = this.store;
        dispatch((0, $9U2WO.setAppProps)(props));
        dispatch((0, $g81jz.setQuery)(props.query || (0, $aRmgJ.initialQuery)));
        dispatch(filters ? (0, $2UX9B.retrieved)(filters) : (0, $2UX9B.retrieve)());
    }
    componentDidUpdate(prevProps) {
        const { dispatch: dispatch, getState: getState } = this.store;
        const { query: query } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevProps, this.props)) dispatch((0, $9U2WO.setAppProps)(this.props));
        /**
     * We compare this.props.query against what's being stored inside the store ONLY IF the query prop is specified
     * i.e. NOT undefined. When query is passed in as a prop, the expectation is onQueryChanged is also passed in as
     * a prop. Using these two props, the parent component has the ability to control this component's "current query".
     * Note that this component is capable to manage its own query independently, which is why the two aforementioned
     * props are actually optional.
     */ // @ts-expect-error - TS2345 - Argument of type 'Partial<Query>' is not assignable to parameter of type 'Query'.
        if (query && (0, $ds4d2.isQueryChanged)(query, (0, $4biUB.getQuery)(getState()))) {
            dispatch((0, $g81jz.setQuery)(query));
            dispatch((0, $2UX9B.retrieve)());
        }
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const headerConfiguration = (0, $jTnv2.getHeaderConfiguration)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            id: "filter-directory-main",
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraFiltersMain",
            teamName: "jira-cosmos"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
            title: // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<string>'.
            headerConfiguration.caption ? // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<string>'.
            formatMessage(headerConfiguration.caption) : ''
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $2DwI3.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64LCo.default), null))));
    }
}
const $b6c201c0b6db69c4$var$FiltersWithContext = (props)=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const intl = (0, $aWse0.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c201c0b6db69c4$var$Filters, {
        ...props,
        isAdmin: isAdmin,
        intl: intl
    });
};
var $b6c201c0b6db69c4$export$2e2bcd8739ae039 = $b6c201c0b6db69c4$var$FiltersWithContext;

});
parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $994MI.default)({
    componentName: 'view-tracker'
})((0, $cb25w.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("lf2Au", function(module, exports) {

$parcel$export(module.exports, "default", () => $9249f8c63b854f95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $9249f8c63b854f95$var$appStyles = null;
var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyle;

});

parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("2DwI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e41aa4d32fcecaf$export$2e2bcd8739ae039);

var $705dd = parcelRequire("705dd");

var $99OGQ = parcelRequire("99OGQ");

var $lyrWK = parcelRequire("lyrWK");

var $aCttf = parcelRequire("aCttf");

var $dXrFW = parcelRequire("dXrFW");

var $7B6Sy = parcelRequire("7B6Sy");

var $5XpfZ = parcelRequire("5XpfZ");
const $8e41aa4d32fcecaf$var$flagsMapper = (action)=>{
    switch(action.type){
        // @ts-expect-error - TS2678 - Type '"state.actions.copy.COPY_INITIATE_FAILED"' is not comparable to type '"state.actions.operations.DELETED" | "state.actions.operations.DELETE_FAILED" | "state.actions.operations.COPIED" | "state.actions.operations.COPY_FAILED"'.
        case 0, $705dd.COPY_INITIATE_FAILED:
            return (0, $5XpfZ.default)();
        case 0, $99OGQ.COPIED:
            return (0, $aCttf.default)({
                name: action.payload.originalItemName
            });
        case 0, $99OGQ.COPY_FAILED:
            return (0, $lyrWK.default)(action.payload);
        case 0, $99OGQ.DELETED:
            return (0, $7B6Sy.default)(action.payload);
        case 0, $99OGQ.DELETE_FAILED:
            return (0, $dXrFW.default)(action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $8e41aa4d32fcecaf$export$2e2bcd8739ae039 = $8e41aa4d32fcecaf$var$flagsMapper;

});
parcelRegister("705dd", function(module, exports) {

$parcel$export(module.exports, "COPY_INITIATE_FAILED", () => $85491ada8f3c7303$export$eff7a7b152af4c1);
const $85491ada8f3c7303$export$eff7a7b152af4c1 = 'state.actions.copy.COPY_INITIATE_FAILED';
const $85491ada8f3c7303$export$3f5c30a007387562 = ()=>({
        type: $85491ada8f3c7303$export$eff7a7b152af4c1
    });

});

parcelRegister("99OGQ", function(module, exports) {

$parcel$export(module.exports, "DELETED", () => $4987d65409f61620$export$1cc76b53f23597de);
$parcel$export(module.exports, "deleted", () => $4987d65409f61620$export$bccbf0c716f226f4);
$parcel$export(module.exports, "DELETE_FAILED", () => $4987d65409f61620$export$ae082348f4557243);
$parcel$export(module.exports, "deleteFailed", () => $4987d65409f61620$export$8830effd508d9f31);
$parcel$export(module.exports, "COPIED", () => $4987d65409f61620$export$ab06cbdc503432af);
$parcel$export(module.exports, "COPY_FAILED", () => $4987d65409f61620$export$9db31c0e010caedf);
// DELETED
const $4987d65409f61620$export$1cc76b53f23597de = 'state.actions.operations.DELETED';
const $4987d65409f61620$export$bccbf0c716f226f4 = (name)=>({
        type: $4987d65409f61620$export$1cc76b53f23597de,
        payload: {
            name: name
        }
    });
const $4987d65409f61620$export$ae082348f4557243 = 'state.actions.operations.DELETE_FAILED';
const $4987d65409f61620$export$8830effd508d9f31 = (name)=>({
        type: $4987d65409f61620$export$ae082348f4557243,
        payload: {
            name: name
        }
    });
const $4987d65409f61620$export$ab06cbdc503432af = 'state.actions.operations.COPIED';
const $4987d65409f61620$export$a92b46551664f4e = (payload)=>({
        type: $4987d65409f61620$export$ab06cbdc503432af,
        payload: payload
    });
const $4987d65409f61620$export$9db31c0e010caedf = 'state.actions.operations.COPY_FAILED';
const $4987d65409f61620$export$5d8d1af388d10413 = (payload)=>({
        type: $4987d65409f61620$export$9db31c0e010caedf,
        payload: payload
    });

});

parcelRegister("lyrWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ff8026b7aa76d6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $12ff8026b7aa76d6$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.copy.error.title",
        "defaultMessage": "We couldn't create {name}"
    },
    description: {
        "id": "directories.filters-v2.main.flags.copy.error.description",
        "defaultMessage": "There was an error, please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$12ff8026b7aa76d6$export$2e2bcd8739ae039 = (name)=>({
        type: 'error',
        title: [
            $12ff8026b7aa76d6$var$messages.title,
            {
                name: name
            }
        ],
        description: $12ff8026b7aa76d6$var$messages.description,
        messageId: 'filters-main.flags.copy.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("aCttf", function(module, exports) {

$parcel$export(module.exports, "default", () => $908b82319d1a2257$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $908b82319d1a2257$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.copy.success.title",
        "defaultMessage": "A copy of {name} was successfully created."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$908b82319d1a2257$export$2e2bcd8739ae039 = ({ name: name })=>({
        type: 'success',
        title: [
            $908b82319d1a2257$var$messages.title,
            {
                name: name
            }
        ],
        isAutoDismiss: true,
        messageId: 'filters-main.flags.copy.flag.success',
        messageType: 'transactional'
    });

});

parcelRegister("dXrFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $589d0026efbddbec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $589d0026efbddbec$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.delete.error.title",
        "defaultMessage": "We couldn't delete {name}"
    },
    description: {
        "id": "directories.filters-v2.main.flags.delete.error.description",
        "defaultMessage": "There was an error, please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$589d0026efbddbec$export$2e2bcd8739ae039 = ({ name: name })=>({
        type: 'error',
        title: [
            $589d0026efbddbec$var$messages.title,
            {
                name: name
            }
        ],
        description: $589d0026efbddbec$var$messages.description,
        messageId: 'filters-main.flags.delete.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("7B6Sy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fffd95b0653be30$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7fffd95b0653be30$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.delete.success.title",
        "defaultMessage": "{name} was deleted"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7fffd95b0653be30$export$2e2bcd8739ae039 = ({ name: name })=>({
        type: 'success',
        title: [
            $7fffd95b0653be30$var$messages.title,
            {
                name: name
            }
        ],
        isAutoDismiss: true,
        messageId: 'filters-main.flags.delete.flag.success',
        messageType: 'transactional'
    });

});

parcelRegister("5XpfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c99c810612d5df8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $5c99c810612d5df8$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.main.flags.initiate-copy-modal.error.title",
        "defaultMessage": "We couldn't get filter data"
    },
    description: {
        "id": "directories.filters-v2.main.flags.initiate-copy-modal.error.description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5c99c810612d5df8$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $5c99c810612d5df8$var$messages.title,
        description: $5c99c810612d5df8$var$messages.description,
        messageId: 'filters-main.flags.initiate-copy-modal.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("ds4d2", function(module, exports) {

$parcel$export(module.exports, "isQueryChanged", () => $630ffe7c034a2ba0$export$dcc7e61e8982458d);

var $ajpes = parcelRequire("ajpes");
const $630ffe7c034a2ba0$var$getOwnerIdentifier = (owner)=>owner.accountId;
const $630ffe7c034a2ba0$var$getQueryValues = (target)=>{
    const { page: page, sortField: sortField, sortDirection: sortDirection, filter: filter } = target;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { query: query, owner: owner, project: project, group: group } = filter;
    return {
        page: page,
        sortField: sortField,
        sortDirection: sortDirection,
        filter: {
            query: query,
            owner: owner && $630ffe7c034a2ba0$var$getOwnerIdentifier(owner),
            project: project && project.value,
            group: group && group.value
        }
    };
};
const $630ffe7c034a2ba0$export$dcc7e61e8982458d = (newQuery, prevQuery)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))($630ffe7c034a2ba0$var$getQueryValues(newQuery), $630ffe7c034a2ba0$var$getQueryValues(prevQuery));

});

parcelRegister("lgrrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a50a64ff718c99$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $bqhaK = parcelRequire("bqhaK");

var $l0SAx = parcelRequire("l0SAx");
var $20a50a64ff718c99$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $bqhaK.default), (0, $l0SAx.default));

});
parcelRegister("bqhaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ea25c070065f796$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $hJCUd = parcelRequire("hJCUd");

var $kVLXA = parcelRequire("kVLXA");

var $g81jz = parcelRequire("g81jz");

var $hXBjD = parcelRequire("hXBjD");

var $4biUB = parcelRequire("4biUB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1ea25c070065f796$var$querySet = (action$, store)=>action$.ofType((0, $g81jz.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $hXBjD.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $kVLXA.Observable).empty();
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1ea25c070065f796$var$queryPatched = (action$, store)=>action$.ofType((0, $g81jz.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $hXBjD.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))(payload, (0, $4biUB.getQuery)(state)));
        return (0, $kVLXA.Observable).empty();
    });
var $1ea25c070065f796$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($1ea25c070065f796$var$querySet, $1ea25c070065f796$var$queryPatched);

});
parcelRegister("g81jz", function(module, exports) {

$parcel$export(module.exports, "SET_QUERY", () => $473d28dd36d8ab45$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $473d28dd36d8ab45$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $473d28dd36d8ab45$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $473d28dd36d8ab45$export$8a4e224aafd3a2bf);
const $473d28dd36d8ab45$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $473d28dd36d8ab45$export$f3b215b0b382f63b = (payload)=>({
        type: $473d28dd36d8ab45$export$11bcea24b35a126f,
        payload: payload
    });
const $473d28dd36d8ab45$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $473d28dd36d8ab45$export$8a4e224aafd3a2bf = (payload)=>({
        type: $473d28dd36d8ab45$export$403065a1ff0b1663,
        payload: payload
    });

});

parcelRegister("hXBjD", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountId", () => $213159c97288625c$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getBaseUrl", () => $213159c97288625c$export$f654b28f82155665);
$parcel$export(module.exports, "getIsAdmin", () => $213159c97288625c$export$7d046765d192af80);
$parcel$export(module.exports, "getOnQueryChanged", () => $213159c97288625c$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getXsrfToken", () => $213159c97288625c$export$14407a25c57e1f92);
$parcel$export(module.exports, "isWithoutHeader", () => $213159c97288625c$export$ac359c528ee5de31);
const $213159c97288625c$export$f5baf4f0aaa47428 = (state)=>state.app.props.atlassianAccountId;
const $213159c97288625c$export$f654b28f82155665 = (state)=>state.app.props.baseUrl;
const $213159c97288625c$export$7d046765d192af80 = (state)=>state.app.props.isAdmin;
const $213159c97288625c$export$59e4f8ebf6520bf7 = (state)=>state.app.props.onQueryChanged;
const $213159c97288625c$export$14407a25c57e1f92 = (state)=>state.app.props.xsrfToken;
const $213159c97288625c$export$ac359c528ee5de31 = (state)=>state.app.props.withoutHeader;
const $213159c97288625c$export$29e8a85166eb4498 = (state)=>state.app.props.withPageReadyMetrics;

});

parcelRegister("4biUB", function(module, exports) {

$parcel$export(module.exports, "getQuery", () => $12ff88bc7ce0b1fb$export$71eec30d9db46a56);
$parcel$export(module.exports, "getSortField", () => $12ff88bc7ce0b1fb$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $12ff88bc7ce0b1fb$export$509e2b9937961873);
$parcel$export(module.exports, "getPage", () => $12ff88bc7ce0b1fb$export$c2a6433281518c91);
$parcel$export(module.exports, "getFilter", () => $12ff88bc7ce0b1fb$export$61ec8404f465cd36);
$parcel$export(module.exports, "getSearchQuery", () => $12ff88bc7ce0b1fb$export$1664b92369554829);
$parcel$export(module.exports, "getSelectedProject", () => $12ff88bc7ce0b1fb$export$1ebc7a42c839af66);
$parcel$export(module.exports, "getSelectedGroup", () => $12ff88bc7ce0b1fb$export$27ee39f0d715ac22);
$parcel$export(module.exports, "getSelectedOwner", () => $12ff88bc7ce0b1fb$export$858444e3fc2798fd);
$parcel$export(module.exports, "isFilterApplied", () => $12ff88bc7ce0b1fb$export$980aed36f19060a5);

var $dGvGJ = parcelRequire("dGvGJ");
const $12ff88bc7ce0b1fb$export$71eec30d9db46a56 = (state)=>state.query;
const $12ff88bc7ce0b1fb$export$9b753af5a9fb5911 = (state)=>state.query.sortField;
const $12ff88bc7ce0b1fb$export$509e2b9937961873 = (state)=>state.query.sortDirection;
const $12ff88bc7ce0b1fb$export$c2a6433281518c91 = (state)=>state.query.page;
const $12ff88bc7ce0b1fb$export$61ec8404f465cd36 = (state)=>state.query.filter;
const $12ff88bc7ce0b1fb$export$1664b92369554829 = (state)=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36(state)?.query || '';
const $12ff88bc7ce0b1fb$export$1ebc7a42c839af66 = (state)=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36(state)?.project;
const $12ff88bc7ce0b1fb$export$27ee39f0d715ac22 = (state)=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36(state)?.group;
const $12ff88bc7ce0b1fb$export$858444e3fc2798fd = (state)=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36(state)?.owner;
const $12ff88bc7ce0b1fb$export$980aed36f19060a5 = (0, $dGvGJ.createSelector)($12ff88bc7ce0b1fb$export$1664b92369554829, $12ff88bc7ce0b1fb$export$1ebc7a42c839af66, $12ff88bc7ce0b1fb$export$27ee39f0d715ac22, $12ff88bc7ce0b1fb$export$858444e3fc2798fd, (queryValue, projectValue, groupValue, ownerValue)=>!!queryValue || !!projectValue || !!groupValue || !!ownerValue);

});


parcelRegister("l0SAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $81e033301b263805$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("7qVV7");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jcw0u = parcelRequire("jcw0u");

var $05iiI = parcelRequire("05iiI");

var $2UX9B = parcelRequire("2UX9B");

var $hXBjD = parcelRequire("hXBjD");

var $4biUB = parcelRequire("4biUB");

var $i0CUl = parcelRequire("i0CUl");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$81e033301b263805$export$2e2bcd8739ae039 = (action$, store)=>{
    const getFiltersRequestAction$ = action$.ofType((0, $2UX9B.RETRIEVE));
    return getFiltersRequestAction$.mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $hXBjD.getBaseUrl)(state);
        const request = (0, $i0CUl.getServiceRequest)(state);
        const filter = (0, $4biUB.getFilter)(state);
        const isAdmin = (0, $hXBjD.getIsAdmin)(state);
        // @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'Filter'.
        return (0, $kVLXA.Observable).fromPromise((0, $05iiI.default)(baseUrl, request, filter, isAdmin)).mergeMap((result)=>(0, $kVLXA.Observable).of((0, $2UX9B.retrieved)(result))).takeUntil(getFiltersRequestAction$).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'retrieveFilters',
                    packageName: 'jiraFiltersMain',
                    teamName: 'jira-cosmos'
                }
            });
            return (0, $kVLXA.Observable).of((0, $2UX9B.retrieveFailed)());
        });
    });
};

});
parcelRegister("05iiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e11696e02827824$export$2e2bcd8739ae039);

var $iUBbS = parcelRequire("iUBbS");

var $bpsHV = parcelRequire("bpsHV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e11696e02827824$export$2e2bcd8739ae039 = async (baseUrl, request, filter, isAdmin)=>{
    const restResponse = await (0, $iUBbS.default)(baseUrl, request, filter, isAdmin);
    return (0, $bpsHV.transformFilters)(baseUrl, restResponse.values, restResponse.total);
};

});
parcelRegister("iUBbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca849b16fe2a082$export$2e2bcd8739ae039);

var $3NMrl = parcelRequire("3NMrl");

var $ebyGx = parcelRequire("ebyGx");

var $8xvPa = parcelRequire("8xvPa");

var $ePCtu = parcelRequire("ePCtu");

var $fsh9d = parcelRequire("fsh9d");

var $5HnTq = parcelRequire("5HnTq");

const $cca849b16fe2a082$var$createQueryFilter = (filter)=>({
        filterName: filter.query,
        isSubstringMatch: true
    });
const $cca849b16fe2a082$var$createProjectFilter = (filter)=>({
        projectId: filter.project ? filter.project.value : undefined
    });
const $cca849b16fe2a082$var$createGroupFilter = (filter)=>({
        groupname: filter.group ? filter.group.value : undefined
    });
const $cca849b16fe2a082$var$createOwnerFilter = (filter)=>({
        accountId: filter.owner ? filter.owner.accountId : undefined,
        owner: undefined
    });
const $cca849b16fe2a082$var$logError = async (error, currentTry)=>{
    (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'ops.rest.filters.get', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8), `Cannot fetch filters - is SSR: ${String(false)}, attempt: ${currentTry}`);
};
const $cca849b16fe2a082$export$20e00d0048bb5104 = ()=>'/rest/api/2/filter/search';
const $cca849b16fe2a082$export$7138c24907de3954 = (baseUrl, request, filter, isAdmin)=>{
    const queryParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(request, 'startAt', 'maxResults', 'orderBy', 'expand'),
        ...filter.query ? $cca849b16fe2a082$var$createQueryFilter(filter) : undefined,
        ...filter.project ? $cca849b16fe2a082$var$createProjectFilter(filter) : undefined,
        ...filter.group ? $cca849b16fe2a082$var$createGroupFilter(filter) : undefined,
        ...filter.owner ? $cca849b16fe2a082$var$createOwnerFilter(filter) : undefined
    };
    return `${$cca849b16fe2a082$export$20e00d0048bb5104()}?${(0, $ebyGx.stringify)(queryParams)}${isAdmin ? '&overrideSharePermissions=true' : ''}`;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cca849b16fe2a082$export$2e2bcd8739ae039 = async (baseUrl, request, filter, isAdmin)=>{
    const url = $cca849b16fe2a082$export$7138c24907de3954(baseUrl, request, filter, isAdmin);
    const response = await (0, $ePCtu.fetchWithRetry)(url, (0, $5HnTq.getDefaultOptions)(url), $cca849b16fe2a082$var$logError);
    if (response.ok) return response.json();
    throw await (0, $8xvPa.getErrorFromResponse)(response, 'Cannot fetch filters');
};

});
parcelRegister("3NMrl", function(module, exports) {

var $i2e26 = parcelRequire("i2e26");

var $9SRAA = parcelRequire("9SRAA");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
    return object == null ? {} : $i2e26(object, paths);
});
module.exports = $2c4b85df1af41471$var$pick;

});
parcelRegister("i2e26", function(module, exports) {

var $4gaCO = parcelRequire("4gaCO");

var $fh9gH = parcelRequire("fh9gH");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $d2134c8f0f8064b1$var$basePick(object, paths) {
    return $4gaCO(object, paths, function(value, path) {
        return $fh9gH(object, path);
    });
}
module.exports = $d2134c8f0f8064b1$var$basePick;

});


parcelRegister("8xvPa", function(module, exports) {

$parcel$export(module.exports, "getErrorFromResponse", () => $8065287d9cd7a779$export$7780d7826aafbede);

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $8065287d9cd7a779$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $eusud.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $jJZqs.default)(response.status, errorMessage);
};

});

parcelRegister("ePCtu", function(module, exports) {

$parcel$export(module.exports, "fetchWithRetry", () => $97da449f15cd9238$export$cffaac380b94df26);

var $5HnTq = parcelRequire("5HnTq");

var $8xvPa = parcelRequire("8xvPa");
const $97da449f15cd9238$export$fbc55f9ab8ae7207 = false ? 1 : 3;
const $97da449f15cd9238$var$logResponseError = async (logSafeErrorWithoutCustomerData, response, currentTry)=>{
    const error = await (0, $8xvPa.getErrorFromResponse)(response, 'Directory fetch with retry failed');
    await logSafeErrorWithoutCustomerData(error, currentTry);
};
const $97da449f15cd9238$export$cffaac380b94df26 = async (url, options, logSafeErrorWithoutCustomerData, currentTry = 1)=>{
    try {
        const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
        if (!response.ok) {
            await $97da449f15cd9238$var$logResponseError(logSafeErrorWithoutCustomerData, response, currentTry);
            if (currentTry < $97da449f15cd9238$export$fbc55f9ab8ae7207) return $97da449f15cd9238$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
        }
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await logSafeErrorWithoutCustomerData(error, currentTry);
        if (currentTry < $97da449f15cd9238$export$fbc55f9ab8ae7207) return $97da449f15cd9238$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
        throw error;
    }
};

});

parcelRegister("fsh9d", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $064efdbf2b7e743c$export$c77be5886e7f1d9e);

var $2YZCu = parcelRequire("2YZCu");
const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});

const $c6c682f59adc6c63$export$9c2a9d62bcf944f8 = 'directories.filters.error';


parcelRegister("bpsHV", function(module, exports) {

$parcel$export(module.exports, "transformFilters", () => $bfb2b3de2ad77495$export$6b801750e47278fe);

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $1Tbo7 = parcelRequire("1Tbo7");
const $bfb2b3de2ad77495$export$6b801750e47278fe = (baseUrl, filters, total)=>{
    const order = filters.map((i)=>i.id);
    const responsesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(filters, (filter)=>filter.id);
    const page = (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(responsesById, (response)=>(0, $1Tbo7.transformFilter)(baseUrl, response));
    return {
        page: page,
        order: order,
        total: total
    };
};

});
parcelRegister("1Tbo7", function(module, exports) {

$parcel$export(module.exports, "transformFilter", () => $b92180b5876a8d46$export$4f94cef62d9cfa51);

var $knvh6 = parcelRequire("knvh6");
const $b92180b5876a8d46$export$4f94cef62d9cfa51 = (baseUrl, item)=>({
        id: item.id,
        name: item.name,
        viewUrl: `/issues/?filter=${item.id}`,
        owner: item.owner ? (0, $knvh6.transformUser)(baseUrl, item.owner) : null,
        isFavourite: item.favourite,
        popularity: item.favouritedCount || 0,
        shares: item.sharePermissions ? item.sharePermissions.map((0, $knvh6.transformSharePermission)).filter(Boolean) : [],
        edits: item.editPermissions ? item.editPermissions.map((0, $knvh6.transformSharePermission)).filter(Boolean) : [],
        description: item.description,
        jql: item.jql,
        isWritable: item.isWritable === true
    });

});
parcelRegister("knvh6", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $879c58d3b16279dc$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformSharePermission", () => $879c58d3b16279dc$export$443a799045209d52);
$parcel$export(module.exports, "transformSharePermissionsToServer", () => $879c58d3b16279dc$export$e05899da868da914);


const $879c58d3b16279dc$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $879c58d3b16279dc$export$88dcd5c1adae8021 = (baseUrl, user)=>({
        displayName: user.displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        accountId: user.accountId,
        profileUrl: `/jira/people/${user.accountId}`
    });
const $879c58d3b16279dc$export$443a799045209d52 = (sharePermission)=>{
    switch(sharePermission.type){
        case 0, $a889b3091d5309c7$export$86517eb0163ef745:
            return {
                type: (0, $a889b3091d5309c7$export$86517eb0163ef745)
            };
        case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
            return {
                type: (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)
            };
        case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
            return {
                type: (0, $a889b3091d5309c7$export$b02d7412182d1bce),
                group: {
                    ...sharePermission.group
                }
            };
        case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
            {
                const { project: project, role: role } = sharePermission;
                return {
                    type: (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                    project: {
                        id: project.id,
                        name: project.name,
                        avatarUrl: project.avatarUrls['48x48']
                    },
                    role: role && {
                        id: role.id,
                        name: role.name
                    }
                };
            }
        case 0, $a889b3091d5309c7$export$487da0972e3459fe:
            return sharePermission;
        case 0, $a889b3091d5309c7$export$aea0835048e1c730:
            {
                const { user: user } = sharePermission;
                return {
                    type: (0, $a889b3091d5309c7$export$aea0835048e1c730),
                    user: {
                        accountId: user.accountId,
                        displayName: user.displayName,
                        avatarUrl: user.avatarUrls['48x48']
                    }
                };
            }
        default:
            $879c58d3b16279dc$var$assertUnreachable(sharePermission);
            return null;
    }
};
const $879c58d3b16279dc$export$e05899da868da914 = (sharePermissions, shouldReturnGroupIdForGroupIfAvailable = false)=>sharePermissions.map((sharePermission)=>{
        switch(sharePermission.type){
            case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                {
                    let group = {
                        name: sharePermission.group.name
                    };
                    if (shouldReturnGroupIdForGroupIfAvailable && sharePermission.group.groupId) group = {
                        groupId: sharePermission.group.groupId
                    };
                    return {
                        type: sharePermission.type,
                        group: group
                    };
                }
            case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                return {
                    type: sharePermission.type,
                    user: {
                        accountId: sharePermission.user.accountId
                    }
                };
            case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                {
                    const permission = {
                        type: sharePermission.role ? (0, $3f2163233a19a685$export$4d955b5fb0c1d4d7) : (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                        project: {
                            id: sharePermission.project.id
                        }
                    };
                    if (sharePermission.role) permission.role = {
                        id: sharePermission.role.id
                    };
                    return permission;
                }
            case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                return sharePermission;
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                return {
                    type: (0, $3f2163233a19a685$export$e2fe9963c33d5918)
                };
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                return sharePermission;
            default:
                $879c58d3b16279dc$var$assertUnreachable(sharePermission);
                return sharePermission;
        }
    });

});
const $a889b3091d5309c7$export$b02d7412182d1bce = 'group';
const $a889b3091d5309c7$export$5ef95a67b8fd1ff6 = 'project';
const $a889b3091d5309c7$export$487da0972e3459fe = 'project-unknown';
const $a889b3091d5309c7$export$b0a0e62d9b1a8269 = 'loggedin';
const $a889b3091d5309c7$export$86517eb0163ef745 = 'global';
const $a889b3091d5309c7$export$aea0835048e1c730 = 'user';
 // this is what can come from backend

const $3f2163233a19a685$export$e2fe9963c33d5918 = 'authenticated';
const $3f2163233a19a685$export$4d955b5fb0c1d4d7 = 'projectRole';





parcelRegister("2UX9B", function(module, exports) {

$parcel$export(module.exports, "RETRIEVE", () => $7877f29733d95837$export$7bf2c28a4e08c796);
$parcel$export(module.exports, "retrieve", () => $7877f29733d95837$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "RETRIEVED", () => $7877f29733d95837$export$1a07e8ff5bab976c);
$parcel$export(module.exports, "retrieved", () => $7877f29733d95837$export$4058166ec369dd8);
$parcel$export(module.exports, "RETRIEVE_FAILED", () => $7877f29733d95837$export$26e5d507c83e3d5a);
$parcel$export(module.exports, "retrieveFailed", () => $7877f29733d95837$export$1c9b9c3d8868d26f);
$parcel$export(module.exports, "PATCH", () => $7877f29733d95837$export$54950d96c4d7b0);
$parcel$export(module.exports, "patch", () => $7877f29733d95837$export$b76953f99ab2be78);
const $7877f29733d95837$export$7bf2c28a4e08c796 = 'state.actions.filters.RETRIEVE';
const $7877f29733d95837$export$8a4d17b6e8486e66 = ()=>({
        type: $7877f29733d95837$export$7bf2c28a4e08c796
    });
const $7877f29733d95837$export$1a07e8ff5bab976c = 'state.actions.filters.RETRIEVED';
const $7877f29733d95837$export$4058166ec369dd8 = (payload)=>({
        type: $7877f29733d95837$export$1a07e8ff5bab976c,
        payload: payload
    });
const $7877f29733d95837$export$26e5d507c83e3d5a = 'state.actions.filters.RETRIEVE_FAILED';
const $7877f29733d95837$export$1c9b9c3d8868d26f = ()=>({
        type: $7877f29733d95837$export$26e5d507c83e3d5a
    });
const $7877f29733d95837$export$54950d96c4d7b0 = 'state.actions.filters.PATCH';
const $7877f29733d95837$export$b76953f99ab2be78 = (payload)=>({
        type: $7877f29733d95837$export$54950d96c4d7b0,
        payload: payload
    });

});

parcelRegister("i0CUl", function(module, exports) {

$parcel$export(module.exports, "getServiceRequest", () => $d2f4336c6070bf3e$export$d7889f7cae5c51ff);

var $b3NWe = parcelRequire("b3NWe");

var $aRmgJ = parcelRequire("aRmgJ");

var $e9yg4 = parcelRequire("e9yg4");

var $4biUB = parcelRequire("4biUB");
const $d2f4336c6070bf3e$var$SORT_FIELDS = {
    [(0, $e9yg4.NAME)]: 'NAME',
    [(0, $e9yg4.OWNER)]: 'OWNER',
    [(0, $e9yg4.FAVOURITED)]: 'IS_FAVOURITE',
    [(0, $e9yg4.POPULARITY)]: 'FAVOURITE_COUNT'
};
const $d2f4336c6070bf3e$var$getSort = (state)=>({
        direction: (0, $4biUB.getSortDirection)(state),
        field: $d2f4336c6070bf3e$var$SORT_FIELDS[(0, $4biUB.getSortField)(state)]
    });
const $d2f4336c6070bf3e$export$d7889f7cae5c51ff = (state)=>(0, $b3NWe.createPageRequest)((0, $4biUB.getPage)(state), (0, $aRmgJ.ITEMS_PER_PAGE), $d2f4336c6070bf3e$var$getSort(state), (0, $aRmgJ.EXPAND_PARAMETERS));

});
parcelRegister("b3NWe", function(module, exports) {

$parcel$export(module.exports, "createPageRequest", () => $76f67021d51b1075$export$6c268d1798324d1);
const $76f67021d51b1075$export$a2b44ae778ac3391 = (startAt, maxResults, order, expand)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    return pageRequest;
};
const $76f67021d51b1075$export$2db35c6ee4729a76 = (startAt, maxResults, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    if (searchBy && searchBy.length) pageRequest.searchBy = searchBy.join(',');
    return pageRequest;
};
const $76f67021d51b1075$export$6c268d1798324d1 = (page, itemsPerPage, order, expand)=>$76f67021d51b1075$export$a2b44ae778ac3391(itemsPerPage * (page - 1), itemsPerPage, order, expand);
const $76f67021d51b1075$export$98ffd4f2a2fa32d7 = (page, itemsPerPage, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>$76f67021d51b1075$export$2db35c6ee4729a76(itemsPerPage * (page - 1), itemsPerPage, order, expand, searchBy);

});




parcelRegister("9U2WO", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $05ed3b55ae66b821$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $05ed3b55ae66b821$export$cfda7627848a58cd);
const $05ed3b55ae66b821$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $05ed3b55ae66b821$export$cfda7627848a58cd = (payload)=>({
        type: $05ed3b55ae66b821$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("hGfxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd276c550df891db$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $3sbO7 = parcelRequire("3sbO7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd276c550df891db$export$2e2bcd8739ae039 = (rootEpic, initialState)=>(0, $F2Mxm.default)({
        initialState: initialState,
        appName: 'directories/filters',
        rootReducer: $3sbO7.default,
        rootEpic: rootEpic
    });

});
parcelRegister("3sbO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e44ff8c9aef63065$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $j8MrP = parcelRequire("j8MrP");

var $bOupe = parcelRequire("bOupe");

var $ef3e5 = parcelRequire("ef3e5");

var $7XGTR = parcelRequire("7XGTR");
var $e44ff8c9aef63065$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    app: $j8MrP.default,
    filters: $ef3e5.default,
    query: $7XGTR.default,
    copyFilterModal: $bOupe.default
});

});
parcelRegister("j8MrP", function(module, exports) {

$parcel$export(module.exports, "default", () => $193619407f596e0d$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $9U2WO = parcelRequire("9U2WO");
const $193619407f596e0d$export$d4c72bab9d6cc13a = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$193619407f596e0d$export$2e2bcd8739ae039 = (state = $193619407f596e0d$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9U2WO.SET_APP_PROPS:
            return {
                ...state,
                props: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(action.payload, 'query')
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("bOupe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e9c4af67d268a03$export$2e2bcd8739ae039);

var $kWgA3 = parcelRequire("kWgA3");
const $9e9c4af67d268a03$export$d4c72bab9d6cc13a = {
    isCopyFilterModalOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9e9c4af67d268a03$export$2e2bcd8739ae039 = (state = $9e9c4af67d268a03$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $kWgA3.OPEN_COPY_FILTER_MODAL:
            return {
                isCopyFilterModalOpen: true
            };
        case 0, $kWgA3.CLOSE_COPY_FILTER_MODAL:
            return {
                isCopyFilterModalOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("kWgA3", function(module, exports) {

$parcel$export(module.exports, "OPEN_COPY_FILTER_MODAL", () => $4e42ce4b41a05efa$export$ffe8b20c0eaae005);
$parcel$export(module.exports, "openCopyFilterModal", () => $4e42ce4b41a05efa$export$444d12d73e6452c6);
$parcel$export(module.exports, "CLOSE_COPY_FILTER_MODAL", () => $4e42ce4b41a05efa$export$4ef64fde5562fa6a);
$parcel$export(module.exports, "closeCopyFilterModal", () => $4e42ce4b41a05efa$export$fa2b70863b7e4314);
const $4e42ce4b41a05efa$export$ffe8b20c0eaae005 = 'state.actions.copy-filter-modal.OPEN_COPY_FILTER_MODAL';
const $4e42ce4b41a05efa$export$444d12d73e6452c6 = ()=>({
        type: $4e42ce4b41a05efa$export$ffe8b20c0eaae005
    });
const $4e42ce4b41a05efa$export$4ef64fde5562fa6a = 'state.actions.copy-filter-modal.CLOSE_COPY_FILTER_MODAL';
const $4e42ce4b41a05efa$export$fa2b70863b7e4314 = ()=>({
        type: $4e42ce4b41a05efa$export$4ef64fde5562fa6a
    });

});


parcelRegister("ef3e5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a201ddc2a139894d$export$2e2bcd8739ae039);

var $2UX9B = parcelRequire("2UX9B");
const $a201ddc2a139894d$export$d4c72bab9d6cc13a = {
    page: {},
    order: [],
    total: 0,
    isLoading: true,
    isError: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a201ddc2a139894d$export$2e2bcd8739ae039 = (state = $a201ddc2a139894d$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $2UX9B.RETRIEVE:
            return {
                ...state,
                isLoading: true
            };
        case 0, $2UX9B.RETRIEVED:
            return {
                ...state,
                page: action.payload.page,
                order: action.payload.order,
                total: action.payload.total,
                isLoading: false,
                isError: false
            };
        case 0, $2UX9B.RETRIEVE_FAILED:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 0, $2UX9B.PATCH:
            return {
                ...state,
                page: {
                    ...state.page,
                    [action.payload.id]: {
                        ...state.page[action.payload.id],
                        ...action.payload.patch
                    }
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("7XGTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f870ebda6ac32f8a$export$2e2bcd8739ae039);

var $aRmgJ = parcelRequire("aRmgJ");

var $g81jz = parcelRequire("g81jz");
const $f870ebda6ac32f8a$export$d4c72bab9d6cc13a = (0, $aRmgJ.initialQuery);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f870ebda6ac32f8a$export$2e2bcd8739ae039 = (state = $f870ebda6ac32f8a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $g81jz.SET_QUERY:
            return action.payload;
        case 0, $g81jz.PATCH_QUERY:
            return {
                ...state,
                ...action.payload,
                filter: {
                    ...state.filter,
                    ...action.payload.filter ? action.payload.filter : undefined
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("64LCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae8629e7e825b49$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $eHTfV = parcelRequire("eHTfV");

var $bC2fB = parcelRequire("bC2fB");

var $aRmgJ = parcelRequire("aRmgJ");

var $2UX9B = parcelRequire("2UX9B");

var $g81jz = parcelRequire("g81jz");

var $hXBjD = parcelRequire("hXBjD");

var $b9OA0 = parcelRequire("b9OA0");

var $4biUB = parcelRequire("4biUB");

var $lOB3Y = parcelRequire("lOB3Y");

var $hdUWf = parcelRequire("hdUWf");

var $dCHeQ = parcelRequire("dCHeQ");

var $jTnv2 = parcelRequire("jTnv2");
const $eae8629e7e825b49$var$getHeaderConfigurationMemoized = ()=>(0, $dGvGJ.createSelector)((state)=>(0, $hXBjD.isWithoutHeader)(state) ? {
            FilterView: $dCHeQ.default
        } : {
            headerConfiguration: (0, $jTnv2.getHeaderConfiguration)()
        }, (res)=>res);
const $eae8629e7e825b49$var$mapStateToPropsFactory = ()=>{
    const getHeaderConfigurationInstance = $eae8629e7e825b49$var$getHeaderConfigurationMemoized();
    return (state)=>({
            // data
            entityIds: (0, $b9OA0.getIds)(state),
            totalItems: (0, $b9OA0.getTotal)(state),
            itemsPerPage: (0, $aRmgJ.ITEMS_PER_PAGE),
            isLoading: (0, $b9OA0.isLoading)(state),
            isError: (0, $b9OA0.isError)(state),
            page: (0, $4biUB.getPage)(state),
            sortField: (0, $4biUB.getSortField)(state),
            sortDirection: (0, $4biUB.getSortDirection)(state),
            filter: (0, $4biUB.isFilterApplied)(state) ? (0, $4biUB.getFilter)(state) : undefined,
            // ui
            firstColumnHeadingAlignment: 'center',
            // views
            ...getHeaderConfigurationInstance(state),
            tableConfiguration: (0, $jTnv2.getTableConfiguration)(state),
            tableLabel: (0, $jTnv2.getTableLabel)(),
            resultsAnnouncerMessage: (0, $jTnv2.getResultsAnnouncerMessage)(),
            emptyFilterResultConfiguration: $jTnv2.emptyFilterResultConfiguration,
            operationModals: $jTnv2.operationModals,
            EmptyView: $lOB3Y.default,
            ErrorView: $hdUWf.default
        });
};
const $eae8629e7e825b49$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'patch' implicitly has an 'any' type.
        onPatch: ({ id: id, patch: patch })=>dispatch((0, $2UX9B.patch)({
                id: id,
                patch: patch
            })),
        onReload: (query)=>{
            dispatch((0, $g81jz.patchQuery)(query));
            dispatch((0, $2UX9B.retrieve)());
        }
    });
var $eae8629e7e825b49$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($eae8629e7e825b49$var$mapStateToPropsFactory, $eae8629e7e825b49$var$mapDispatchToProps)((0, $eHTfV.default));

});
parcelRegister("eHTfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $68b9ede2efb547aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2YZCu = parcelRequire("2YZCu");

var $dZw8H = parcelRequire("dZw8H");

var $j1FRT = parcelRequire("j1FRT");

var $6E8KZ = parcelRequire("6E8KZ");

var $2g1f1 = parcelRequire("2g1f1");

var $5wSMM = parcelRequire("5wSMM");

var $iqNVX = parcelRequire("iqNVX");

var $iOBt9 = parcelRequire("iOBt9");

const $68b9ede2efb547aa$var$defaultEntityIds = [];
class $68b9ede2efb547aa$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isOnboardingEnabled: false,
            headerConfiguration: undefined,
            FilterView: undefined,
            TableMaskView: undefined,
            CreateModal: undefined,
            metrics: {
                tableMounted: undefined
            },
            entityIds: $68b9ede2efb547aa$var$defaultEntityIds,
            dataProvider: undefined,
            renderOnboardingSpotlight: ()=>null,
            tableLabel: undefined,
            onboardingSpotlightTargets: [],
            onFirstRender: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        if (props.entityIds !== $68b9ede2efb547aa$var$defaultEntityIds && props.dataProvider) (0, $2YZCu.default).safeErrorWithoutCustomerData('directory.base', 'Please provide only one of props: [entityIds] or [dataProvider], dataProvider will be used');
        this.store = (0, $iqNVX.default)((0, $2g1f1.default));
        this.store.dispatch((0, $5wSMM.setAppProps)(props));
    }
    componentDidUpdate() {
        this.store.dispatch((0, $5wSMM.setAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6E8KZ.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j1FRT.default), {
            onFirstMount: this.props.onFirstRender
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOBt9.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null)));
    }
}

});
parcelRegister("j1FRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1db2b6388142380$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bKLSv = parcelRequire("bKLSv");
class $b1db2b6388142380$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKLSv.default).Provider, {
            value: {
                reportMount: this.onSubtreeMount
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.onSubtreeMount = ()=>{
            if (!this.hasAnyMounted) {
                this.hasAnyMounted = true;
                this.props.onFirstMount();
            }
        }, this.hasAnyMounted = false;
    }
}

});
parcelRegister("bKLSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $78841c2f4061c1bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
var $78841c2f4061c1bf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    reportMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});

});


parcelRegister("6E8KZ", function(module, exports) {

$parcel$export(module.exports, "storeOptions", () => $faa45d572897b119$export$12cf63d9f5bd0793);
$parcel$export(module.exports, "Provider", () => $faa45d572897b119$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $faa45d572897b119$export$64605811ab45167f);

var $5uXOq = parcelRequire("5uXOq");

var $bC2fB = parcelRequire("bC2fB");
const $faa45d572897b119$var$STORE_KEY = 'project-directories.directory.story';
const $faa45d572897b119$export$d03cc44e35038f93 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $faa45d572897b119$export$12cf63d9f5bd0793 = {
    storeKey: $faa45d572897b119$var$STORE_KEY,
    context: $faa45d572897b119$export$d03cc44e35038f93
};
const $faa45d572897b119$export$2881499e37b75b9a = (0, $bC2fB.createProvider)($faa45d572897b119$export$d03cc44e35038f93);
const $faa45d572897b119$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>(0, $bC2fB.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $faa45d572897b119$export$d03cc44e35038f93,
        storeKey: $faa45d572897b119$var$STORE_KEY
    });

});

parcelRegister("2g1f1", function(module, exports) {

$parcel$export(module.exports, "default", () => $98259b1e80972783$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $gcE5m = parcelRequire("gcE5m");

var $eh8lN = parcelRequire("eh8lN");
var $98259b1e80972783$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $gcE5m.default), (0, $eh8lN.default));

});
parcelRegister("gcE5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab58ae642be3a4d$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");
var // flow can't deal with the generics here
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$dab58ae642be3a4d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $26mQL.ENTITY_CREATED)).mergeMap(()=>{
        const state = store.getState();
        const page = (0, $eVVoZ.getPage)(state);
        (0, $eVVoZ.getOnReload)(state)({
            page: page
        });
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("26mQL", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $fd2eed6f29a3dd08$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $fd2eed6f29a3dd08$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_CREATED", () => $fd2eed6f29a3dd08$export$61bc72c2b62d14ed);
$parcel$export(module.exports, "entityCreated", () => $fd2eed6f29a3dd08$export$5e2c0a0dc191dd3e);
$parcel$export(module.exports, "ENTITY_CREATE_FAILED", () => $fd2eed6f29a3dd08$export$ac0dd97afb285388);
$parcel$export(module.exports, "entityCreateFailed", () => $fd2eed6f29a3dd08$export$b71626a5d7099742);
$parcel$export(module.exports, "CANCELLED", () => $fd2eed6f29a3dd08$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $fd2eed6f29a3dd08$export$b108ea1063c657e3);
const $fd2eed6f29a3dd08$export$643daa42aa3148d5 = 'state.actions.create.INITIATE';
const $fd2eed6f29a3dd08$export$b14c4413e822aa8d = ()=>({
        type: $fd2eed6f29a3dd08$export$643daa42aa3148d5
    });
const $fd2eed6f29a3dd08$export$61bc72c2b62d14ed = 'state.actions.create.ENTITY_CREATED';
const $fd2eed6f29a3dd08$export$5e2c0a0dc191dd3e = (payload)=>({
        type: $fd2eed6f29a3dd08$export$61bc72c2b62d14ed,
        payload: payload
    });
const $fd2eed6f29a3dd08$export$ac0dd97afb285388 = 'state.actions.create.ENTITY_CREATE_FAILED';
const $fd2eed6f29a3dd08$export$b71626a5d7099742 = (payload)=>({
        type: $fd2eed6f29a3dd08$export$ac0dd97afb285388,
        payload: payload
    });
const $fd2eed6f29a3dd08$export$6b4658081fcf1aed = 'state.actions.create.CANCELLED';
const $fd2eed6f29a3dd08$export$b108ea1063c657e3 = ()=>({
        type: $fd2eed6f29a3dd08$export$6b4658081fcf1aed
    });

});

parcelRegister("eVVoZ", function(module, exports) {

$parcel$export(module.exports, "getEntityIds", () => $6cea3ab9141d1142$export$1fe43832be7d1fcb);
$parcel$export(module.exports, "getDataProvider", () => $6cea3ab9141d1142$export$add6bf8e4261fead);
$parcel$export(module.exports, "getTotalItems", () => $6cea3ab9141d1142$export$cbc4bdd6c02fac4d);
$parcel$export(module.exports, "getPage", () => $6cea3ab9141d1142$export$c2a6433281518c91);
$parcel$export(module.exports, "getItemsPerPage", () => $6cea3ab9141d1142$export$347447940701b338);
$parcel$export(module.exports, "getSortField", () => $6cea3ab9141d1142$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $6cea3ab9141d1142$export$509e2b9937961873);
$parcel$export(module.exports, "getFilter", () => $6cea3ab9141d1142$export$61ec8404f465cd36);
$parcel$export(module.exports, "getHeaderConfiguration", () => $6cea3ab9141d1142$export$60b0ef02721854ed);
$parcel$export(module.exports, "getFilterView", () => $6cea3ab9141d1142$export$4a62b01f13af161e);
$parcel$export(module.exports, "getTableConfiguration", () => $6cea3ab9141d1142$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $6cea3ab9141d1142$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $6cea3ab9141d1142$export$64df75861e57fb7f);
$parcel$export(module.exports, "getEmptyView", () => $6cea3ab9141d1142$export$6ad7beec028137c);
$parcel$export(module.exports, "getErrorView", () => $6cea3ab9141d1142$export$67942d5525c28c28);
$parcel$export(module.exports, "getEmptyFilterResultConfiguration", () => $6cea3ab9141d1142$export$dae3c68be4c9569d);
$parcel$export(module.exports, "getTableMaskView", () => $6cea3ab9141d1142$export$7a35128187f8245c);
$parcel$export(module.exports, "getCreateModal", () => $6cea3ab9141d1142$export$be5bc82ccf7ca5ca);
$parcel$export(module.exports, "getOperationModal", () => $6cea3ab9141d1142$export$3f5ae3b2bfec9457);
$parcel$export(module.exports, "getOnReload", () => $6cea3ab9141d1142$export$7158eb69f7a0b59);
$parcel$export(module.exports, "getOnPatch", () => $6cea3ab9141d1142$export$944f52419ab8e737);
$parcel$export(module.exports, "isLoading", () => $6cea3ab9141d1142$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $6cea3ab9141d1142$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getTotalPages", () => $6cea3ab9141d1142$export$652b307566494a6);
$parcel$export(module.exports, "getFirstColumnHeadingAlignment", () => $6cea3ab9141d1142$export$22b039be773dbf63);
$parcel$export(module.exports, "getLastColumnHeadingAlignment", () => $6cea3ab9141d1142$export$affaf5a34a669e16);
$parcel$export(module.exports, "isCreateOpen", () => $6cea3ab9141d1142$export$996a71275221ab9e);
$parcel$export(module.exports, "getOperations", () => $6cea3ab9141d1142$export$acc17f62bededcaf);
$parcel$export(module.exports, "getOperationInitializationStatusPerEntity", () => $6cea3ab9141d1142$export$69a0d9b5be75b55d);
$parcel$export(module.exports, "getIsOnboardingEnabled", () => $6cea3ab9141d1142$export$65890ce3309e3ccf);
$parcel$export(module.exports, "getRenderOnboardingSpotlight", () => $6cea3ab9141d1142$export$98db60f26810390);
$parcel$export(module.exports, "getSpotlightForCell", () => $6cea3ab9141d1142$export$1faee8e10b588885);
$parcel$export(module.exports, "getAvailableSpotlightTargets", () => $6cea3ab9141d1142$export$7eda79d5ce9a0b8b);

var $dGvGJ = parcelRequire("dGvGJ");

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $k15gu = parcelRequire("k15gu");
const $6cea3ab9141d1142$export$876089ea65adc54 = (state)=>state.app.props;
const $6cea3ab9141d1142$export$1fe43832be7d1fcb = (state)=>state.app.props.entityIds;
const $6cea3ab9141d1142$export$add6bf8e4261fead = (state)=>state.app.props.dataProvider || undefined;
const $6cea3ab9141d1142$export$cbc4bdd6c02fac4d = (state)=>state.app.props.totalItems;
const $6cea3ab9141d1142$export$c2a6433281518c91 = (state)=>state.app.props.page;
const $6cea3ab9141d1142$export$347447940701b338 = (state)=>state.app.props.itemsPerPage;
const $6cea3ab9141d1142$export$9b753af5a9fb5911 = (state)=>state.app.props.sortField;
const $6cea3ab9141d1142$export$509e2b9937961873 = (state)=>state.app.props.sortDirection;
const $6cea3ab9141d1142$export$61ec8404f465cd36 = (state)=>state.app.props.filter;
const $6cea3ab9141d1142$export$60b0ef02721854ed = (state)=>state.app.props.headerConfiguration;
const $6cea3ab9141d1142$export$4a62b01f13af161e = (state)=>state.app.props.FilterView;
const $6cea3ab9141d1142$export$6847365bea1c5392 = (state)=>state.app.props.tableConfiguration;
const $6cea3ab9141d1142$export$b2d196af18e06ad6 = (state)=>state.app.props.tableLabel;
const $6cea3ab9141d1142$export$64df75861e57fb7f = (state)=>state.app.props.resultsAnnouncerMessage;
const $6cea3ab9141d1142$export$6ad7beec028137c = (state)=>state.app.props.EmptyView;
const $6cea3ab9141d1142$export$67942d5525c28c28 = (state)=>state.app.props.ErrorView;
const $6cea3ab9141d1142$export$dae3c68be4c9569d = (state)=>state.app.props.emptyFilterResultConfiguration;
const $6cea3ab9141d1142$export$7a35128187f8245c = (state)=>state.app.props.TableMaskView;
const $6cea3ab9141d1142$export$be5bc82ccf7ca5ca = (state)=>state.app.props.CreateModal;
const $6cea3ab9141d1142$export$3f5ae3b2bfec9457 = (state, operation)=>state.app.props.operationModals[operation];
const $6cea3ab9141d1142$export$7158eb69f7a0b59 = (state)=>state.app.props.onReload;
const $6cea3ab9141d1142$export$944f52419ab8e737 = (state)=>state.app.props.onPatch;
const $6cea3ab9141d1142$export$20bb0d907fbbe433 = (state)=>state.app.props.isLoading;
const $6cea3ab9141d1142$export$e6127cc7fe7395c3 = (state)=>state.app.props.isError;
const $6cea3ab9141d1142$var$getTotalPagesInternal = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6cea3ab9141d1142$export$cbc4bdd6c02fac4d, $6cea3ab9141d1142$export$347447940701b338, (totalItems, itemsOnPage)=>(0, $k15gu.calculateTotalPages)(totalItems, itemsOnPage));
const $6cea3ab9141d1142$export$652b307566494a6 = (state)=>$6cea3ab9141d1142$var$getTotalPagesInternal(state);
const $6cea3ab9141d1142$export$22b039be773dbf63 = (state)=>state.app.props.firstColumnHeadingAlignment;
const $6cea3ab9141d1142$export$affaf5a34a669e16 = (state)=>state.app.props.lastColumnHeadingAlignment;
const $6cea3ab9141d1142$export$996a71275221ab9e = (state)=>state.create.isOpen;
const $6cea3ab9141d1142$export$acc17f62bededcaf = (state)=>state.operations;
const $6cea3ab9141d1142$var$getOperationInitializationStatusPerEntityInternal = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.operations, (operations)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))((0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(operations, ({ id: id })=>id), ({ isInitializing: isInitializing })=>isInitializing));
const $6cea3ab9141d1142$export$69a0d9b5be75b55d = (state)=>$6cea3ab9141d1142$var$getOperationInitializationStatusPerEntityInternal(state);
const $6cea3ab9141d1142$export$65890ce3309e3ccf = (state)=>state.app.props.isOnboardingEnabled;
const $6cea3ab9141d1142$export$ee9bc95b4b33fe7b = (state)=>state.app.props.onboardingSpotlightTargets;
const $6cea3ab9141d1142$export$98db60f26810390 = (state)=>state.app.props.renderOnboardingSpotlight;
const $6cea3ab9141d1142$export$1faee8e10b588885 = (state)=>(id, colIndex)=>$6cea3ab9141d1142$export$ee9bc95b4b33fe7b(state).find((c)=>c.entityId === id && c.colIndex === colIndex);
const $6cea3ab9141d1142$export$7eda79d5ce9a0b8b = (state)=>// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string[]'.
    (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
    $6cea3ab9141d1142$export$6847365bea1c5392, $6cea3ab9141d1142$export$add6bf8e4261fead, $6cea3ab9141d1142$export$1fe43832be7d1fcb, $6cea3ab9141d1142$export$1faee8e10b588885, (tableConfig, dataProvider, entitiesIds, getSpotlightCellTarget)=>{
        const availableSpotlightTargets = [];
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entitiesIds;
        if (ids && tableConfig) ids.forEach((entityId)=>{
            for(let i = 0; i < tableConfig.length; i += 1){
                const cellMatch = getSpotlightCellTarget(entityId, i);
                if (cellMatch && cellMatch.spotlightId) availableSpotlightTargets.push(entityId);
            }
        });
        return availableSpotlightTargets;
    })(state);

});


parcelRegister("eh8lN", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ecadf93c93225f$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $k15gu = parcelRequire("k15gu");


var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$37ecadf93c93225f$export$2e2bcd8739ae039 = (action$, store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$.ofType((0, $lxmKy.ENTITY_UPDATED)).mergeMap((action)=>{
        const { id: id, operation: operation, patch: patch } = action.payload;
        const state = store.getState();
        const currentPage = (0, $eVVoZ.getPage)(state);
        if (patch) {
            (0, $eVVoZ.getOnPatch)(state)({
                id: id,
                patch: patch
            }); // change page's state with a patch instead of reloading a table's page
            return (0, $kVLXA.Observable).empty();
        }
        if (operation === (0, $088bf273559ead46$export$4bd2facc4a3e6aa1)) {
            const itemsPerPage = (0, $eVVoZ.getItemsPerPage)(state);
            const totalItems = (0, $eVVoZ.getTotalItems)(state);
            const predictedPage = (0, $k15gu.predictPageToRequestAfterItemDeletion)(itemsPerPage, totalItems, currentPage);
            (0, $eVVoZ.getOnReload)(state)({
                page: predictedPage
            });
        } else (0, $eVVoZ.getOnReload)(state)({
            page: currentPage
        });
        return (0, $kVLXA.Observable).empty();
    });

});
const $088bf273559ead46$export$250171a898bf7ef = 'EDIT';
const $088bf273559ead46$export$4bd2facc4a3e6aa1 = 'DELETE';
const $088bf273559ead46$export$257be95a51c84145 = 'DUPLICATE';
const $088bf273559ead46$export$a7c1ec142e70d69d = 'ARCHIVE';
const $088bf273559ead46$export$92f9e1ed9114d3a6 = 'COPY';
const $088bf273559ead46$export$346f08c1f0d0fe41 = 'MOVE';
const $088bf273559ead46$export$bbf2495ca7d54c9f = 'SHOW_DETAILS';
const $088bf273559ead46$export$39d2a7fb21967424 = 'CHANGE_OWNER';
const $088bf273559ead46$export$2b848a0670941e75 = 'TRASH';
const $088bf273559ead46$export$aeed50488a8a79d7 = 'RESTORE';

parcelRegister("lxmKy", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $7c27857a14ac40bb$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $7c27857a14ac40bb$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_DATA_RETRIEVE_FAILED", () => $7c27857a14ac40bb$export$d5657bfeb6a06769);
$parcel$export(module.exports, "entityDataRetrieveFailed", () => $7c27857a14ac40bb$export$7771a5f3a1cb2756);
$parcel$export(module.exports, "DIALOG_SHOWN", () => $7c27857a14ac40bb$export$54e32bf20c0b405b);
$parcel$export(module.exports, "dialogShown", () => $7c27857a14ac40bb$export$7aca9ee5930fa3ea);
$parcel$export(module.exports, "ENTITY_UPDATED", () => $7c27857a14ac40bb$export$93e8e914b5b8b20d);
$parcel$export(module.exports, "entityUpdated", () => $7c27857a14ac40bb$export$c0932263cb70e08f);
$parcel$export(module.exports, "ENTITY_UPDATE_FAILED", () => $7c27857a14ac40bb$export$d2d41c22dcb7b1db);
$parcel$export(module.exports, "entityUpdateFailed", () => $7c27857a14ac40bb$export$fbb84be2ae83b4ed);
$parcel$export(module.exports, "CANCELLED", () => $7c27857a14ac40bb$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $7c27857a14ac40bb$export$b108ea1063c657e3);
// initiate
const $7c27857a14ac40bb$export$643daa42aa3148d5 = 'state.actions.operation.INITIATE';
const $7c27857a14ac40bb$export$b14c4413e822aa8d = (payload)=>({
        type: $7c27857a14ac40bb$export$643daa42aa3148d5,
        payload: payload
    });
const $7c27857a14ac40bb$export$d5657bfeb6a06769 = 'state.actions.operation.ENTITY_DATA_RETRIEVE_FAILED';
const $7c27857a14ac40bb$export$7771a5f3a1cb2756 = (payload)=>({
        type: $7c27857a14ac40bb$export$d5657bfeb6a06769,
        payload: payload
    });
const $7c27857a14ac40bb$export$54e32bf20c0b405b = 'state.actions.operation.DIALOG_SHOWN';
const $7c27857a14ac40bb$export$7aca9ee5930fa3ea = (payload)=>({
        type: $7c27857a14ac40bb$export$54e32bf20c0b405b,
        payload: payload
    });
const $7c27857a14ac40bb$export$93e8e914b5b8b20d = 'state.actions.operation.ENTITY_UPDATED';
const $7c27857a14ac40bb$export$c0932263cb70e08f = (payload)=>({
        type: $7c27857a14ac40bb$export$93e8e914b5b8b20d,
        payload: payload
    });
const $7c27857a14ac40bb$export$d2d41c22dcb7b1db = 'state.actions.operation.ENTITY_UPDATE_FAILED';
const $7c27857a14ac40bb$export$fbb84be2ae83b4ed = (payload)=>({
        type: $7c27857a14ac40bb$export$d2d41c22dcb7b1db,
        payload: payload
    });
const $7c27857a14ac40bb$export$6b4658081fcf1aed = 'state.actions.operation.CANCELLED';
const $7c27857a14ac40bb$export$b108ea1063c657e3 = (payload)=>({
        type: $7c27857a14ac40bb$export$6b4658081fcf1aed,
        payload: payload
    });

});



parcelRegister("5wSMM", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $2b3ff44e59fa5c9c$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $2b3ff44e59fa5c9c$export$cfda7627848a58cd);
const $2b3ff44e59fa5c9c$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $2b3ff44e59fa5c9c$export$cfda7627848a58cd = (payload)=>({
        type: $2b3ff44e59fa5c9c$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("iqNVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $908bc238b7ffec6c$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $1EQqh = parcelRequire("1EQqh");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$908bc238b7ffec6c$export$2e2bcd8739ae039 = (rootEpic)=>{
    // @ts-expect-error - TS2322 - Type 'Reducer<unknown>' is not assignable to type 'Reducer<TState>'.
    const fixedTypeRootReducer = (0, $1EQqh.default);
    // @ts-expect-error - TS2344 - Type 'TAction' does not satisfy the constraint '{ type: any; }'.
    return (0, $F2Mxm.default)({
        appName: 'directory-base',
        rootReducer: fixedTypeRootReducer,
        rootEpic: rootEpic
    });
};

});
parcelRegister("1EQqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7f8876305395d63$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $bDEL5 = parcelRequire("bDEL5");

var $grerf = parcelRequire("grerf");

var $9Oh3c = parcelRequire("9Oh3c");
var $b7f8876305395d63$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    app: $bDEL5.default,
    create: $grerf.default,
    operations: $9Oh3c.default
});

});
parcelRegister("bDEL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6089ea8d621e8008$export$2e2bcd8739ae039);

var $5wSMM = parcelRequire("5wSMM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6089ea8d621e8008$export$2e2bcd8739ae039 = (state = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
}, action)=>{
    switch(action.type){
        case 0, $5wSMM.SET_APP_PROPS:
            return {
                ...state,
                props: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("grerf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e84fac704b397d4d$export$2e2bcd8739ae039);

var $26mQL = parcelRequire("26mQL");
const $e84fac704b397d4d$var$initialState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e84fac704b397d4d$export$2e2bcd8739ae039 = (state = $e84fac704b397d4d$var$initialState, action)=>{
    switch(action.type){
        case 0, $26mQL.INITIATE:
            return {
                isOpen: true
            };
        case 0, $26mQL.ENTITY_CREATED:
        case 0, $26mQL.ENTITY_CREATE_FAILED:
        case 0, $26mQL.CANCELLED:
            return {
                isOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("9Oh3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f9982687de3ac1$export$2e2bcd8739ae039);

var $lxmKy = parcelRequire("lxmKy");
const $32f9982687de3ac1$var$reducer = (state = [], action)=>{
    switch(action.type){
        case 0, $lxmKy.INITIATE:
            // adding new operation to array will render new <OperationModal>, showing new dialog/modal in UI
            return [
                ...state,
                {
                    ...action.payload,
                    isInitializing: true
                }
            ];
        case 0, $lxmKy.DIALOG_SHOWN:
            // change isInitializing from true to false
            return [
                ...state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation),
                {
                    ...action.payload,
                    isInitializing: false
                }
            ];
        case 0, $lxmKy.ENTITY_DATA_RETRIEVE_FAILED:
        case 0, $lxmKy.ENTITY_UPDATED:
        case 0, $lxmKy.ENTITY_UPDATE_FAILED:
        case 0, $lxmKy.CANCELLED:
            return state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $32f9982687de3ac1$export$2e2bcd8739ae039 = $32f9982687de3ac1$var$reducer;

});



parcelRegister("iOBt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63bf7e60b7f91719$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $lm3g2 = parcelRequire("lm3g2");

var $gZxo5 = parcelRequire("gZxo5");

var $1Evzn = parcelRequire("1Evzn");
var $63bf7e60b7f91719$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(()=>({
        Content: $lm3g2.default,
        Modals: $gZxo5.default
    }), null, null, (0, $6E8KZ.storeOptions))((0, $1Evzn.default));

});
parcelRegister("lm3g2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf0f9e385dafe4e$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $6dDSs = parcelRequire("6dDSs");

var $l3DlM = parcelRequire("l3DlM");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $gSSqP = parcelRequire("gSSqP");

var $geyiO = parcelRequire("geyiO");

var $fjCWQ = parcelRequire("fjCWQ");

var $1zjdB = parcelRequire("1zjdB");

var $do0bP = parcelRequire("do0bP");

var $gO9Up = parcelRequire("gO9Up");
const $cdf0f9e385dafe4e$var$getEmptyViewSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $l3DlM.withMountReporting)((0, $eVVoZ.getEmptyView)(state)), (res)=>res);
const $cdf0f9e385dafe4e$var$getErrorViewSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $l3DlM.withMountReporting)((0, $eVVoZ.getErrorView)(state)), (res)=>res);
const $cdf0f9e385dafe4e$var$getAvailableSpotlightTargetsSelectorMemoized = ()=>(0, $6dDSs.createSelector)((state)=>(0, $eVVoZ.getAvailableSpotlightTargets)(state), (res)=>res);
const $cdf0f9e385dafe4e$var$mapStateToPropsFactory = ()=>{
    const getEmptyViewSelectorInstance = $cdf0f9e385dafe4e$var$getEmptyViewSelectorMemoized();
    const getErrorViewSelectorInstance = $cdf0f9e385dafe4e$var$getErrorViewSelectorMemoized();
    const getAvailableSpotlightTargetsSelectorInstance = $cdf0f9e385dafe4e$var$getAvailableSpotlightTargetsSelectorMemoized();
    const onRetryFactory = (0, $8QpSo.default)((state)=>()=>(0, $eVVoZ.getOnReload)(state)({}));
    return (state)=>{
        let Header;
        const FilterView = (0, $eVVoZ.getFilterView)(state);
        if (FilterView) Header = (0, $gSSqP.default);
        else {
            const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
            if (headerConfiguration) {
                // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
                if (headerConfiguration.View) Header = (0, $fjCWQ.default);
                else Header = (0, $geyiO.default);
            }
        }
        return {
            Header: Header,
            Table: $do0bP.default,
            Paginator: $1zjdB.default,
            Empty: getEmptyViewSelectorInstance(state),
            Error: getErrorViewSelectorInstance(state),
            status: (0, $hLegl.getStatus)(state),
            onRetry: onRetryFactory(state),
            isOnboardingEnabled: (0, $eVVoZ.getIsOnboardingEnabled)(state),
            renderOnboardingSpotlight: (0, $eVVoZ.getRenderOnboardingSpotlight)(state),
            availableSpotlightTargets: getAvailableSpotlightTargetsSelectorInstance(state)
        };
    };
};
const $cdf0f9e385dafe4e$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var $cdf0f9e385dafe4e$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($cdf0f9e385dafe4e$var$mapStateToPropsFactory, $cdf0f9e385dafe4e$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $gO9Up.default));

});
parcelRegister("l3DlM", function(module, exports) {

$parcel$export(module.exports, "withMountReporting", () => $626145856bfd7724$export$95fa4b7a60ebef6);
$parcel$export(module.exports, "default", () => $626145856bfd7724$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $bKLSv = parcelRequire("bKLSv");
// eslint-disable-next-line jira/react/no-class-components
class $626145856bfd7724$var$Reporter extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            performanceMarkKey: undefined
        };
    }
    componentDidMount() {
        this.props.onMounted();
    }
    render() {
        const { performanceMarkKey: performanceMarkKey } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, performanceMarkKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
            metricKey: performanceMarkKey
        }), this.props.children);
    }
}
function $626145856bfd7724$export$95fa4b7a60ebef6(Wrapped) {
    return (props)=>{
        const { performanceMarkKey: performanceMarkKey, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bKLSv.default).Consumer, null, ({ reportMount: reportMount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($626145856bfd7724$var$Reporter, {
                onMounted: reportMount,
                performanceMarkKey: performanceMarkKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapped, rest)));
    };
}
const $626145856bfd7724$var$MountReporter = $626145856bfd7724$export$95fa4b7a60ebef6(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
var $626145856bfd7724$export$2e2bcd8739ae039 = $626145856bfd7724$var$MountReporter;

});

parcelRegister("hLegl", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $2846182b2726a0e3$export$b70265791d2079d4);

var $eVVoZ = parcelRequire("eVVoZ");
const $2846182b2726a0e3$export$b70265791d2079d4 = (state)=>{
    if ((0, $eVVoZ.isError)(state)) return 'error';
    if ((0, $eVVoZ.isLoading)(state)) return 'has-entities';
    const dataProvider = (0, $eVVoZ.getDataProvider)(state);
    const elementsCount = dataProvider ? dataProvider.getData().length : (0, $eVVoZ.getEntityIds)(state).length;
    return elementsCount === 0 && (0, $eVVoZ.getFilter)(state) === undefined && (0, $eVVoZ.getPage)(state) === 1 ? 'empty' : 'has-entities';
};

});

parcelRegister("gSSqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebd0a798fbf431b0$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $6Wj1D = parcelRequire("6Wj1D");
const $ebd0a798fbf431b0$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>({
            FilterView: (0, $eVVoZ.getFilterView)(state),
            onFilter: onFilterFactory(state),
            hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities'
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type '<T>(props: Props<T>) => false | Element' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$ebd0a798fbf431b0$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($ebd0a798fbf431b0$var$mapStateToPropsFactory, {})((0, $6Wj1D.default));

});
parcelRegister("6Wj1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63d55477b9357$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $5eb63d55477b9357$export$2e2bcd8739ae039(props) {
    const { hasEntities: hasEntities, FilterView: FilterView, onFilter: onFilter } = props;
    return hasEntities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5eb63d55477b9357$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterView, {
        onFilter: onFilter
    })) : null;
}
const $5eb63d55477b9357$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});


parcelRegister("geyiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef20ad5474450900$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $kBSkq = parcelRequire("kBSkq");

var $9WoAf = parcelRequire("9WoAf");

var $gg466 = parcelRequire("gg466");
const $ef20ad5474450900$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (!headerConfiguration || headerConfiguration.View) throw new Error('Invalid state - Default Header view must not be mounted');
    return {
        Filter: $9WoAf.default,
        // @ts-expect-error - TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
        Actions: headerConfiguration.ActionsView || (0, $kBSkq.default),
        hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities',
        // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<TFilter>'.
        caption: headerConfiguration.caption || null
    };
};
var // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<DispatchProp<any> & { Filter: ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }; Actions: any; hasEntities: boolean; caption: any; }>'.
$ef20ad5474450900$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($ef20ad5474450900$var$mapStateToProps, null, null, (0, $6E8KZ.storeOptions))((0, $gg466.default));

});
parcelRegister("kBSkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $665d045383a33008$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $k0n1b = parcelRequire("k0n1b");
const $665d045383a33008$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (headerConfiguration && !headerConfiguration.View && !headerConfiguration.ActionsView) {
        // @ts-expect-error - TS2339 - Property 'isAddAllowed' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'addButtonCaption' does not exist on type 'HeaderConfiguration<TFilter>'.
        const { isAddAllowed: isAddAllowed, addButtonCaption: addButtonCaption } = headerConfiguration;
        return {
            canAdd: isAddAllowed,
            caption: addButtonCaption
        };
    }
    return {};
};
const $665d045383a33008$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var $665d045383a33008$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($665d045383a33008$var$mapStateToProps, $665d045383a33008$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $k0n1b.default));

});
parcelRegister("k0n1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2628b3f0abf572$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");
function $5e2628b3f0abf572$var$Add(props) {
    const { canAdd: canAdd, caption: caption, onAdd: onAdd } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canAdd ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: onAdd
    }, caption && formatMessage(caption)) : null;
}
$5e2628b3f0abf572$var$Add.defaultProps = {
    canAdd: false
};
var $5e2628b3f0abf572$export$2e2bcd8739ae039 = $5e2628b3f0abf572$var$Add;

});


parcelRegister("9WoAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $900e6ddadbcb8d02$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $fwdEW = parcelRequire("fwdEW");
const $900e6ddadbcb8d02$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>(filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.FilterView) throw new Error('Invalid state - Filter wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
            FilterView: headerConfiguration.FilterView,
            onFilter: onFilterFactory(state)
        };
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Filter' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$900e6ddadbcb8d02$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($900e6ddadbcb8d02$var$mapStateToPropsFactory, {})((0, $fwdEW.default));

});
parcelRegister("fwdEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2acfb424a6da5ad8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $2acfb424a6da5ad8$export$2e2bcd8739ae039(props) {
    const { FilterView: FilterView, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterView, {
        onFilter: onFilter
    });
}

});


parcelRegister("gg466", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60de6ef876d0e76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cS37j = parcelRequire("cS37j");

var $az4zD = parcelRequire("az4zD");
function $c60de6ef876d0e76$var$Default(props) {
    const { Filter: Filter, Actions: Actions, caption: caption, hasEntities: hasEntities, intl: { formatMessage: formatMessage } } = props;
    let searchBar = null;
    let actions = null;
    if (hasEntities) {
        searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Filter, null);
        actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Actions, null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        actions: actions,
        bottomBar: searchBar
    }, caption ? formatMessage(caption) : '');
}
var $c60de6ef876d0e76$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($c60de6ef876d0e76$var$Default);

});
parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});



parcelRegister("fjCWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b8144acd42bd1f$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $hLegl = parcelRequire("hLegl");

var $1F2yg = parcelRequire("1F2yg");
const $06b8144acd42bd1f$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $8QpSo.default)((state)=>(filter)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $eVVoZ.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.View) throw new Error('Invalid state - Header wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
            HeaderView: headerConfiguration.View,
            hasEntities: (0, $hLegl.getStatus)(state) === 'has-entities',
            onFilter: onFilterFactory(state)
        };
    };
};
const $06b8144acd42bd1f$var$mapDispatchToProps = {
    onAdd: (0, $26mQL.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Wrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$06b8144acd42bd1f$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($06b8144acd42bd1f$var$mapStateToPropsFactory, $06b8144acd42bd1f$var$mapDispatchToProps)((0, $1F2yg.default));

});
parcelRegister("1F2yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $197bfc3e7904115c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $197bfc3e7904115c$export$2e2bcd8739ae039(props) {
    const { HeaderView: HeaderView, hasEntities: hasEntities, onAdd: onAdd, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderView, {
        hasEntities: hasEntities,
        onAdd: onAdd,
        onFilter: onFilter
    });
}

});


parcelRegister("1zjdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7e92938aa45f06$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $hNlad = parcelRequire("hNlad");
const $6c7e92938aa45f06$var$mapStateToPropsFactory = ()=>{
    const onPageChangeFactory = (0, $8QpSo.default)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'page' implicitly has an 'any' type.
    (state)=>(event, page)=>(0, $eVVoZ.getOnReload)(state)({
                page: page
            }));
    return (state)=>({
            currentPage: (0, $eVVoZ.getPage)(state),
            totalPages: (0, $eVVoZ.getTotalPages)(state),
            onPageChange: onPageChangeFactory(state)
        });
};
var $6c7e92938aa45f06$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($6c7e92938aa45f06$var$mapStateToPropsFactory, {}, null, (0, $6E8KZ.storeOptions))((0, $hNlad.default));

});
parcelRegister("hNlad", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c4a3856827caa5$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iASWI = parcelRequire("iASWI");

var $xBgAj = parcelRequire("xBgAj");

var $kgoHi = parcelRequire("kgoHi");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $4iWLf = parcelRequire("4iWLf");
function $83c4a3856827caa5$var$Paginator(props) {
    const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = props;
    const onPageChange = (data, event, analyticsEvent)=>{
        props.onPageChange(data, event);
        if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'pagination');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
        selectedIndex: currentPage - 1,
        onChange: onPageChange,
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(1, totalPages + 1),
        previousLabel: formatMessage((0, $4iWLf.default).previousButton),
        nextLabel: formatMessage((0, $4iWLf.default).nextButton)
    });
    if (totalPages > 1) return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $83c4a3856827caa5$var$styles.paginationContainer,
        testId: "global-pages.directories.directory-base.content.paginator.container"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83c4a3856827caa5$var$Container, {
        "data-test-id": "global-pages.directories.directory-base.content.paginator.container"
    }, content);
    return null;
}
var $83c4a3856827caa5$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($83c4a3856827caa5$var$Paginator);
const $83c4a3856827caa5$var$styles = {
    paginationContainer: "_n3td1ejb _18u0xmi2"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83c4a3856827caa5$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n3td1ejb _18u0xmi2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        })
    });
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $15F6T.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $8aaadfaafd170b3c$var$styles.paginationMenu,
                    children: (0, $gRWrA.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});


parcelRegister("4iWLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f9b7bf6876a52ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f9b7bf6876a52ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    previousButton: {
        "id": "directory-base.content.paginator.previous-button",
        "defaultMessage": "Previous page"
    },
    nextButton: {
        "id": "directory-base.content.paginator.next-button",
        "defaultMessage": "Next page"
    }
});

});



parcelRegister("do0bP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca8b4269a3eb958$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");

var $d0BRN = parcelRequire("d0BRN");

var $c3kRB = parcelRequire("c3kRB");

var $joT8a = parcelRequire("joT8a");
const $cca8b4269a3eb958$var$getSpotlightForCellSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((state)=>(0, $eVVoZ.getSpotlightForCell)(state), (res)=>res);
const $cca8b4269a3eb958$var$mapStateToPropsFactory = ()=>{
    const getSpotlightForCellSelectorInstance = $cca8b4269a3eb958$var$getSpotlightForCellSelectorMemoized();
    const onSortFactory = (0, $8QpSo.default)(// @ts-expect-error - TS7006 - Parameter 'sort' implicitly has an 'any' type.
    (state)=>(sort)=>(0, $eVVoZ.getOnReload)(state)({
                page: 1,
                ...sort
            }));
    return (state)=>{
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'EmptyFilterResultConfiguration'.
        const EmptyView = (0, $eVVoZ.getEmptyFilterResultConfiguration)(state).View || (0, $c3kRB.default);
        const TableMaskView = (0, $eVVoZ.getTableMaskView)(state);
        const filter = (0, $eVVoZ.getFilter)(state);
        const filterQuery = filter ? filter.query : '';
        return {
            tableConfiguration: (0, $eVVoZ.getTableConfiguration)(state),
            tableLabel: (0, $eVVoZ.getTableLabel)(state),
            resultsAnnouncerMessage: (0, $eVVoZ.getResultsAnnouncerMessage)(state),
            EmptyView: EmptyView,
            TableMaskView: TableMaskView,
            dataProvider: (0, $eVVoZ.getDataProvider)(state),
            entityIds: (0, $eVVoZ.getEntityIds)(state),
            totalItems: (0, $eVVoZ.getTotalItems)(state),
            operationInitializationStatusPerEntity: (0, $eVVoZ.getOperationInitializationStatusPerEntity)(state),
            isLoading: (0, $eVVoZ.isLoading)(state),
            sortField: (0, $eVVoZ.getSortField)(state),
            sortDirection: (0, $eVVoZ.getSortDirection)(state),
            onSort: onSortFactory(state),
            mountMetricKey: (0, $d0BRN.getTableMountedMetricKey)(state),
            getSpotlightForCell: getSpotlightForCellSelectorInstance(state),
            firstColumnHeadingAlignment: (0, $eVVoZ.getFirstColumnHeadingAlignment)(state),
            lastColumnHeadingAlignment: (0, $eVVoZ.getLastColumnHeadingAlignment)(state),
            filterQuery: filterQuery
        };
    };
};
const $cca8b4269a3eb958$var$mapDispatchToProps = {
    onOperationRequested: (0, $lxmKy.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
$cca8b4269a3eb958$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($cca8b4269a3eb958$var$mapStateToPropsFactory, $cca8b4269a3eb958$var$mapDispatchToProps)((0, $joT8a.default));

});
parcelRegister("d0BRN", function(module, exports) {

$parcel$export(module.exports, "getTableMountedMetricKey", () => $fda68c97331475d3$export$b6c1493984bb04f9);
const $fda68c97331475d3$export$b6c1493984bb04f9 = (state)=>state.app.props.metrics.tableMounted;

});

parcelRegister("c3kRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $68cb0124d97ea366$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $dh6ia = parcelRequire("dh6ia");
const $68cb0124d97ea366$var$mapStateToProps = (state)=>{
    const configuration = (0, $eVVoZ.getEmptyFilterResultConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
    if (!configuration.message) throw new Error('Invalid state - Default empty view should not be mounted');
    return {
        // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
        message: configuration.message
    };
};
var $68cb0124d97ea366$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($68cb0124d97ea366$var$mapStateToProps, null, null, (0, $6E8KZ.storeOptions))((0, $dh6ia.default));

});
parcelRegister("dh6ia", function(module, exports) {

$parcel$export(module.exports, "default", () => $d730ce5cb03c7be1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $4R6GH = parcelRequire("4R6GH");

var $8RXs9 = parcelRequire("8RXs9");

var $k0yDo = parcelRequire("k0yDo");

var $dCm1o = parcelRequire("dCm1o");

var $jzUVR = parcelRequire("jzUVR");
function $d730ce5cb03c7be1$var$DefaultEmptyView(props) {
    const { message: message } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "global-pages.directories.directory-base.content.table.default-empty-view.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, (/*@__PURE__*/$parcel$interopDefault($k0yDo))) : (0, (/*@__PURE__*/$parcel$interopDefault($jzUVR))),
        header: formatMessage(message),
        width: "narrow",
        headingLevel: 2
    }));
}
var $d730ce5cb03c7be1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d730ce5cb03c7be1$var$DefaultEmptyView);

});
parcelRegister("k0yDo", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});

parcelRegister("jzUVR", function(module, exports) {
module.exports = new URL("generic-no-results.fb302821.svg", import.meta.url).toString();

});



parcelRegister("joT8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c01d48f0796d7f8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $7Jxgt = parcelRequire("7Jxgt");

var $dHbUn = parcelRequire("dHbUn");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");

var $fraBZ = parcelRequire("fraBZ");


var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $l3DlM = parcelRequire("l3DlM");

var $8Tb2p = parcelRequire("8Tb2p");
class $5c01d48f0796d7f8$var$Table extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isLoading: false,
            entityIds: [],
            totalItems: 0,
            sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
            mountMetricKey: undefined,
            getSpotlightForCell: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            TableMaskView: undefined,
            firstColumnHeadingAlignment: 'left',
            lastColumnHeadingAlignment: 'left',
            filterQuery: '',
            tableLabel: undefined,
            resultsAnnouncerMessage: (0, $8Tb2p.default).filterResultsAnnouncement,
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onOperationRequested: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sortDirection !== this.props.sortDirection || prevProps.sortField !== this.props.sortField) this.state.hasSortingChanged = true;
        if (!prevProps.isLoading && this.props.isLoading) this.state.shouldAnnounceResults = !this.state.hasSortingChanged;
        else if (prevProps.isLoading && !this.props.isLoading) this.state.hasSortingChanged = false;
    }
    render() {
        const { tableConfiguration: tableConfiguration, entityIds: entityIds, totalItems: totalItems, EmptyView: EmptyView, isLoading: isLoading, operationInitializationStatusPerEntity: operationInitializationStatusPerEntity, sortField: sortField, sortDirection: sortDirection, mountMetricKey: mountMetricKey, getSpotlightForCell: getSpotlightForCell, TableMaskView: TableMaskView, dataProvider: dataProvider, firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, intl: { formatMessage: formatMessage }, tableLabel: tableLabel, resultsAnnouncerMessage: resultsAnnouncerMessage } = this.props;
        const headCells = tableConfiguration.map(({ title: title, width: width, sortField: cellSortField, dataTestId: dataTestId, isIconOnlyHeader: isIconOnlyHeader, ascendingSortTooltip: ascendingSortTooltip, descendingSortTooltip: descendingSortTooltip })=>{
            let content = '';
            const wrapperProps = dataTestId ? {
                'data-test-id': dataTestId
            } : {};
            if (dataTestId) // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$NonBreakingCell, wrapperProps);
            if (typeof title === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const HeaderCell = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (()=>{
                    if (!(0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$HeaderWrapper, wrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderCell, null));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        xcss: $5c01d48f0796d7f8$var$styles.headerWrapper,
                        testId: dataTestId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderCell, null));
                })();
            } else if (typeof title !== 'undefined') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const message = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    testId: dataTestId,
                    color: "color.text.subtle",
                    maxLines: 1,
                    weight: "bold",
                    size: "small"
                }, formatMessage(message))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$NonBreakingCell, wrapperProps, formatMessage(message));
            }
            return {
                key: cellSortField || (0, $7Jxgt.v1)(),
                isSortable: !!cellSortField,
                content: content,
                width: width,
                isIconOnlyHeader: (0, $dCm1o.isVisualRefreshEnabled)() ? !!isIconOnlyHeader : undefined,
                ascendingSortTooltip: ascendingSortTooltip && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? formatMessage(ascendingSortTooltip) : undefined,
                descendingSortTooltip: descendingSortTooltip && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? formatMessage(descendingSortTooltip) : undefined
            };
        });
        const head = {
            cells: headCells
        };
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entityIds;
        const tableAriaLabel = tableLabel ? formatMessage(tableLabel) : undefined;
        const rowCells = ids.map((entityId, rowIndex)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = sortDirection === 'DESC' ? -(rowIndex + 1) : rowIndex + 1;
            const entity = dataProvider ? dataProvider.getData()[rowIndex] : undefined;
            const cells = tableConfiguration.map(({ Cell: Cell }, colIndex)=>{
                const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Cell, {
                    id: entityId,
                    entity: entity,
                    isOperationInProgress: !!operationInitializationStatusPerEntity[entityId],
                    onOperationRequested: (operation, operationParams)=>this.props.onOperationRequested({
                            id: entityId,
                            childEntityId: operationParams && operationParams.childEntityId,
                            operation: operation
                        })
                });
                const getVisuallyRefreshedContent = (visuallyRefreshedContent)=>{
                    return visuallyRefreshedContent;
                };
                const cellMatch = getSpotlightForCell(entityId, colIndex);
                if (cellMatch && cellMatch.spotlightId) {
                    const onboardingContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                        name: cellMatch.spotlightId
                    }, getVisuallyRefreshedContent(content));
                    return {
                        content: onboardingContent,
                        key: key
                    };
                }
                return {
                    content: getVisuallyRefreshedContent(content),
                    key: key
                };
            });
            return {
                cells: cells
            };
        });
        return(// Note: the data-test-id attribute is used by Pollinator checks in Jalapeno so avoid changing if possible
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$Container, {
            "data-test-id": "global-pages.directories.directory-base.content.table.container",
            firstColumnHeadingAlignment: firstColumnHeadingAlignment,
            lastColumnHeadingAlignment: lastColumnHeadingAlignment,
            visualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)(),
            visuallyRefreshedHeight: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6')
        }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l3DlM.default), {
            performanceMarkKey: mountMetricKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
            message: formatMessage(resultsAnnouncerMessage || (0, $8Tb2p.default).filterResultsAnnouncement, {
                itemCount: totalItems
            }),
            shouldAnnounce: !isLoading && this.state.shouldAnnounceResults
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHbUn.default), {
            isFixedSize: true,
            isLoading: isLoading,
            head: head,
            rows: rowCells,
            onSort: this.onSort,
            sortKey: sortField,
            sortOrder: sortDirection,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EmptyView, null),
            label: tableAriaLabel
        }), TableMaskView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TableMaskView, null)));
    }
    constructor(...args){
        super(...args), this.state = {
            hasSortingChanged: false,
            shouldAnnounceResults: false
        }, /**
   * We very much wish that `attrs` is an object of this type {| key: string, sortOrder: string |}
   * but unfortunately @atlaskit/dynamic-table types do not give any guarantee of that
   * so we should be handling mixed here.
   */ this.onSort = (attrs, analyticsEvent)=>{
            // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'unknown'. | TS2339 - Property 'sortOrder' does not exist on type 'unknown'.
            const { key: key, sortOrder: sortOrder } = attrs;
            const { onSort: onSort } = this.props;
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'tableHeader', {
                key: key
            });
            onSort({
                sortField: key,
                sortDirection: sortOrder
            });
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof Table' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props<unknown, string, unknown, unknown>>> & typeof Table'.
$5c01d48f0796d7f8$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($5c01d48f0796d7f8$var$Table);
const $5c01d48f0796d7f8$var$TABLE_ROW_HEIGHT = '40px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$NonBreakingCell = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { firstColumnHeadingAlignment: firstColumnHeadingAlignment, visuallyRefreshedHeight: visuallyRefreshedHeight, visualRefreshEnabled: visualRefreshEnabled, lastColumnHeadingAlignment: lastColumnHeadingAlignment, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bgnkvw": (0, $lD23V.default)(__cmplp.firstColumnHeadingAlignment),
            "--_xer3jx": (0, $lD23V.default)(__cmplp.visuallyRefreshedHeight ? '16px' : '14px'),
            "--_w6gjp2": (0, $lD23V.default)(__cmplp.visualRefreshEnabled ? '16px' : '14px'),
            "--_jlq5ur": (0, $lD23V.default)(__cmplp.lastColumnHeadingAlignment)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _2ws7jp4b _p4liidpf _6autidpf _7dd61ux8 _13jcr73l _496i159m _9yen1pfg _10wbnkob _jwot4jg8",
            __cmplp.visualRefreshEnabled && "_19ibi2wt _y4wot94y _oaa6nqa1 _10okmuej _cnoh1vhk _1m2zqbzx _1cuj1ylp _qassi2wt _1g00i2wt",
            __cmplp.className
        ])
    });
});
const $5c01d48f0796d7f8$var$styles = {
    headerWrapper: "_19bvu2gc _u5f31b66 _ca0q1b66 _n3td1b66",
    headerWrapperOld: "_18zr1b66 _1rjcu2gc _4cvr1h6o _1bah1h6o _1bsbzwfg"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$EmptyLoadingView = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c01d48f0796d7f8$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dk72m.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hiWL0.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jlnvO.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $50Tma.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dDBI6.default), {
                isLoading: isLoading,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hcItm")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = null;
const $3b29b0d00cd7b5c6$var$tableStyles = null;
const $3b29b0d00cd7b5c6$var$bodyBorder = null;
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $3b29b0d00cd7b5c6$var$captionStyles = null;
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("caption", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = null;
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0852c529eaab7231$var$fixedHeightStyles = null;
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $bwpsq.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $0852c529eaab7231$var$emptyViewContainerStyles = null;
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggqAE.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $1g0dL.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$var$fixedSizeTruncateStyles = null;
const $11c3ea74eda01ab8$var$overflowTruncateStyles = null;
const $11c3ea74eda01ab8$var$truncationWidthStyles = null;
const $11c3ea74eda01ab8$var$cellStyles = null;
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ba9cb59faf06ce7f$var$rowStyles = null;
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = null;
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = null;
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lLAKY.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = null;
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$contentsContainerStyles = null;
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $bwpsq.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$spinnerContainerStyles = null;
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48301faf1109874f$var$containerStyles = null;
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $48301faf1109874f$var$spinnerBackdropStyles = null;
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $48301faf1109874f$var$spinnerContainerStyles = null;
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});

parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");



var $9GQPi = parcelRequire("9GQPi");
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = null;
const $e002e0403dc403bb$var$headStyles = null;
const $e002e0403dc403bb$var$overflowTruncateStyles = null;
const $e002e0403dc403bb$var$truncationWidthStyles = null;
const $e002e0403dc403bb$var$fixedSizeTruncateStyles = null;
const $e002e0403dc403bb$var$cellStyles = null;
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $bwpsq.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = null;
const $e002e0403dc403bb$var$headCellBaseStylesOld = null;
const $e002e0403dc403bb$var$onClickStyles = null;
const $e002e0403dc403bb$var$baseStyles = null;
const $e002e0403dc403bb$var$ascendingStyles = null;
const $e002e0403dc403bb$var$descendingStyles = null;
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $bwpsq.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Lty3.default), {
                onClick: onClick,
                xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            size: "small",
                            color: "color.text.subtle",
                            weight: "bold",
                            maxLines: 1,
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});



parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("hcItm", function(module, exports) {

let $c8660dfa442bff40$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c8660dfa442bff40$var$load("76n7a"),
    $c8660dfa442bff40$var$load("l253H"),
    $c8660dfa442bff40$var$load("etJKP")
]).then(()=>parcelRequire('4THp8'));

});


parcelRegister("8Tb2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ccc3b7593e6b203$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3ccc3b7593e6b203$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterResultAnnounce: {
        "id": "directory-base.content.table.filter-result-announce",
        "defaultMessage": "{itemCount, plural, one {One item was found after filtering.} other {{itemCount} items were found after filtering.}}"
    },
    filterResultsAnnouncement: {
        "id": "directory-base.content.table.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No results were found that match your search} one {{itemCount} result found} other {{itemCount} results found}}"
    }
});

});



parcelRegister("gO9Up", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c83f1ab25cac0ee$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $imZsD = parcelRequire("imZsD");

var $3HwlS = parcelRequire("3HwlS");
const $8c83f1ab25cac0ee$var$styles = {
    pageContainerNav3: "_7opz1wug",
    pageContainerNav3inner: "_1ul94na8"
};
function $8c83f1ab25cac0ee$export$2e2bcd8739ae039(props) {
    const { Header: Header, Table: Table, Paginator: Paginator, Empty: Empty, Error: Error, status: status, onAdd: onAdd, onRetry: onRetry, isOnboardingEnabled: isOnboardingEnabled, renderOnboardingSpotlight: renderOnboardingSpotlight, availableSpotlightTargets: availableSpotlightTargets } = props;
    let main = null;
    let spotlight = null;
    let expectOverflow = false;
    switch(status){
        case 'has-entities':
            expectOverflow = true;
            main = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Table, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Paginator, null));
            spotlight = isOnboardingEnabled && renderOnboardingSpotlight && renderOnboardingSpotlight(availableSpotlightTargets);
            break;
        case 'empty':
            main = Empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Empty, {
                onAdd: onAdd
            }) : null;
            break;
        case 'error':
            main = Error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Error, {
                onRetry: onRetry
            }) : null;
            break;
        default:
            break;
    }
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main));
    if (expectOverflow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3inner
        ])
    }, main)));
    return expectOverflow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8c83f1ab25cac0ee$var$styles.pageContainerNav3inner
        ])
    }, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main));
}
$8c83f1ab25cac0ee$export$2e2bcd8739ae039.defaultProps = {
    isOnboardingEnabled: false,
    renderOnboardingSpotlight: ()=>null,
    availableSpotlightTargets: [],
    onAdd: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};

});


parcelRegister("gZxo5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9e30bbc17bbf06$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $6E8KZ = parcelRequire("6E8KZ");

var $eVVoZ = parcelRequire("eVVoZ");

var $7vDsW = parcelRequire("7vDsW");

var $dXqrk = parcelRequire("dXqrk");

var $jd28H = parcelRequire("jd28H");
const $ad9e30bbc17bbf06$var$mapStateToProps = (state)=>({
        isCreateModalShown: (0, $eVVoZ.isCreateOpen)(state),
        CreateModal: $7vDsW.default,
        operations: (0, $eVVoZ.getOperations)(state),
        OperationModal: $dXqrk.default
    });
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Modals' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$ad9e30bbc17bbf06$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($ad9e30bbc17bbf06$var$mapStateToProps, {})((0, $jd28H.default));

});
parcelRegister("7vDsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d32de1c8b6343c$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $6E8KZ = parcelRequire("6E8KZ");

var $26mQL = parcelRequire("26mQL");

var $eVVoZ = parcelRequire("eVVoZ");

var $k3e3M = parcelRequire("k3e3M");
const $f7d32de1c8b6343c$var$mapStateToProps = (state)=>{
    const CreateModal = (0, $eVVoZ.getCreateModal)(state);
    if (!CreateModal) throw new Error('Invalid state - no Create Modal provided');
    return {
        CreateModal: CreateModal
    };
};
const $f7d32de1c8b6343c$var$mapDispatchToProps = {
    onCreated: (0, $26mQL.entityCreated),
    onCreateFailed: (0, $26mQL.entityCreateFailed),
    onCancel: (0, $26mQL.cancelled)
};
var $f7d32de1c8b6343c$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f7d32de1c8b6343c$var$mapStateToProps, $f7d32de1c8b6343c$var$mapDispatchToProps, null, (0, $6E8KZ.storeOptions))((0, $k3e3M.default));

});
parcelRegister("k3e3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4842467b44d7e63d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $4842467b44d7e63d$export$2e2bcd8739ae039(props) {
    const { CreateModal: CreateModal, onCreated: onCreated, onCreateFailed: onCreateFailed, onCancel: onCancel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateModal, {
        onCreated: onCreated,
        onCreateFailed: onCreateFailed,
        onCancel: onCancel
    });
}

});


parcelRegister("dXqrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dde6756d9548826$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $6E8KZ = parcelRequire("6E8KZ");

var $lxmKy = parcelRequire("lxmKy");

var $eVVoZ = parcelRequire("eVVoZ");

var $1jyVQ = parcelRequire("1jyVQ");
const $5dde6756d9548826$var$mapStateToPropsFactory = ()=>{
    const onDataRetrievedFactory = (0, $8QpSo.default)((state, id)=>// @ts-expect-error - TS7031 - Binding element 'patch' implicitly has an 'any' type.
        ({ patch: patch })=>(0, $eVVoZ.getOnPatch)(state)({
                id: id,
                patch: patch
            }));
    return (state, ownProps)=>{
        const { id: id, operation: operation } = ownProps;
        return {
            OperationModal: (0, $eVVoZ.getOperationModal)(state, operation),
            onDataRetrieved: onDataRetrievedFactory(state, id)
        };
    };
};
const $5dde6756d9548826$var$mapDispatchToProps = (dispatch, ownProps)=>{
    const { id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing } = ownProps;
    return {
        entityId: id,
        isInitializing: isInitializing,
        onDialogShown: ()=>dispatch((0, $lxmKy.dialogShown)({
                id: id,
                operation: operation,
                childEntityId: childEntityId
            })),
        onDataRetrieveFailed: ()=>dispatch((0, $lxmKy.entityDataRetrieveFailed)({
                id: id,
                operation: operation
            })),
        // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
        onUpdated: ({ patch: patch } = {})=>dispatch((0, $lxmKy.entityUpdated)({
                id: id,
                operation: operation,
                patch: patch
            })),
        onUpdateFailed: ()=>dispatch((0, $lxmKy.entityUpdateFailed)({
                id: id,
                operation: operation
            })),
        onCancel: ()=>dispatch((0, $lxmKy.cancelled)({
                id: id,
                operation: operation
            }))
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Operation' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$5dde6756d9548826$export$2e2bcd8739ae039 = (0, $6E8KZ.connect)($5dde6756d9548826$var$mapStateToPropsFactory, $5dde6756d9548826$var$mapDispatchToProps)((0, $1jyVQ.default));

});
parcelRegister("1jyVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd144476f98eada3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $bd144476f98eada3$export$2e2bcd8739ae039(props) {
    const { OperationModal: OperationModal, ...modalProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OperationModal, modalProps);
}

});


parcelRegister("jd28H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5c2b4eef0dc70b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a5c2b4eef0dc70b8$export$2e2bcd8739ae039(props) {
    const { isCreateModalShown: isCreateModalShown, CreateModal: CreateModal, operations: operations, OperationModal: OperationModal } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, isCreateModalShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CreateModal, null), operations.map(({ id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OperationModal, {
            key: id,
            id: id,
            operation: operation,
            childEntityId: childEntityId,
            isInitializing: isInitializing
        })));
}

});


parcelRegister("1Evzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f4de78934b94b3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $17f4de78934b94b3$export$2e2bcd8739ae039(props) {
    const { Content: Content, Modals: Modals } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Modals, null));
}

});



parcelRegister("b9OA0", function(module, exports) {

$parcel$export(module.exports, "getIds", () => $644d9d1cda833da7$export$24b60fe7179439bc);
$parcel$export(module.exports, "getTotal", () => $644d9d1cda833da7$export$94860ac4a286a8d9);
$parcel$export(module.exports, "isLoading", () => $644d9d1cda833da7$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $644d9d1cda833da7$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getName", () => $644d9d1cda833da7$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getDescription", () => $644d9d1cda833da7$export$67580b1c13935958);
$parcel$export(module.exports, "getOwner", () => $644d9d1cda833da7$export$5f4ed0d56c2c0edf);
$parcel$export(module.exports, "getViewUrl", () => $644d9d1cda833da7$export$bdccd6a672e4a607);
$parcel$export(module.exports, "getShares", () => $644d9d1cda833da7$export$3b3cfad4475f6525);
$parcel$export(module.exports, "getEdits", () => $644d9d1cda833da7$export$ade2933f0cc600b);
$parcel$export(module.exports, "getFilter", () => $644d9d1cda833da7$export$61ec8404f465cd36);
$parcel$export(module.exports, "getIsWritable", () => $644d9d1cda833da7$export$8e04de5241998cf7);
$parcel$export(module.exports, "manageSubscriptionsUrl", () => $644d9d1cda833da7$export$e68f39a61961e36b);
$parcel$export(module.exports, "getChangeFavorite", () => $644d9d1cda833da7$export$85b24bd43a2bd6cf);
$parcel$export(module.exports, "isFavorite", () => $644d9d1cda833da7$export$70b3463aa7e3e514);
$parcel$export(module.exports, "isPending", () => $644d9d1cda833da7$export$872dec21e9a69476);
$parcel$export(module.exports, "getPopularity", () => $644d9d1cda833da7$export$34145270e160ba15);

var $ebyGx = parcelRequire("ebyGx");

var $hXBjD = parcelRequire("hXBjD");
const $644d9d1cda833da7$export$dd1bc94b04021eeb = (state)=>state.filters.order.length === 0;
const $644d9d1cda833da7$export$24b60fe7179439bc = (state)=>state.filters.order;
const $644d9d1cda833da7$export$94860ac4a286a8d9 = (state)=>state.filters.total;
const $644d9d1cda833da7$export$20bb0d907fbbe433 = (state)=>state.filters.isLoading;
const $644d9d1cda833da7$export$e6127cc7fe7395c3 = (state)=>state.filters.isError;
const $644d9d1cda833da7$export$7d9f7e9c1c02b41e = (state, id)=>state.filters.page[id]?.name;
const $644d9d1cda833da7$export$67580b1c13935958 = (state, id)=>state.filters.page[id]?.description;
const $644d9d1cda833da7$export$5f4ed0d56c2c0edf = (state, id)=>state.filters.page[id]?.owner;
const $644d9d1cda833da7$export$bdccd6a672e4a607 = (state, id)=>state.filters.page[id]?.viewUrl;
const $644d9d1cda833da7$export$3b3cfad4475f6525 = (state, id)=>state.filters.page[id]?.shares;
const $644d9d1cda833da7$export$ade2933f0cc600b = (state, id)=>state.filters.page[id]?.edits;
const $644d9d1cda833da7$export$61ec8404f465cd36 = (state, id)=>state.filters.page[id];
const $644d9d1cda833da7$export$8e04de5241998cf7 = (state, id)=>state.filters.page[id]?.isWritable || false;
const $644d9d1cda833da7$export$9b4c238bf352f0c9 = (actionType)=>(state, filterId)=>{
        const xsrfToken = (0, $hXBjD.getXsrfToken)(state);
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            atl_token: xsrfToken,
            returnUrl: 'ManageFilters.jspa',
            filterId: filterId
        });
        return `/${actionType}!default.jspa?${parsed}`;
    };
const $644d9d1cda833da7$export$e68f39a61961e36b = $644d9d1cda833da7$export$9b4c238bf352f0c9('ViewSubscriptions');
const $644d9d1cda833da7$var$getFavoriteChangeContext = (state)=>state.app.props.favoriteChangeContext;
const $644d9d1cda833da7$export$85b24bd43a2bd6cf = (state)=>{
    // TODO EM-312: remove `| void` checks (e.g. `context &&`) from this and other directory pages when old provider is removed
    const context = $644d9d1cda833da7$var$getFavoriteChangeContext(state);
    return context && context.changeFavorite;
};
const $644d9d1cda833da7$var$getChangedFilter = (state, id)=>{
    const context = $644d9d1cda833da7$var$getFavoriteChangeContext(state);
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    return context && context.items.filters[id];
};
const $644d9d1cda833da7$var$getIsFavoriteFromState = (state, id)=>state.page[id]?.isFavourite;
const $644d9d1cda833da7$var$getPopularityFromState = (state, id)=>state.page[id]?.popularity;
const $644d9d1cda833da7$export$70b3463aa7e3e514 = (state, id)=>{
    const itemChanged = $644d9d1cda833da7$var$getChangedFilter(state, id);
    return itemChanged ? itemChanged.value : $644d9d1cda833da7$var$getIsFavoriteFromState(state.filters, id);
};
const $644d9d1cda833da7$export$872dec21e9a69476 = (state, id)=>{
    const item = $644d9d1cda833da7$var$getChangedFilter(state, id);
    return !!(item && item.pending);
};
const $644d9d1cda833da7$export$34145270e160ba15 = (state, id)=>{
    const popularityInState = $644d9d1cda833da7$var$getPopularityFromState(state.filters, id);
    const isFavoriteInState = $644d9d1cda833da7$var$getIsFavoriteFromState(state.filters, id);
    const item = $644d9d1cda833da7$var$getChangedFilter(state, id);
    if (!item) return popularityInState;
    if (item.value && !isFavoriteInState && popularityInState) return popularityInState + 1;
    if (!item.value && isFavoriteInState && popularityInState) return popularityInState - 1;
    return popularityInState;
};

});

parcelRegister("lOB3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a07c47635c495b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $ousew = parcelRequire("ousew");

var $az4zD = parcelRequire("az4zD");

var $kB4mh = parcelRequire("kB4mh");

var $jELjD = parcelRequire("jELjD");
function $58a07c47635c495b$var$Empty({ intl: { formatMessage: formatMessage } }) {
    // https://ecosystem.atlassian.net/browse/AK-4581
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $jELjD.default).description,
        values: {
            viewAllIssues: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, formatMessage((0, $jELjD.default).viewAllIssues)),
            saveFilterAs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, formatMessage((0, $jELjD.default).saveFilterAs))
        }
    }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kB4mh))),
        header: formatMessage((0, $jELjD.default).header),
        description: description,
        headingLevel: 2
    });
}
var $58a07c47635c495b$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($58a07c47635c495b$var$Empty);

});
parcelRegister("kB4mh", function(module, exports) {
module.exports = new URL("empty.368985dc.svg", import.meta.url).toString();

});

parcelRegister("jELjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $109a7738ed819bd4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $109a7738ed819bd4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "directories.filters-v2.main.content.empty.header",
        "defaultMessage": "You don't have any filters"
    },
    description: {
        "id": "directories.filters-v2.main.content.empty.description",
        "defaultMessage": "You can create a filter by searching. Select {viewAllIssues} option from the Filters top bar item and enter your search criteria. Then, select {saveFilterAs} to create a filter"
    },
    viewAllIssues: {
        "id": "directories.filters-v2.main.content.empty.view-all-issues",
        "defaultMessage": "View all issues"
    },
    saveFilterAs: {
        "id": "directories.filters-v2.main.content.empty.save-filter-as",
        "defaultMessage": "Save filter"
    }
});

});


parcelRegister("hdUWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $07fb65c497884ecc$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $b9OA0 = parcelRequire("b9OA0");

var $blhJn = parcelRequire("blhJn");
const $07fb65c497884ecc$var$mapStateToProps = (state)=>({
        isLoading: (0, $b9OA0.isLoading)(state)
    });
var $07fb65c497884ecc$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($07fb65c497884ecc$var$mapStateToProps, {})((0, $blhJn.default));

});
parcelRegister("blhJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d60c1c435a7ef60$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eae50 = parcelRequire("eae50");

var $koVbs = parcelRequire("koVbs");

var $6Nspm = parcelRequire("6Nspm");
function $0d60c1c435a7ef60$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $6Nspm.default).header),
        description: formatMessage((0, $6Nspm.default).description),
        isLoading: isLoading,
        onRetry: onRetry,
        headingLevel: 2
    });
}
$0d60c1c435a7ef60$var$Error.defaultProps = {
    isLoading: false
};
var $0d60c1c435a7ef60$export$2e2bcd8739ae039 = $0d60c1c435a7ef60$var$Error;

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $az4zD = parcelRequire("az4zD");

var $97INH = parcelRequire("97INH");

var $lNvSq = parcelRequire("lNvSq");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($97INH))) : (0, (/*@__PURE__*/$parcel$interopDefault($lNvSq)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("97INH", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("lNvSq", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("6Nspm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb31d6d707dd59d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb31d6d707dd59d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "directories.filters-v2.main.content.error.header",
        "defaultMessage": "We couldn't load your filters"
    },
    description: {
        "id": "directories.filters-v2.main.content.error.description",
        "defaultMessage": "Give it another try. If you run into more trouble, contact your admin for help."
    }
});

});



parcelRegister("dCHeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd9d68418563101$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iQv12 = parcelRequire("iQv12");

var $5JMh5 = parcelRequire("5JMh5");

var $4R6GH = parcelRequire("4R6GH");

var $lMdZA = parcelRequire("lMdZA");

var $fs8YG = parcelRequire("fs8YG");

var $bC2fB = parcelRequire("bC2fB");

var $imOJb = parcelRequire("imOJb");

var $aRmgJ = parcelRequire("aRmgJ");

var $hXBjD = parcelRequire("hXBjD");

var $4biUB = parcelRequire("4biUB");

var $cOGXp = parcelRequire("cOGXp");

var $lNjU3 = parcelRequire("lNjU3");
const $ddd9d68418563101$var$SearchWithAnalytics = (0, $iQv12.default)({
    onChange: 'search'
})((0, $5JMh5.default));
const $ddd9d68418563101$var$OwnerPickerWithAnalytics = (0, $iQv12.default)({
    onChange: 'owner'
})((0, $imOJb.default));
const $ddd9d68418563101$var$ProjectTypePickerWithAnalytics = (0, $iQv12.default)({
    onChange: 'project'
})((0, $fs8YG.default));
const $ddd9d68418563101$var$GroupPickerWithAnalytics = (0, $iQv12.default)({
    onChange: 'group'
})((0, $lMdZA.default));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ddd9d68418563101$var$renderFilterSearch = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ddd9d68418563101$var$SearchWithAnalytics, {
            ...props,
            value: (0, $4biUB.getSearchQuery)(state),
            isAlwaysExpanded: true,
            placeholderAlwaysVisible: (0, $4R6GH.fg)('blu-7151-filters-directory-search-field-a11y'),
            shouldFitContainerWidth: true
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ddd9d68418563101$var$renderOwnerPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ddd9d68418563101$var$OwnerPickerWithAnalytics, {
            ...props,
            selectedUser: (0, $4biUB.getSelectedOwner)(state),
            suggestedAccountId: (0, $hXBjD.getAtlassianAccountId)(state),
            baseUrl: (0, $hXBjD.getBaseUrl)(state),
            isCompact: true,
            shouldFitContainer: true,
            noPortal: (0, $4R6GH.fg)('blu-7426-filters-directory-pickers-a11y')
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ddd9d68418563101$var$renderProjectPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ddd9d68418563101$var$ProjectTypePickerWithAnalytics, {
            ...props,
            selectedProject: (0, $4biUB.getSelectedProject)(state),
            baseUrl: (0, $hXBjD.getBaseUrl)(state),
            isCompact: true,
            width: "100%",
            noPortal: (0, $4R6GH.fg)('blu-7426-filters-directory-pickers-a11y')
        });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ddd9d68418563101$var$renderGroupPicker = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ddd9d68418563101$var$GroupPickerWithAnalytics, {
            ...props,
            selectedGroup: (0, $4biUB.getSelectedGroup)(state),
            baseUrl: (0, $hXBjD.getBaseUrl)(state),
            isCompact: true,
            width: "100%",
            noPortal: (0, $4R6GH.fg)('blu-7426-filters-directory-pickers-a11y')
        });
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ddd9d68418563101$var$renderClear = (state)=>(props)=>(0, $4biUB.isFilterApplied)(state) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOGXp.default), props);
const $ddd9d68418563101$var$mapStateToPropsFactory = ()=>{
    const renderFilterSearchFactory = (0, $8QpSo.default)($ddd9d68418563101$var$renderFilterSearch);
    const renderOwnerPickerFactory = (0, $8QpSo.default)($ddd9d68418563101$var$renderOwnerPicker);
    const renderProjectPickerFactory = (0, $8QpSo.default)($ddd9d68418563101$var$renderProjectPicker);
    const renderGroupPickerFactory = (0, $8QpSo.default)($ddd9d68418563101$var$renderGroupPicker);
    const renderClearFactory = (0, $8QpSo.default)($ddd9d68418563101$var$renderClear);
    return (state, ownProps)=>({
            renderFilterSearch: renderFilterSearchFactory(state),
            renderOwnerPicker: renderOwnerPickerFactory(state),
            renderProjectPicker: renderProjectPickerFactory(state),
            renderGroupPicker: renderGroupPickerFactory(state),
            renderClear: renderClearFactory(state),
            initialFilter: (0, $aRmgJ.initialQuery).filter,
            value: (0, $4biUB.getFilter)(state),
            onChange: ownProps.onFilter
        });
};
var $ddd9d68418563101$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($ddd9d68418563101$var$mapStateToPropsFactory, {})((0, $lNjU3.default));

});
parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("5JMh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6c98eab5c64edc$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $3as6V = parcelRequire("3as6V");
var $1c6c98eab5c64edc$export$2e2bcd8739ae039 = (0, $8oe80.default)('filterSearch', {
    onChange: 'changed'
})((0, $3as6V.default));

});
parcelRegister("3as6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $466d610aa4e058b2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $2xSAL = parcelRequire("2xSAL");

var $dCm1o = parcelRequire("dCm1o");
const $466d610aa4e058b2$export$4c4c11a6ab1f5b09 = 1000;
const $466d610aa4e058b2$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((value, callback)=>callback(value), $466d610aa4e058b2$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $466d610aa4e058b2$var$Filter extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: (0, $dCm1o.isVisualRefreshEnabled)()
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $466d610aa4e058b2$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $466d610aa4e058b2$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $466d610aa4e058b2$export$2e2bcd8739ae039 = $466d610aa4e058b2$var$Filter;

});


parcelRegister("lMdZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab630e8f21974ebe$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $cz6xH = parcelRequire("cz6xH");
var $ab630e8f21974ebe$export$2e2bcd8739ae039 = (0, $8oe80.default)('GroupPicker', {
    onChange: 'changed'
})((0, $cz6xH.default));

});
parcelRegister("cz6xH", function(module, exports) {

$parcel$export(module.exports, "default", () => $407c71fa53420c90$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $ckyDP = parcelRequire("ckyDP");

var $4USKh = parcelRequire("4USKh");

var $az4zD = parcelRequire("az4zD");

var $iTyDa = parcelRequire("iTyDa");

var $frWNK = parcelRequire("frWNK");
class $407c71fa53420c90$export$471c4c2b52766e8d extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            fetchOnce: false,
            width: 200
        };
    }
    constructor(props){
        super(props), this.state = {
            options: [],
            selectedGroup: this.props.selectedGroup,
            prevSelectedGroup: this.props.selectedGroup
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedGroup: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (group)=>({
                // @ts-expect-error - TS2769 - No overload matches this call.
                avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
                    LEGACY_size: "small"
                }),
                label: group.name
            }), /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchAllGroups = (searchQuery)=>(0, $iTyDa.getAllGroups)(this.props.baseUrl, searchQuery), /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchUserGroups = (searchQuery)=>this.props.withMember ? (0, $iTyDa.getUserGroups)(this.props.baseUrl, this.props.withMember, searchQuery) : Promise.resolve();
        this.groupPickerId = `group-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentGroup = props.selectedGroup && props.selectedGroup.value;
        const prevGroup = state.prevSelectedGroup && state.prevSelectedGroup.value;
        if (currentGroup !== prevGroup) return {
            ...state,
            selectedGroup: props.selectedGroup,
            prevSelectedGroup: props.selectedGroup
        };
        return null;
    }
    componentDidMount() {
        const { fetchOnce: fetchOnce } = this.props;
        if (fetchOnce === true) {
            const getOptions = this.getFetchOptionsFunction();
            getOptions('').then((groups)=>this.setState({
                    // @ts-expect-error - TS2322 - Type 'void | Group[]' is not assignable to type 'Group[]'.
                    options: groups
                }));
        }
    }
    getFetchOptionsFunction() {
        return this.props.withMember ? this.fetchUserGroups : this.fetchAllGroups;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, placeholder: placeholder = this.props.placeholder || formatMessage((0, $frWNK.default).placeholder), onChange: onChange, fetchOnce: fetchOnce, ...props } = this.props;
        const { selectedGroup: selectedGroup } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $frWNK.default).labelText) : undefined,
            inputId: this.groupPickerId,
            ...props,
            errorMessage: formatMessage((0, $frWNK.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            // @ts-expect-error - TS2769 - No overload matches this call.
            options: fetchOnce === true ? this.state.options : this.getFetchOptionsFunction(),
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedGroup && selectedGroup.name ? selectedGroup : null
        });
    }
}
var $407c71fa53420c90$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($407c71fa53420c90$export$471c4c2b52766e8d);

});
parcelRegister("4USKh", function(module, exports) {

$parcel$export(module.exports, "PickerWithAvatar", () => $63c33924209c0872$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $63c33924209c0872$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $8oe80 = parcelRequire("8oe80");

var $4U4qk = parcelRequire("4U4qk");

var $9M5Oz = parcelRequire("9M5Oz");
const $63c33924209c0872$export$e6b8a87858f7afd1 = (0, $9M5Oz.default);
const $63c33924209c0872$export$3d409af828769e2e = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $9M5Oz.default));
const $63c33924209c0872$export$d8d9f25d80d89b16 = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $4U4qk.default));

});
parcelRegister("4U4qk", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $0d1a93ba35d548ba$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $0d1a93ba35d548ba$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $0d1a93ba35d548ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1ZftP = parcelRequire("1ZftP");
var $94bNw = parcelRequire("94bNw");
var $bChGW = parcelRequire("bChGW");
var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $VgvL1 = parcelRequire("VgvL1");

var $fVAPR = parcelRequire("fVAPR");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $e239o = parcelRequire("e239o");
const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #626F86)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: '',
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $e239o.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, props));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $0d1a93ba35d548ba$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $1ZftP.default) : (0, $iOwNT.default);
        if (isAsync) return 0, $VgvL1.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $94bNw.default) : (0, $7K5PP.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $e239o.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>(0, $4R6GH.fg)('enable-project-picker-require-edit-permission') ? this.props.noOptionsMessage ?? formatMessage((0, $e239o.default).noOptions) : formatMessage((0, $e239o.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $e239o.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...(0, $4R6GH.fg)('jira_apply_prop_stylings_to_base_picker') ? this.props.styles : undefined,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
const $0d1a93ba35d548ba$var$PickerWithIntl = (0, $az4zD.injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
};
$0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
var $0d1a93ba35d548ba$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0d1a93ba35d548ba$var$DefaultPicker;
const $0d1a93ba35d548ba$var$StyledValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, $8CUq3.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
});

});
parcelRegister("1ZftP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe39b95a8bd43db$export$2e2bcd8739ae039);

var $isgat = parcelRequire("isgat");

var $3c98u = parcelRequire("3c98u");
const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, $3c98u.default)((0, $isgat.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;

});
parcelRegister("isgat", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce0d05b9e97e68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iaInK.default)(props);
    const creatableProps = (0, $9uJ4X.default)(stateManagerProps);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;

});
parcelRegister("2QhWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e863683b34816f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2Z7Iz = parcelRequire("2Z7Iz");

var $VSDnB = parcelRequire("VSDnB");

var $eEtcC = parcelRequire("eEtcC");

var $bChGW = parcelRequire("bChGW");

var $jtVgE = parcelRequire("jtVgE");
var $9cRAr = parcelRequire("9cRAr");
var $galqx = parcelRequire("galqx");

var $7uagk = parcelRequire("7uagk");

var $81i5b = parcelRequire("81i5b");

var $aA8TC = parcelRequire("aA8TC");

var $5JAlL = parcelRequire("5JAlL");

var $7VXAu = parcelRequire("7VXAu");

var $gyjU7 = parcelRequire("gyjU7");
const $d8e863683b34816f$export$9c21a3269931e1e6 = {
    // aria-live is by default with the live region so we don't need it
    // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
    'aria-live': (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $gyjU7.isTouchCapable)(),
    captureMenuScroll: !(0, $gyjU7.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5JAlL.createFilter)(),
    formatGroupLabel: (0, $eEtcC.formatGroupLabel),
    getOptionLabel: (0, $eEtcC.getOptionLabel),
    getOptionValue: (0, $eEtcC.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $eEtcC.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $gyjU7.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
    const label = $d8e863683b34816f$var$getOptionLabel(props, option);
    const value = $d8e863683b34816f$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $gyjU7.notNullish));
}
function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
    return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
}
function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
    return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
}
function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $d8e863683b34816f$var$instanceId = 1;
class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isVoiceOver = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && (0, $2Z7Iz.isAppleDevice)(), // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $gyjU7.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $gyjU7.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $gyjU7.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $gyjU7.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $gyjU7.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $gyjU7.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $d8e863683b34816f$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $d8e863683b34816f$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $7VXAu.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            if (!custom) return base;
            const customStyles = (0, $VSDnB.fg)('compiled-react-select') ? (0, $gyjU7.filterUnsupportedSelectors)(custom(base, props)) : custom(base, props);
            return customStyles;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $bChGW.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $gyjU7.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $VSDnB.fg)('platform_dst_layer_observer_select')) return;
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
        this.state.selectValue = (0, $gyjU7.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $gyjU7.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $gyjU7.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription(action) {
        const descriptionProp = this.props['aria-describedby'] || this.props['descriptionId'];
        const { isMulti: isMulti } = this.props;
        const { selectValue: selectValue } = this.state;
        const defaultDescription = selectValue.length ? this.getElementId('live-region') : this.getElementId('placeholder');
        if (!isMulti && selectValue.length && action !== 'initial-input-focus') return;
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            return {
                'aria-describedby': descriptionProp ? [
                    descriptionProp,
                    defaultDescription,
                    multiMessage
                ].join(' ') : [
                    defaultDescription,
                    multiMessage
                ].join(' ')
            };
        } else return {
            'aria-describedby': descriptionProp ? [
                descriptionProp,
                defaultDescription
            ].join(' ') : defaultDescription
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-describedby': this.props['aria-describedby'] || descriptionId,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription(ariaSelection?.action)
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtVgE.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $gyjU7.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $5uXOq.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $5uXOq.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled && (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : isDisabled,
                'aria-describedby': (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? headingId : undefined,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $5uXOq.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const calculateListboxLabel = ()=>{
            // First in name calculation, overwrites aria-label
            if (labelId) return {
                'aria-labelledby': labelId
            };
            // Second in name calcuation, overwrites everything else except aria-labelledby
            if (label) return {
                'aria-label': label
            };
            // Fallback if no label or labelId is provided, might catch label via <label for> otherwise
            // will most likely not have an accessible name
            return {
                'aria-labelledby': this.inputRef?.id || this.getElementId('input')
            };
        };
        const menuElement = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aA8TC.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galqx.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    'aria-multiselectable': (this.isVoiceOver || !commonProps.isMulti) && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox when ff is on
                                    ...(0, $VSDnB.fg)('design_system_select-a11y-improvement') && calculateListboxLabel()
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $2OMIu.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9cRAr.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $81i5b.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isVoiceOver
        });
    }
    renderMultiselectMessage() {
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: ", multiple selections available,"
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $2OMIu.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $2Z7Iz.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7uagk.NotifyOpenLayerObserver), {
                    isOpen: (0, $VSDnB.fg)('platform_dst_layer_observer_select') && this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("eEtcC", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $1a3d0f2eb875e1af$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $1a3d0f2eb875e1af$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $1a3d0f2eb875e1af$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $1a3d0f2eb875e1af$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("bChGW", function(module, exports) {

$parcel$export(module.exports, "components", () => $ea75c1778b4e3ad2$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $ea75c1778b4e3ad2$export$71abc632aa29e6fe);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $95iuW.ClearIndicator),
    Control: (0, $eZFhY.default),
    DropdownIndicator: (0, $95iuW.DropdownIndicator),
    Group: (0, $i48X9.default),
    GroupHeading: (0, $i48X9.GroupHeading),
    IndicatorsContainer: (0, $h1QWG.IndicatorsContainer),
    Input: (0, $dS5G5.default),
    LoadingIndicator: (0, $95iuW.LoadingIndicator),
    Menu: (0, $aA8TC.default),
    MenuList: (0, $aA8TC.MenuList),
    MenuPortal: (0, $aA8TC.MenuPortal),
    LoadingMessage: (0, $aA8TC.LoadingMessage),
    NoOptionsMessage: (0, $aA8TC.NoOptionsMessage),
    MultiValue: (0, $hqcPo.default),
    MultiValueContainer: (0, $hqcPo.MultiValueContainer),
    MultiValueLabel: (0, $hqcPo.MultiValueLabel),
    MultiValueRemove: (0, $hqcPo.MultiValueRemove),
    Option: (0, $8l2RA.default),
    Placeholder: (0, $kKm82.default),
    SelectContainer: (0, $h1QWG.SelectContainer),
    SingleValue: (0, $hpcbi.default),
    ValueContainer: (0, $h1QWG.ValueContainer)
};
const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
        ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("h1QWG", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $78186faf13ea75d3$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $78186faf13ea75d3$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $78186faf13ea75d3$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $78186faf13ea75d3$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $78186faf13ea75d3$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $78186faf13ea75d3$export$d0ffd7e649cab6f);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $agFN9 = parcelRequire("agFN9");

var $1dm34 = parcelRequire("1dm34");
const $78186faf13ea75d3$export$949392aeaf7d2e3a = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.containerCSS)() : (0, $1dm34.containerCSS)(props);
const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.SelectContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.SelectContainer), {
        ...props
    });
const $78186faf13ea75d3$export$47aec73c7aa6b9aa = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.valueContainerCSS)() : (0, $1dm34.valueContainerCSS)(props);
const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.ValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.ValueContainer), {
        ...props
    });
const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.indicatorsContainerCSS)() : (0, $1dm34.indicatorsContainerCSS)();
const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.IndicatorsContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.IndicatorsContainer), {
        ...props
    });

});
parcelRegister("agFN9", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $0e7e14a3e3f4b78e$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $0e7e14a3e3f4b78e$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $0e7e14a3e3f4b78e$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $0e7e14a3e3f4b78e$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $0e7e14a3e3f4b78e$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $0e7e14a3e3f4b78e$export$d0ffd7e649cab6f);
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
const $0e7e14a3e3f4b78e$export$949392aeaf7d2e3a = ()=>({});
const $0e7e14a3e3f4b78e$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
const $0e7e14a3e3f4b78e$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $gyjU7.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0e7e14a3e3f4b78e$var$containerStyles.default,
            isRtl && $0e7e14a3e3f4b78e$var$containerStyles.rtl,
            isDisabled && $0e7e14a3e3f4b78e$var$containerStyles.disabled,
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $0e7e14a3e3f4b78e$var$containerStyles.ff_safari_input_fix,
            (0, $DEWI6.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $0e7e14a3e3f4b78e$export$47aec73c7aa6b9aa = ()=>({});
const $0e7e14a3e3f4b78e$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7"
};
const $0e7e14a3e3f4b78e$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0e7e14a3e3f4b78e$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $0e7e14a3e3f4b78e$var$valueContainerStyles.flex,
            isCompact && $0e7e14a3e3f4b78e$var$valueContainerStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $0e7e14a3e3f4b78e$export$9d74e3c8b5868ad7 = ()=>({});
const $0e7e14a3e3f4b78e$var$indicatorContainerStyles = null;
const $0e7e14a3e3f4b78e$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $DEWI6.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("gyjU7", function(module, exports) {

$parcel$export(module.exports, "noop", () => $109d3f9af5469308$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $109d3f9af5469308$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $109d3f9af5469308$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $109d3f9af5469308$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $109d3f9af5469308$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $109d3f9af5469308$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $109d3f9af5469308$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $109d3f9af5469308$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $109d3f9af5469308$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $109d3f9af5469308$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $109d3f9af5469308$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $109d3f9af5469308$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $109d3f9af5469308$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $109d3f9af5469308$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $109d3f9af5469308$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $109d3f9af5469308$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $109d3f9af5469308$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $109d3f9af5469308$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $109d3f9af5469308$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $109d3f9af5469308$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $109d3f9af5469308$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $109d3f9af5469308$export$4213b25a1c4e877);
$parcel$export(module.exports, "filterUnsupportedSelectors", () => $109d3f9af5469308$export$bf2eda47afa5f369);
const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
    if ($109d3f9af5469308$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $109d3f9af5469308$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $109d3f9af5469308$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
    const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
        $109d3f9af5469308$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $109d3f9af5469308$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $109d3f9af5469308$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $109d3f9af5469308$var$passiveOptionAccessed = false;
const $109d3f9af5469308$var$options = {
    get passive () {
        return $109d3f9af5469308$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
}
const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $109d3f9af5469308$var$isArray(arg) {
    return Array.isArray(arg);
}
function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $109d3f9af5469308$export$bf2eda47afa5f369 = (styles)=>{
    const unsupportedSelectors = [
        ':hover',
        ':focus',
        ':active',
        ':visited',
        ':link',
        ':checked',
        ':disabled',
        ':enabled',
        ':first-child',
        ':last-child',
        ':nth-child',
        ':nth-last-child',
        ':only-child',
        ':first-of-type',
        ':last-of-type',
        ':nth-of-type',
        ':nth-last-of-type',
        ':only-of-type',
        ':empty',
        ':not',
        ':root',
        ':target',
        ':before',
        ':after',
        '::before',
        '::after',
        '::placeholder',
        '::selection',
        '::backdrop',
        '::marker',
        '::first-line',
        '::first-letter',
        '::spelling-error',
        '::grammar-error',
        '[attr]',
        '[attr=value]',
        '[attr^=value]',
        '[attr$=value]',
        '[attr*=value]',
        '[attr|=value]',
        '[attr~=value]',
        '>',
        '+',
        '~',
        ' '
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});


parcelRegister("1dm34", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $cefbf12e841cc8e0$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $cefbf12e841cc8e0$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $cefbf12e841cc8e0$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $cefbf12e841cc8e0$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $cefbf12e841cc8e0$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $cefbf12e841cc8e0$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $gyjU7 = parcelRequire("gyjU7");
const $cefbf12e841cc8e0$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        position: 'relative',
        font: (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        pointerEvents: 'all',
        cursor: isDisabled ? 'not-allowed' : undefined,
        [`${(0, $h9kUS.media).above.xs}`]: {
            font: (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : undefined
        }
    });
const $cefbf12e841cc8e0$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $cefbf12e841cc8e0$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
    });
const $cefbf12e841cc8e0$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $cefbf12e841cc8e0$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0,
        paddingRight: "var(--ds-space-050, 4px)"
    });
const $cefbf12e841cc8e0$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});


parcelRegister("eZFhY", function(module, exports) {

$parcel$export(module.exports, "css", () => $728816cb4150b6bc$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $728816cb4150b6bc$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8JQpT = parcelRequire("8JQpT");

var $PQCB3 = parcelRequire("PQCB3");
const $728816cb4150b6bc$export$dbf350e5966cf602 = (props)=>{
    return (0, $VSDnB.fg)('compiled-react-select') ? (0, $8JQpT.css)() : (0, $PQCB3.css)(props);
};
const $728816cb4150b6bc$var$Control = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JQpT.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PQCB3.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;

});
parcelRegister("8JQpT", function(module, exports) {

$parcel$export(module.exports, "css", () => $2fb743295de83222$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $2fb743295de83222$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $2fb743295de83222$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123b1h4p _d0altlke _irr31d5g _1oglgxqn",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $2fb743295de83222$export$dbf350e5966cf602 = ()=>({});
const $2fb743295de83222$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $2fb743295de83222$var$styles.default,
            isDisabled && $2fb743295de83222$var$styles.disabled,
            isInvalid && $2fb743295de83222$var$styles.invalid,
            isCompact && $2fb743295de83222$var$styles.compact,
            appearance === 'subtle' && $2fb743295de83222$var$styles.subtle,
            appearance === 'subtle' && isFocused && $2fb743295de83222$var$styles.subtleFocused,
            isFocused && $2fb743295de83222$var$styles.focused,
            appearance === 'none' && $2fb743295de83222$var$styles.none,
            (0, $DEWI6.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2fb743295de83222$export$2e2bcd8739ae039 = $2fb743295de83222$var$Control;

});

parcelRegister("PQCB3", function(module, exports) {

$parcel$export(module.exports, "css", () => $00e6c98a997351d1$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $00e6c98a997351d1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $00e6c98a997351d1$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
    let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
    let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    if (isDisabled) {
        backgroundColor = "var(--ds-background-disabled, #091E4208)";
        borderColor = "var(--ds-background-disabled, #091E4208)";
    }
    if (isInvalid) {
        borderColor = "var(--ds-border-danger, #E2483D)";
        borderColorHover = "var(--ds-border-danger, #E2483D)";
    }
    const transitionDuration = '200ms';
    if (appearance === 'subtle') {
        borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
        backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
        backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    }
    if (appearance === 'none') {
        borderColor = 'transparent';
        backgroundColor = 'transparent';
        backgroundColorHover = 'transparent';
        borderColorHover = 'transparent';
    }
    return {
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        // Turn pointer events off when disabled - this makes it so hover etc don't work.
        pointerEvents: isDisabled ? 'none' : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
        '&:focus-within': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
        },
        minHeight: isCompact ? 32 : 40,
        padding: 0,
        transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
        '::-webkit-scrollbar': {
            height: 8,
            width: 8
        },
        '::-webkit-scrollbar-corner': {
            display: 'none'
        },
        ':hover': {
            '::-webkit-scrollbar-thumb': {
                // scrollbars occur only if the user passes in a custom component with overflow: scroll
                backgroundColor: 'rgba(0,0,0,0.2)'
            },
            cursor: 'pointer',
            backgroundColor: backgroundColorHover,
            borderColor: borderColorHover
        },
        '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.4)'
        }
    };
};
const $00e6c98a997351d1$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $gyjU7.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$00e6c98a997351d1$export$2e2bcd8739ae039 = $00e6c98a997351d1$var$Control;

});


parcelRegister("i48X9", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $902e86f4b4fe337b$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $902e86f4b4fe337b$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $902e86f4b4fe337b$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $902e86f4b4fe337b$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $OON7h = parcelRequire("OON7h");

var $2Tqqx = parcelRequire("2Tqqx");
const $902e86f4b4fe337b$export$b6794329c1460634 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $OON7h.groupCSS)() : (0, $2Tqqx.groupCSS)(props);
const $902e86f4b4fe337b$var$Group = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OON7h.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Tqqx.default), {
        ...props
    });
const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $OON7h.groupHeadingCSS)() : (0, $2Tqqx.groupHeadingCSS)(props);
const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OON7h.GroupHeading), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Tqqx.GroupHeading), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;

});
parcelRegister("OON7h", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $a3ce5541021fbdcc$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $a3ce5541021fbdcc$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $a3ce5541021fbdcc$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $a3ce5541021fbdcc$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $a3ce5541021fbdcc$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $a3ce5541021fbdcc$export$b6794329c1460634 = ()=>({});
const $a3ce5541021fbdcc$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a3ce5541021fbdcc$var$styles.root,
            (0, $DEWI6.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                children: children
            })
        ]
    });
};
const $a3ce5541021fbdcc$var$headingStyles = null;
const $a3ce5541021fbdcc$export$e5a7fbb542efcb7d = ()=>({});
const $a3ce5541021fbdcc$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $DEWI6.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ce5541021fbdcc$export$2e2bcd8739ae039 = $a3ce5541021fbdcc$var$Group;

});

parcelRegister("2Tqqx", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $460363aae382b65a$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $460363aae382b65a$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $460363aae382b65a$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $460363aae382b65a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $460363aae382b65a$export$b6794329c1460634 = ({})=>({
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-100, 8px)"
    });
const $460363aae382b65a$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, label && /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $460363aae382b65a$export$e5a7fbb542efcb7d = ({})=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        marginBottom: '0.25em',
        paddingLeft: "var(--ds-space-150, 12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtle, #44546F)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textTransform: 'none'
    });
const $460363aae382b65a$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$460363aae382b65a$export$2e2bcd8739ae039 = $460363aae382b65a$var$Group;

});


parcelRegister("95iuW", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $13f090f36c42825d$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $13f090f36c42825d$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $13f090f36c42825d$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $13f090f36c42825d$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $13f090f36c42825d$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $13f090f36c42825d$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $7FTuF = parcelRequire("7FTuF");

var $ckNeS = parcelRequire("ckNeS");
const $13f090f36c42825d$export$e1687335805e1230 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.dropdownIndicatorCSS)() : (0, $ckNeS.dropdownIndicatorCSS)(props);
const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.DropdownIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.DropdownIndicator), {
        ...props
    });
const $13f090f36c42825d$export$9c0419fd944c1def = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.clearIndicatorCSS)() : (0, $ckNeS.clearIndicatorCSS)(props);
const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.ClearIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.ClearIndicator), {
        ...props
    });
const $13f090f36c42825d$export$1d3f24cde248e6b5 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.loadingIndicatorCSS)() : (0, $ckNeS.loadingIndicatorCSS)(props);
const $13f090f36c42825d$export$7c20be4c1d342248 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.LoadingIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.LoadingIndicator), {
        ...props
    });

});
parcelRegister("7FTuF", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $a7cf25f9e9baf2e9$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $a7cf25f9e9baf2e9$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $a7cf25f9e9baf2e9$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $a7cf25f9e9baf2e9$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $a7cf25f9e9baf2e9$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $a7cf25f9e9baf2e9$export$7c20be4c1d342248);
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $c8Oei = parcelRequire("c8Oei");

var $cQz2U = parcelRequire("cQz2U");

var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $gyjU7 = parcelRequire("gyjU7");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $a7cf25f9e9baf2e9$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $a7cf25f9e9baf2e9$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
const $a7cf25f9e9baf2e9$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
const $a7cf25f9e9baf2e9$export$e1687335805e1230 = ()=>({});
const $a7cf25f9e9baf2e9$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$dropdownStyles.default,
            isDisabled && $a7cf25f9e9baf2e9$var$dropdownStyles.disabled,
            isCompact && $a7cf25f9e9baf2e9$var$dropdownStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "span",
            xcss: $a7cf25f9e9baf2e9$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                color: "currentColor",
                label: "open",
                LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
            })
        })
    });
};
const $a7cf25f9e9baf2e9$export$9c0419fd944c1def = ()=>({});
const $a7cf25f9e9baf2e9$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
const $a7cf25f9e9baf2e9$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$clearIndicatorStyles.default,
            isCompact && $a7cf25f9e9baf2e9$var$clearIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            xcss: $a7cf25f9e9baf2e9$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small",
                LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
            })
        })
    });
};
const $a7cf25f9e9baf2e9$export$1d3f24cde248e6b5 = ()=>({});
const $a7cf25f9e9baf2e9$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
const $a7cf25f9e9baf2e9$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$loadingIndicatorStyles.default,
            isCompact && $a7cf25f9e9baf2e9$var$loadingIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            size: "small"
        })
    });
};

});
parcelRegister("cQz2U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7da2857c3151a92889bed61f5baa1334>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));

var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
function $95a586bfe482ffec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
    }, props));
$95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;

});
parcelRegister("47etd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23b3104937a360e799abf4f0ea698b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ff30a5d9a7d32b6$var$_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;

});

parcelRegister("673MF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
function $473654f205f53fc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $473654f205f53fc4$var$SelectClearIcon = (props)=>/*#__PURE__*/ $473654f205f53fc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $473654f205f53fc4$var$_crossCircle.default
    }));
$473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;

});



parcelRegister("ckNeS", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $fbe9e11ad0f07d66$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $fbe9e11ad0f07d66$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $fbe9e11ad0f07d66$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $fbe9e11ad0f07d66$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $fbe9e11ad0f07d66$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $fbe9e11ad0f07d66$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $c8Oei = parcelRequire("c8Oei");

var $cQz2U = parcelRequire("cQz2U");

var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $gyjU7 = parcelRequire("gyjU7");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $fbe9e11ad0f07d66$var$iconContainerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $fbe9e11ad0f07d66$var$dropdownWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.075'
});
const $fbe9e11ad0f07d66$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $fbe9e11ad0f07d66$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
        as: "span",
        xcss: $fbe9e11ad0f07d66$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
};
const $fbe9e11ad0f07d66$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: "var(--ds-text-subtlest, #626F86)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $fbe9e11ad0f07d66$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear' } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
        xcss: $fbe9e11ad0f07d66$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
};
const $fbe9e11ad0f07d66$export$1d3f24cde248e6b5 = ({ isCompact: isCompact })=>({
        label: 'loadingIndicator',
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
    });
const $fbe9e11ad0f07d66$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), {
        size: "small"
    }));
};

});


parcelRegister("dS5G5", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $1c949ac6f5985b40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $1c949ac6f5985b40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dIuKO = parcelRequire("dIuKO");

var $2KDs7 = parcelRequire("2KDs7");
const $1c949ac6f5985b40$export$14a7781d0ca7abea = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $dIuKO.inputCSS)() : (0, $2KDs7.inputCSS)(props);
const $1c949ac6f5985b40$var$Input = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dIuKO.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2KDs7.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;

});
parcelRegister("dIuKO", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $6599751c7dd5cc6c$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $6599751c7dd5cc6c$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $6599751c7dd5cc6c$export$14a7781d0ca7abea = ()=>({});
const $6599751c7dd5cc6c$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $6599751c7dd5cc6c$var$nativeInnputStyles = null;
const $6599751c7dd5cc6c$var$hidden = null;
const $6599751c7dd5cc6c$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'input', {
        'input-container': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $6599751c7dd5cc6c$var$inputStyles.root,
            isDisabled && $6599751c7dd5cc6c$var$inputStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6599751c7dd5cc6c$export$2e2bcd8739ae039 = $6599751c7dd5cc6c$var$Input;

});

parcelRegister("2KDs7", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $3bbb27dfa42e66e5$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $3bbb27dfa42e66e5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $3bbb27dfa42e66e5$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value })=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$3bbb27dfa42e66e5$var$containerStyle,
        margin: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingTop: "var(--ds-space-025, 2px)",
        color: "var(--ds-text, #172B4D)"
    });
const $3bbb27dfa42e66e5$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $3bbb27dfa42e66e5$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$3bbb27dfa42e66e5$var$spacingStyle
    }
};
const $3bbb27dfa42e66e5$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$3bbb27dfa42e66e5$var$spacingStyle
    });
const $3bbb27dfa42e66e5$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $3bbb27dfa42e66e5$var$inputStyle(isHidden),
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3bbb27dfa42e66e5$export$2e2bcd8739ae039 = $3bbb27dfa42e66e5$var$Input;

});


parcelRegister("aA8TC", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $1fde8cb844828ae2$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $1fde8cb844828ae2$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $1fde8cb844828ae2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $1fde8cb844828ae2$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $1fde8cb844828ae2$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $1fde8cb844828ae2$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $1fde8cb844828ae2$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $1fde8cb844828ae2$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $1fde8cb844828ae2$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $1fde8cb844828ae2$export$793392f970497feb);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $5aZmi = parcelRequire("5aZmi");

var $1s63F = parcelRequire("1s63F");
const $1fde8cb844828ae2$export$a228922d5ca42a79 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuCSS)() : (0, $1s63F.menuCSS)(props);
const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuPlacer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuPlacer), {
        ...props
    });
const $1fde8cb844828ae2$var$Menu = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
const $1fde8cb844828ae2$export$abafed69cff95d5e = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuListCSS)() : (0, $1s63F.menuListCSS)(props);
const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuList), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuList), {
        ...props
    });
// ==============================
// Menu Notices
// ==============================
const $1fde8cb844828ae2$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$d58b72b7d3c4072c = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.NoOptionsMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.NoOptionsMessage), {
        ...props
    });
const $1fde8cb844828ae2$export$e928a71d039d3102 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.LoadingMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.LoadingMessage), {
        ...props
    });
const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuPortalCSS)() : (0, $1s63F.menuPortalCSS)(props);
const $1fde8cb844828ae2$export$793392f970497feb = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuPortal), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuPortal), {
        ...props
    });

});
parcelRegister("5aZmi", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $76c1fc1d7ab61474$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $76c1fc1d7ab61474$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $76c1fc1d7ab61474$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $76c1fc1d7ab61474$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $76c1fc1d7ab61474$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $76c1fc1d7ab61474$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $76c1fc1d7ab61474$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $76c1fc1d7ab61474$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $76c1fc1d7ab61474$export$793392f970497feb);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $VSDnB = parcelRequire("VSDnB");

var $dS3PR = parcelRequire("dS3PR");

var $gyjU7 = parcelRequire("gyjU7");
function $76c1fc1d7ab61474$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $VSDnB.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $76c1fc1d7ab61474$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $76c1fc1d7ab61474$var$menuStyles = {
    root: "_2rkoglpi _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qs17uf",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
const $76c1fc1d7ab61474$export$a228922d5ca42a79 = ()=>({});
const $76c1fc1d7ab61474$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $76c1fc1d7ab61474$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($76c1fc1d7ab61474$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $76c1fc1d7ab61474$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $76c1fc1d7ab61474$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $76c1fc1d7ab61474$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $76c1fc1d7ab61474$var$menuStyles.root,
            $76c1fc1d7ab61474$var$menuStyles[placement],
            (0, $DEWI6.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$76c1fc1d7ab61474$export$2e2bcd8739ae039 = $76c1fc1d7ab61474$var$Menu;
const $76c1fc1d7ab61474$export$abafed69cff95d5e = ()=>({});
const $76c1fc1d7ab61474$var$menuListStyles = null;
const $76c1fc1d7ab61474$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $DEWI6.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
// ==============================
// Menu Notices
// ==============================
const $76c1fc1d7ab61474$var$noticeCSS = ()=>({});
const $76c1fc1d7ab61474$var$noticeStyles = null;
const $76c1fc1d7ab61474$export$cf0e22534d8b0074 = $76c1fc1d7ab61474$var$noticeCSS;
const $76c1fc1d7ab61474$export$98ec46397a8cb3cd = $76c1fc1d7ab61474$var$noticeCSS;
const $76c1fc1d7ab61474$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $76c1fc1d7ab61474$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $76c1fc1d7ab61474$export$1dbbeb9648d1fdc9 = ()=>({});
const $76c1fc1d7ab61474$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($76c1fc1d7ab61474$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $DEWI6.cx)(className, xcss, '-MenuPortal'),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            zIndex: 9999,
            left: computedPosition.rect.left,
            position: menuPosition,
            top: computedPosition.offset,
            width: computedPosition.rect.width,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($76c1fc1d7ab61474$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("g9RrE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $bc36f1aefc070984$export$deee3a793edee05f);

var $gSfPF = parcelRequire("gSfPF");
var $cVo0M = parcelRequire("cVo0M");

var $cVo0M = parcelRequire("cVo0M");

var $f8LYQ = parcelRequire("f8LYQ");
function $bc36f1aefc070984$var$getCssDimensions(element) {
    const css = (0, $f8LYQ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f8LYQ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cVo0M.round)(width) !== offsetWidth || (0, $cVo0M.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bc36f1aefc070984$var$unwrapElement(element) {
    return !(0, $f8LYQ.isElement)(element) ? element.contextElement : element;
}
function $bc36f1aefc070984$var$getScale(element) {
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    if (!(0, $f8LYQ.isHTMLElement)(domElement)) return (0, $cVo0M.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cVo0M.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cVo0M.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bc36f1aefc070984$var$noOffsets = /*#__PURE__*/ (0, $cVo0M.createCoords)(0);
function $bc36f1aefc070984$var$getVisualOffsets(element) {
    const win = (0, $f8LYQ.getWindow)(element);
    if (!(0, $f8LYQ.isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $f8LYQ.getWindow)(element)) return false;
    return isFixed;
}
function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    let scale = (0, $cVo0M.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f8LYQ.isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
        } else scale = $bc36f1aefc070984$var$getScale(element);
    }
    const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, $cVo0M.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $f8LYQ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $f8LYQ.isElement)(offsetParent) ? (0, $f8LYQ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f8LYQ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f8LYQ.getWindow)(currentIFrame);
            currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        }
    }
    return (0, $cVo0M.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f8LYQ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, $f8LYQ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $f8LYQ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cVo0M.createCoords)(1);
    const offsets = (0, $cVo0M.createCoords)(0);
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if ((0, $f8LYQ.isHTMLElement)(offsetParent)) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
            scale = $bc36f1aefc070984$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, $cVo0M.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bc36f1aefc070984$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bc36f1aefc070984$var$getDocumentRect(element) {
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const scroll = (0, $f8LYQ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cVo0M.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cVo0M.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $f8LYQ.getComputedStyle)(body).direction === 'rtl') x += (0, $cVo0M.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
    const win = (0, $f8LYQ.getWindow)(element);
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $f8LYQ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $f8LYQ.isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, $cVo0M.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, $f8LYQ.getDocumentElement)(element));
    else if ((0, $f8LYQ.isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cVo0M.rectToClientRect)(rect);
}
function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $f8LYQ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $f8LYQ.isElement)(parentNode) || (0, $f8LYQ.isLastTraversableNode)(parentNode)) return false;
    return (0, $f8LYQ.getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f8LYQ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $f8LYQ.isElement)(el) && (0, $f8LYQ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $f8LYQ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f8LYQ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f8LYQ.isElement)(currentNode) && !(0, $f8LYQ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $f8LYQ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $f8LYQ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $f8LYQ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $f8LYQ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bc36f1aefc070984$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f8LYQ.isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cVo0M.max)(rect.top, accRect.top);
        accRect.right = (0, $cVo0M.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cVo0M.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cVo0M.max)(rect.left, accRect.left);
        return accRect;
    }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bc36f1aefc070984$var$getDimensions(element) {
    const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cVo0M.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, $cVo0M.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bc36f1aefc070984$var$isStaticPositioned(element) {
    return (0, $f8LYQ.getComputedStyle)(element).position === 'static';
}
function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f8LYQ.isHTMLElement)(element) || (0, $f8LYQ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f8LYQ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
    const win = (0, $f8LYQ.getWindow)(element);
    if ((0, $f8LYQ.isTopLayer)(element)) return win;
    if (!(0, $f8LYQ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $f8LYQ.getParentNode)(element);
        while(svgOffsetParent && !(0, $f8LYQ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $f8LYQ.isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f8LYQ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f8LYQ.isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f8LYQ.isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, $f8LYQ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $f8LYQ.getContainingBlock)(element) || win;
}
const $bc36f1aefc070984$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bc36f1aefc070984$var$isRTL(element) {
    return (0, $f8LYQ.getComputedStyle)(element).direction === 'rtl';
}
const $bc36f1aefc070984$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f8LYQ.getDocumentElement,
    getClippingRect: $bc36f1aefc070984$var$getClippingRect,
    getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
    getElementRects: $bc36f1aefc070984$var$getElementRects,
    getClientRects: $bc36f1aefc070984$var$getClientRects,
    getDimensions: $bc36f1aefc070984$var$getDimensions,
    getScale: $bc36f1aefc070984$var$getScale,
    isElement: $f8LYQ.isElement,
    isRTL: $bc36f1aefc070984$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bc36f1aefc070984$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $f8LYQ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cVo0M.floor)(top);
        const insetRight = (0, $cVo0M.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cVo0M.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cVo0M.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cVo0M.max)(0, (0, $cVo0M.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f8LYQ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $f8LYQ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, $gSfPF.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bc36f1aefc070984$export$cc800923e997bb8 = (0, $gSfPF.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, $gSfPF.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bc36f1aefc070984$export$fba63a578e423eb = (0, $gSfPF.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, $gSfPF.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bc36f1aefc070984$export$346677f925de839c = (0, $gSfPF.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bc36f1aefc070984$export$fe8985bb6374093c = (0, $gSfPF.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, $gSfPF.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, $gSfPF.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, $gSfPF.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bc36f1aefc070984$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $gSfPF.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("gSfPF", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $c48df878d8118962$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $c48df878d8118962$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $c48df878d8118962$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $c48df878d8118962$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $c48df878d8118962$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $c48df878d8118962$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $c48df878d8118962$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $c48df878d8118962$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $c48df878d8118962$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $c48df878d8118962$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $c48df878d8118962$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("cVo0M")).rectToClientRect);

var $cVo0M = parcelRequire("cVo0M");
function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cVo0M.getSideAxis)(placement);
    const alignmentAxis = (0, $cVo0M.getAlignmentAxis)(placement);
    const alignLength = (0, $cVo0M.getAxisLength)(alignmentAxis);
    const side = (0, $cVo0M.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cVo0M.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state);
    const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cVo0M.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cVo0M.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cVo0M.getAlignmentAxis)(placement);
            const length = (0, $cVo0M.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cVo0M.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cVo0M.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cVo0M.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cVo0M.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cVo0M.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cVo0M.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cVo0M.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cVo0M.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cVo0M.placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cVo0M.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cVo0M.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cVo0M.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cVo0M.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cVo0M.getSide)(placement);
            const initialSideAxis = (0, $cVo0M.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cVo0M.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cVo0M.getOppositePlacement)(initialPlacement)
            ] : (0, $cVo0M.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cVo0M.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cVo0M.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cVo0M.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
    return (0, $cVo0M.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c48df878d8118962$var$getBoundingRect(rects) {
    const minX = (0, $cVo0M.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cVo0M.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cVo0M.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cVo0M.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c48df878d8118962$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cVo0M.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cVo0M.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cVo0M.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cVo0M.getSide)(placement) === 'left';
                    const maxRight = (0, $cVo0M.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cVo0M.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c48df878d8118962$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cVo0M.getSide)(placement);
    const alignment = (0, $cVo0M.getAlignment)(placement);
    const isVertical = (0, $cVo0M.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cVo0M.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c48df878d8118962$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cVo0M.getSideAxis)((0, $cVo0M.getSide)(placement));
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cVo0M.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cVo0M.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cVo0M.getSideAxis)(placement);
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cVo0M.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cVo0M.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c48df878d8118962$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cVo0M.getSide)(placement);
            const alignment = (0, $cVo0M.getAlignment)(placement);
            const isYAxis = (0, $cVo0M.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cVo0M.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cVo0M.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cVo0M.max)(overflow.left, 0);
                const xMax = (0, $cVo0M.max)(overflow.right, 0);
                const yMin = (0, $cVo0M.max)(overflow.top, 0);
                const yMax = (0, $cVo0M.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cVo0M.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cVo0M.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cVo0M", function(module, exports) {

$parcel$export(module.exports, "sides", () => $968d6f1d7e429938$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $968d6f1d7e429938$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $968d6f1d7e429938$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $968d6f1d7e429938$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $968d6f1d7e429938$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $968d6f1d7e429938$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $968d6f1d7e429938$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $968d6f1d7e429938$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $968d6f1d7e429938$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $968d6f1d7e429938$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $968d6f1d7e429938$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $968d6f1d7e429938$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $968d6f1d7e429938$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $968d6f1d7e429938$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $968d6f1d7e429938$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $968d6f1d7e429938$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $968d6f1d7e429938$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $968d6f1d7e429938$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $968d6f1d7e429938$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $968d6f1d7e429938$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $968d6f1d7e429938$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $968d6f1d7e429938$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $968d6f1d7e429938$export$803cd8101b6c182b = /*#__PURE__*/ $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $968d6f1d7e429938$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $968d6f1d7e429938$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
    return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
}
function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
    return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
}
function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
    const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
    const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
    return [
        $968d6f1d7e429938$export$2b182c584985588b(placement),
        oppositePlacement,
        $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
    ];
}
function $968d6f1d7e429938$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
}
function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
    }
    return list;
}
function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
}
function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("f8LYQ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $b05cd24baa7455b6$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $b05cd24baa7455b6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $b05cd24baa7455b6$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $b05cd24baa7455b6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b05cd24baa7455b6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $b05cd24baa7455b6$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $b05cd24baa7455b6$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $b05cd24baa7455b6$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $b05cd24baa7455b6$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $b05cd24baa7455b6$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $b05cd24baa7455b6$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $b05cd24baa7455b6$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $b05cd24baa7455b6$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $b05cd24baa7455b6$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $b05cd24baa7455b6$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $b05cd24baa7455b6$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $b05cd24baa7455b6$export$7bf1f8740e3e34af);
function $b05cd24baa7455b6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b05cd24baa7455b6$export$651544f548703224(node) {
    if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b05cd24baa7455b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
}
function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
}
function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
    if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b05cd24baa7455b6$export$651544f548703224(element));
}
function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
    const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b05cd24baa7455b6$export$940d8225183e1404(element) {
    let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
    while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b05cd24baa7455b6$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b05cd24baa7455b6$export$651544f548703224(node));
}
function $b05cd24baa7455b6$export$3735103072e4a80(element) {
    return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
    if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
    if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b05cd24baa7455b6$export$e495491855dc5418(node);
    return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
    const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
    if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
}
function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = (0, $5uXOq.useLayoutEffect);

});


parcelRegister("1s63F", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $b0d3f8517e4be892$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $b0d3f8517e4be892$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $b0d3f8517e4be892$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $b0d3f8517e4be892$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $b0d3f8517e4be892$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $b0d3f8517e4be892$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $b0d3f8517e4be892$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $b0d3f8517e4be892$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $b0d3f8517e4be892$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $gyjU7 = parcelRequire("gyjU7");
function $b0d3f8517e4be892$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $VSDnB.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $b0d3f8517e4be892$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $b0d3f8517e4be892$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b0d3f8517e4be892$export$a228922d5ca42a79 = ({ placement: placement })=>({
        label: 'menu',
        [$b0d3f8517e4be892$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        borderRadius: "var(--ds-border-radius, 4px)",
        marginBottom: "var(--ds-space-100, 8px)",
        marginTop: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-overlay, white)",
        boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
    });
const $b0d3f8517e4be892$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b0d3f8517e4be892$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($b0d3f8517e4be892$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $b0d3f8517e4be892$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $b0d3f8517e4be892$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $b0d3f8517e4be892$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b0d3f8517e4be892$export$2e2bcd8739ae039 = $b0d3f8517e4be892$var$Menu;
const $b0d3f8517e4be892$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)"
    });
const $b0d3f8517e4be892$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $b0d3f8517e4be892$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $b0d3f8517e4be892$export$cf0e22534d8b0074 = $b0d3f8517e4be892$var$noticeCSS;
const $b0d3f8517e4be892$export$98ec46397a8cb3cd = $b0d3f8517e4be892$var$noticeCSS;
const $b0d3f8517e4be892$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, children));
};
const $b0d3f8517e4be892$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, children));
};
const $b0d3f8517e4be892$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $b0d3f8517e4be892$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($b0d3f8517e4be892$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $gyjU7.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($b0d3f8517e4be892$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});


parcelRegister("hqcPo", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $20933ad7b05a0c37$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $20933ad7b05a0c37$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $20933ad7b05a0c37$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $20933ad7b05a0c37$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $20933ad7b05a0c37$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $20933ad7b05a0c37$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $iBgL9 = parcelRequire("iBgL9");

var $4ntXy = parcelRequire("4ntXy");
const $20933ad7b05a0c37$export$23c213f7717186af = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueCSS)() : (0, $4ntXy.multiValueCSS)(props);
const $20933ad7b05a0c37$export$f40612612e0af964 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueLabelCSS)() : (0, $4ntXy.multiValueLabelCSS)(props);
const $20933ad7b05a0c37$export$283467f6c4ac142b = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueRemoveCSS)() : (0, $4ntXy.multiValueRemoveCSS)(props);
const $20933ad7b05a0c37$export$cf9cf2a30a59265c = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueContainer), {
        ...props
    });
const $20933ad7b05a0c37$export$544aeea2a5ce08ee = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueLabel), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueLabel), {
        ...props
    });
function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a(props) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    (0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueRemove), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueRemove), {
        ...props
    }));
}
const $20933ad7b05a0c37$var$MultiValue = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;

});
parcelRegister("iBgL9", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $a2bd6c7425e95809$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $a2bd6c7425e95809$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $a2bd6c7425e95809$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $a2bd6c7425e95809$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $a2bd6c7425e95809$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $a2bd6c7425e95809$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $a2bd6c7425e95809$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $673MF = parcelRequire("673MF");

var $bjGSs = parcelRequire("bjGSs");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
const $a2bd6c7425e95809$var$multiValueStyles = {
    root: "_2rkogqwt _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs17si _1aewe4h9 _6up53acm _1xdnnqa1",
    refresh: "_2rkoiti9 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
const $a2bd6c7425e95809$export$23c213f7717186af = ()=>({});
const $a2bd6c7425e95809$export$f40612612e0af964 = ()=>({});
const $a2bd6c7425e95809$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkogqwt _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
const $a2bd6c7425e95809$export$283467f6c4ac142b = ()=>({});
const $a2bd6c7425e95809$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rkoglpi _bfhk1w7a _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
const $a2bd6c7425e95809$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueStyles.root,
            isDisabled && $a2bd6c7425e95809$var$multiValueStyles.disabled,
            isFocused && $a2bd6c7425e95809$var$multiValueStyles.focused,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};
const $a2bd6c7425e95809$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueLabelStyles.root,
            isDisabled && $a2bd6c7425e95809$var$multiValueLabelStyles.disabled,
            hasEllipsis && $a2bd6c7425e95809$var$multiValueLabelStyles.ellipsis,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueLabelStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
const $a2bd6c7425e95809$var$disabledStyles = null;
const $a2bd6c7425e95809$var$enabledStyles = null;
function $a2bd6c7425e95809$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueRemoveStyles.root,
            isFocused && $a2bd6c7425e95809$var$multiValueRemoveStyles.focused,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueRemoveStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $bwpsq.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
                label: "",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($673MF))),
                LEGACY_primaryColor: "transparent",
                LEGACY_secondaryColor: "inherit",
                LEGACY_size: "small"
            })
        })
    });
}
const $a2bd6c7425e95809$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a2bd6c7425e95809$export$2e2bcd8739ae039 = $a2bd6c7425e95809$var$MultiValue;

});

parcelRegister("4ntXy", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $e8473c8c41411b48$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $e8473c8c41411b48$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $e8473c8c41411b48$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $e8473c8c41411b48$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $e8473c8c41411b48$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $e8473c8c41411b48$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $e8473c8c41411b48$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $673MF = parcelRequire("673MF");

var $bjGSs = parcelRequire("bjGSs");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
function $e8473c8c41411b48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e8473c8c41411b48$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused })=>{
    let backgroundColor;
    let color;
    if (isDisabled) {
        // Use the basic neutral background so it is slightly separate from the
        // field's background
        backgroundColor = "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text-disabled, #091E424F)";
    } else if (isFocused) {
        backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
    } else {
        backgroundColor = (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text, hsl(0, 0%, 20%))";
    }
    return {
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        margin: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        backgroundColor: backgroundColor,
        boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
        maxWidth: '100%',
        '@media screen and (-ms-high-contrast: active)': {
            border: isFocused ? '1px solid transparent' : 'none'
        },
        color: color,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            borderRadius: "var(--ds-border-radius-100, 4px)",
            // Hardcode this color for visual refresh as there is no token color yet
            borderColor: '#B7B9BE',
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            backgroundColor: "var(--ds-background-input, #FFFFFF)"
        }
    };
};
const $e8473c8c41411b48$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '85%',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        padding: "var(--ds-space-025, 2px)",
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
        paddingLeft: "var(--ds-space-075, 6px)",
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "var(--ds-space-050, 4px)"
        }
    });
const $e8473c8c41411b48$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
        alignItems: 'center',
        display: 'flex',
        backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
        fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-025, 2px)",
        borderRadius: '0px 2px 2px 0px',
        // DSP-6470 we should style like Tag once we have the :has selector
        ':hover': {
            backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
            fill: "var(--ds-text-danger, #000)"
        },
        ':active': {
            backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
            fill: "var(--ds-text-danger, #000)"
        },
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            appearance: 'none',
            borderRadius: "var(--ds-border-radius, 4px)",
            color: "var(--ds-text, #172B4D)",
            padding: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            ':focus-visible': {
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            ':hover': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            }
        }
    });
const $e8473c8c41411b48$var$MultiValueGeneric = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $e8473c8c41411b48$export$cf9cf2a30a59265c = $e8473c8c41411b48$var$MultiValueGeneric;
const $e8473c8c41411b48$export$544aeea2a5ce08ee = $e8473c8c41411b48$var$MultiValueGeneric;
const $e8473c8c41411b48$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $e8473c8c41411b48$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
function $e8473c8c41411b48$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, innerProps: innerProps }) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $e8473c8c41411b48$var$disabledStyles : $e8473c8c41411b48$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
        label: "",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($673MF))),
        LEGACY_primaryColor: "transparent",
        LEGACY_secondaryColor: "inherit",
        LEGACY_size: "small"
    }))));
}
const $e8473c8c41411b48$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            role: 'button',
            tabIndex: -1,
            'aria-label': `${ariaLabel || 'option'}, remove`,
            ...removeProps
        },
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8473c8c41411b48$export$2e2bcd8739ae039 = $e8473c8c41411b48$var$MultiValue;

});


parcelRegister("8l2RA", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $6e6d67a90b457dc1$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $6e6d67a90b457dc1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3ttih = parcelRequire("3ttih");

var $2coFy = parcelRequire("2coFy");
const $6e6d67a90b457dc1$export$ef897119b7e920ba = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $3ttih.optionCSS)() : (0, $2coFy.optionCSS)(props);
const $6e6d67a90b457dc1$var$Option = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3ttih.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2coFy.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;

});
parcelRegister("3ttih", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $067c79fba4bdfbb2$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $067c79fba4bdfbb2$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $067c79fba4bdfbb2$export$ef897119b7e920ba = ()=>({});
const $067c79fba4bdfbb2$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk18uv _16qsglyw _1di618uv _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pknj1ic",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pknj1ic",
    focusedSelected: "_bfhki1yw"
};
const $067c79fba4bdfbb2$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $067c79fba4bdfbb2$var$optionStyles.root,
            isFocused && $067c79fba4bdfbb2$var$optionStyles.focused,
            isSelected && $067c79fba4bdfbb2$var$optionStyles.selected,
            isFocused && isSelected && $067c79fba4bdfbb2$var$optionStyles.focusedSelected,
            isDisabled && $067c79fba4bdfbb2$var$optionStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$067c79fba4bdfbb2$export$2e2bcd8739ae039 = $067c79fba4bdfbb2$var$Option;

});

parcelRegister("2coFy", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $026e08b240e6e5e0$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $026e08b240e6e5e0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $026e08b240e6e5e0$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    let color = "var(--ds-text, #172B4D)";
    if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
    else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
    let boxShadow;
    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
    else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
    const cursor = isDisabled ? 'not-allowed' : 'default';
    return {
        label: 'option',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        backgroundColor: backgroundColor,
        color: color,
        cursor: cursor,
        boxShadow: boxShadow,
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
        }
    };
};
const $026e08b240e6e5e0$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$026e08b240e6e5e0$export$2e2bcd8739ae039 = $026e08b240e6e5e0$var$Option;

});


parcelRegister("kKm82", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $889d652a9d0dc097$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $889d652a9d0dc097$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dw3lH = parcelRequire("dw3lH");

var $iL8GQ = parcelRequire("iL8GQ");
const $889d652a9d0dc097$export$5f3ffacd6594d90f = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $dw3lH.placeholderCSS)() : (0, $iL8GQ.placeholderCSS)(props);
const $889d652a9d0dc097$var$Placeholder = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dw3lH.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iL8GQ.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;

});
parcelRegister("dw3lH", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $7011c54f7352f26b$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $7011c54f7352f26b$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $7011c54f7352f26b$export$5f3ffacd6594d90f = ()=>({});
const $7011c54f7352f26b$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
const $7011c54f7352f26b$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $7011c54f7352f26b$var$placeholderStyles.root,
            isDisabled && $7011c54f7352f26b$var$placeholderStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7011c54f7352f26b$export$2e2bcd8739ae039 = $7011c54f7352f26b$var$Placeholder;

});

parcelRegister("iL8GQ", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $aeddb46ca1eecdf2$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $aeddb46ca1eecdf2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $aeddb46ca1eecdf2$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
    });
const $aeddb46ca1eecdf2$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aeddb46ca1eecdf2$export$2e2bcd8739ae039 = $aeddb46ca1eecdf2$var$Placeholder;

});


parcelRegister("hpcbi", function(module, exports) {

$parcel$export(module.exports, "css", () => $aff94346c62a222f$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $aff94346c62a222f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $5Zgwp = parcelRequire("5Zgwp");

var $9pbjn = parcelRequire("9pbjn");
const $aff94346c62a222f$export$dbf350e5966cf602 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5Zgwp.css)() : (0, $9pbjn.css)(props);
const $aff94346c62a222f$var$SingleValue = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Zgwp.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9pbjn.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;

});
parcelRegister("5Zgwp", function(module, exports) {

$parcel$export(module.exports, "css", () => $11f234ca28812396$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $11f234ca28812396$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $11f234ca28812396$export$dbf350e5966cf602 = ()=>({});
const $11f234ca28812396$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
const $11f234ca28812396$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $11f234ca28812396$var$styles.root,
            isDisabled && $11f234ca28812396$var$styles.disalbed,
            (0, $DEWI6.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$11f234ca28812396$export$2e2bcd8739ae039 = $11f234ca28812396$var$SingleValue;

});

parcelRegister("9pbjn", function(module, exports) {

$parcel$export(module.exports, "css", () => $0f24309584527733$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $0f24309584527733$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $0f24309584527733$export$dbf350e5966cf602 = ({ isDisabled: isDisabled })=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
    });
const $0f24309584527733$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0f24309584527733$export$2e2bcd8739ae039 = $0f24309584527733$var$SingleValue;

});



parcelRegister("jtVgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe53037961824c2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $c8F86 = parcelRequire("c8F86");

var $39bHe = parcelRequire("39bHe");
function $afe53037961824c2$export$2e2bcd8739ae039(props) {
    return (0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8F86.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39bHe.default), {
        ...props
    });
}

});
parcelRegister("c8F86", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb54a2dcae79e275$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gyjU7 = parcelRequire("gyjU7");
const $fb54a2dcae79e275$var$dummyInputStyles = null;
function $fb54a2dcae79e275$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("39bHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ee388602b33ee1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $00ee388602b33ee1$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $00ee388602b33ee1$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $00ee388602b33ee1$var$dummyInputStyles
    });
}

});


parcelRegister("9cRAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a388fa48a9e96271$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $hU6tE = parcelRequire("hU6tE");

var $9Oi37 = parcelRequire("9Oi37");
const $a388fa48a9e96271$var$RequiredInput = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hU6tE.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Oi37.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;

});
parcelRegister("hU6tE", function(module, exports) {

$parcel$export(module.exports, "default", () => $945267b00a632302$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");
const $945267b00a632302$var$styles = null;
const $945267b00a632302$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _jqf61a21 _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$945267b00a632302$export$2e2bcd8739ae039 = $945267b00a632302$var$RequiredInput;

});

parcelRegister("9Oi37", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26802938ecd7698$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $eGmKJ = parcelRequire("eGmKJ");
function $c26802938ecd7698$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c26802938ecd7698$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $c26802938ecd7698$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $c26802938ecd7698$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c26802938ecd7698$export$2e2bcd8739ae039 = $c26802938ecd7698$var$RequiredInput;

});


parcelRegister("galqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15a49c0b3452f71$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $59IMp = parcelRequire("59IMp");

var $3jzRI = parcelRequire("3jzRI");
const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $59IMp.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $3jzRI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onClick: $e15a49c0b3452f71$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("59IMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c08116303d9e3a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
const $96c08116303d9e3a$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $gyjU7.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("3jzRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $840302f0f43020c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $840302f0f43020c5$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $840302f0f43020c5$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $840302f0f43020c5$var$preventTouchMove(e) {
    e.preventDefault();
}
function $840302f0f43020c5$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $840302f0f43020c5$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $840302f0f43020c5$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $840302f0f43020c5$var$activeScrollLocks = 0;
const $840302f0f43020c5$var$listenerOptions = {
    capture: false,
    passive: false
};
function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $840302f0f43020c5$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("7uagk", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $7a4261c0e93bff6e$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $7a4261c0e93bff6e$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("81i5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ccfcdca5695e58$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $7ZLLh = parcelRequire("7ZLLh");

var $bbz9Z = parcelRequire("bbz9Z");
const $a3ccfcdca5695e58$var$LiveRegion = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ZLLh.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bbz9Z.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;

});
parcelRegister("7ZLLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $419a6948853c8feb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dQlbw = parcelRequire("dQlbw");

var $7lhj2 = parcelRequire("7lhj2");
const $419a6948853c8feb$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            }),
            !(0, $VSDnB.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        id: "aria-focused",
                        children: ariaFocused
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        id: "aria-guidance",
                        children: ariaGuidance
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lhj2.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lhj2.default), {
                "aria-live": ariaLive,
                "aria-atomic": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
                "aria-relevant": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
                role: (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? 'status' : 'log',
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$419a6948853c8feb$export$2e2bcd8739ae039 = $419a6948853c8feb$var$LiveRegion;

});
parcelRegister("dQlbw", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $d3258ad64818881e$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $VSDnB = parcelRequire("VSDnB");
const $d3258ad64818881e$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || !(0, $VSDnB.fg)('design_system_select-a11y-improvement') ? `option ${label}, deselected` : ''; // TODO: this should be handled on backspace|delete if no value, but doing it here first
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return label.length && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || !(0, $VSDnB.fg)('design_system_select-a11y-improvement') ? `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.` : '';
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        // No longer needed after fg('design_system_select-a11y-improvement') is cleaned up
        if (context === 'menu' && !(0, $VSDnB.fg)('design_system_select-a11y-improvement')) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ' not selected'}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("7lhj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ce650310f44beb$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $59ce650310f44beb$var$styles = null;
const $59ce650310f44beb$var$A11yText = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _jqf6ydhy _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $59ce650310f44beb$export$2e2bcd8739ae039 = $59ce650310f44beb$var$A11yText;

});


parcelRegister("bbz9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $412616b9b75aa026$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $dQlbw = parcelRequire("dQlbw");

var $4Z3qi = parcelRequire("4Z3qi");
const $412616b9b75aa026$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), !(0, $VSDnB.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance)));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4Z3qi.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4Z3qi.default), {
        "aria-live": ariaLive,
        "aria-atomic": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
        "aria-relevant": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
        role: (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? 'status' : 'log'
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$412616b9b75aa026$export$2e2bcd8739ae039 = $412616b9b75aa026$var$LiveRegion;

});
parcelRegister("4Z3qi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acf6ce83a1ce1d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");
function $1acf6ce83a1ce1d0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $1acf6ce83a1ce1d0$var$styles = {
    name: "jvmzbk-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;user-select:none;white-space:nowrap"
};
const $1acf6ce83a1ce1d0$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $1acf6ce83a1ce1d0$var$styles,
        ...props
    });
var $1acf6ce83a1ce1d0$export$2e2bcd8739ae039 = $1acf6ce83a1ce1d0$var$A11yText;

});



parcelRegister("5JAlL", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $bXu2O = parcelRequire("bXu2O");
const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $bXu2O.stripDiacritics));
const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $bXu2O.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("bXu2O", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $df93339199dda18e$export$b5bee4b27048330b);
const $df93339199dda18e$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $df93339199dda18e$var$diacriticToBase = {};
for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
    let diacritic = $df93339199dda18e$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
    return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
};

});


parcelRegister("7VXAu", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $11d0fd648d1f51c0$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $11d0fd648d1f51c0$export$e618dc39ac9ad607);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
    clearIndicator: (0, $95iuW.clearIndicatorCSS),
    container: (0, $h1QWG.containerCSS),
    control: (0, $eZFhY.css),
    dropdownIndicator: (0, $95iuW.dropdownIndicatorCSS),
    group: (0, $i48X9.groupCSS),
    groupHeading: (0, $i48X9.groupHeadingCSS),
    indicatorsContainer: (0, $h1QWG.indicatorsContainerCSS),
    input: (0, $dS5G5.inputCSS),
    loadingIndicator: (0, $95iuW.loadingIndicatorCSS),
    loadingMessage: (0, $aA8TC.loadingMessageCSS),
    menu: (0, $aA8TC.menuCSS),
    menuList: (0, $aA8TC.menuListCSS),
    menuPortal: (0, $aA8TC.menuPortalCSS),
    multiValue: (0, $hqcPo.multiValueCSS),
    multiValueLabel: (0, $hqcPo.multiValueLabelCSS),
    multiValueRemove: (0, $hqcPo.multiValueRemoveCSS),
    noOptionsMessage: (0, $aA8TC.noOptionsMessageCSS),
    option: (0, $8l2RA.optionCSS),
    placeholder: (0, $kKm82.placeholderCSS),
    singleValue: (0, $hpcbi.css),
    valueContainer: (0, $h1QWG.valueContainerCSS)
};
function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("iaInK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e85c90096c52fe4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $5uXOq.useRef)(undefined);
    const mounted = (0, $5uXOq.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5uXOq.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $gyjU7.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("2HH7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $994aeb783b6f955a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eEtcC = parcelRequire("eEtcC");

var $gyjU7 = parcelRequire("gyjU7");
const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $994aeb783b6f955a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $eEtcC.getOptionValue), getOptionLabel: getOptionLabel = (0, $eEtcC.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $gyjU7.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gyjU7.valueTernary)(isMulti, [
                    ...(0, $gyjU7.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});

parcelRegister("9uJ4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b6d9d338d10de1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("3c98u", function(module, exports) {

$parcel$export(module.exports, "default", () => $628a0199069e875a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $1DATb = parcelRequire("1DATb");
function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? undefined : 'assertive',
            ariaLiveMessages: //TO DO: Still need live region for PopupSelect because of the menu being open by default
            (0, $1DATb.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $1DATb.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("1DATb", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $a998ee34d66f3da7$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $a998ee34d66f3da7$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $a998ee34d66f3da7$export$8ee33f304118fce4);

var $VSDnB = parcelRequire("VSDnB");
function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    if (focused.label && groupData?.label && (0, $VSDnB.fg)('design_system_select-a11y-improvement')) return `${focused.label}, ${groupData?.label}`;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("94bNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf832c571222d72$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $itpgN = parcelRequire("itpgN");

var $7K5PP = parcelRequire("7K5PP");
const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $ebf832c571222d72$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;

});
parcelRegister("itpgN", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $f5875245cd0ad0c1$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $f5875245cd0ad0c1$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6aY6N = parcelRequire("6aY6N");

var $iQHJo = parcelRequire("iQHJo");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
const $f5875245cd0ad0c1$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $f5875245cd0ad0c1$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $f5875245cd0ad0c1$var$baseIconStyles = null;
const $f5875245cd0ad0c1$var$baseOptionStyles = null;
const $f5875245cd0ad0c1$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $5uXOq.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $f5875245cd0ad0c1$var$optionStyles.default,
            isFocused && $f5875245cd0ad0c1$var$optionStyles.focused,
            isDisabled && $f5875245cd0ad0c1$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $f5875245cd0ad0c1$var$iconStyles.inherit : $f5875245cd0ad0c1$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    label: "",
                    primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($6aY6N))),
        ...props
    });
const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $2OMIu.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $f5875245cd0ad0c1$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($iQHJo))),
        ...props
    });

});
parcelRegister("6aY6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
function $47f24d9003b82760$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47f24d9003b82760$var$CheckboxIcon = (props)=>/*#__PURE__*/ $47f24d9003b82760$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $47f24d9003b82760$var$_checkboxChecked.default
    }));
$47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;

});
parcelRegister("aoKYM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79209663d32c0c44$var$_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79209663d32c0c44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;

});


parcelRegister("iQHJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db8f016a0af5fda9$var$RadioIcon = (props)=>/*#__PURE__*/ $db8f016a0af5fda9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $db8f016a0af5fda9$var$_radioChecked.default
    }));
$db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;

});
parcelRegister("kqGQn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f37934c6709a990262261073c8d0052>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $edf7783e719984ba$var$_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $edf7783e719984ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;

});



parcelRegister("7K5PP", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $c2d344e1481a2d3b$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, $3c98u.default)((0, $eAthk.default));
const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
const $c2d344e1481a2d3b$var$Select = (0, $994MI.default)({
    componentName: 'select',
    packageName: $c2d344e1481a2d3b$var$packageName,
    packageVersion: $c2d344e1481a2d3b$var$packageVersion
})((0, $cb25w.default)({
    onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $c2d344e1481a2d3b$var$packageName,
            packageVersion: $c2d344e1481a2d3b$var$packageVersion
        }
    })
})($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;

});
parcelRegister("eAthk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0cf20527a3a891$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("iaInK")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $9uJ4X = parcelRequire("9uJ4X");
const $6d0cf20527a3a891$var$AsyncSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $iaInK.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $9uJ4X.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;

});



parcelRegister("iOwNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $59b6485f0cb008dd$export$2e2bcd8739ae039);

var $9OU1i = parcelRequire("9OU1i");

var $3c98u = parcelRequire("3c98u");
const $59b6485f0cb008dd$var$CreatableSelect = (0, $3c98u.default)((0, $9OU1i.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;

});
parcelRegister("9OU1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29f1caecd9c7d5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("2HH7Y")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $b29f1caecd9c7d5a$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $9uJ4X.default)(props);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;

});


parcelRegister("VgvL1", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $462c399840da3e1c$export$ee664e5add893f9);

var $d7FF4 = parcelRequire("d7FF4");

var $8oe80 = parcelRequire("8oe80");
const $462c399840da3e1c$export$ee664e5add893f9 = (0, $8oe80.default)('select', {
    onChange: 'changed'
})((0, $d7FF4.default));

});
parcelRegister("d7FF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4d84cf4438daea$export$2e2bcd8739ae039);

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $ac4d84cf4438daea$var$AsyncSelect = (0, $3c98u.default)((0, $eAthk.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;

});


parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$labelStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $97462970d1593b07$var$requiredIndicatorStyle = null;

});

parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $k5uoT = parcelRequire("k5uoT");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $k5uoT.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $k5uoT.layers).navigation(),
    card: (0, $k5uoT.layers).card(),
    dialog: (0, $k5uoT.layers).dialog(),
    navigation: (0, $k5uoT.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $k5uoT.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $k5uoT.layers).navigation() - 1,
    layer: (0, $k5uoT.layers).layer(),
    blanket: (0, $k5uoT.layers).blanket(),
    modal: (0, $k5uoT.layers).modal(),
    flag: (0, $k5uoT.layers).flag(),
    spotlight: (0, $k5uoT.layers).spotlight(),
    tooltip: (0, $k5uoT.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});

parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("e239o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6849afedcc0fa8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("9M5Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae2cb265c5b0a53f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $kgoHi = parcelRequire("kgoHi");

var $4U4qk = parcelRequire("4U4qk");
class $ae2cb265c5b0a53f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae2cb265c5b0a53f$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ae2cb265c5b0a53f$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("iTyDa", function(module, exports) {

$parcel$export(module.exports, "getAllGroups", () => $3f576979452c6c2a$export$c243565349cba18c);
$parcel$export(module.exports, "getUserGroups", () => $3f576979452c6c2a$export$bda937ecc753b1f3);

var $aDmD8 = parcelRequire("aDmD8");

var $48hcp = parcelRequire("48hcp");
const $3f576979452c6c2a$export$c243565349cba18c = (baseUrl, searchQuery, maxResults)=>(0, $aDmD8.getAllGroups)(baseUrl, searchQuery, maxResults).then((0, $48hcp.transformAllGroups));
const $3f576979452c6c2a$export$bda937ecc753b1f3 = (baseUrl, accountId, searchQuery)=>{
    if (!accountId) return Promise.resolve([]);
    return (0, $aDmD8.getUserGroups)(baseUrl, accountId).then((response)=>{
        const filteredGroups = (0, $48hcp.filterUserGroups)(response, searchQuery);
        return (0, $48hcp.transformUserGroups)(filteredGroups);
    });
};

});
parcelRegister("aDmD8", function(module, exports) {

$parcel$export(module.exports, "getAllGroups", () => $76137711d5dac9f8$export$c243565349cba18c);
$parcel$export(module.exports, "getUserGroups", () => $76137711d5dac9f8$export$bda937ecc753b1f3);

var $7f4tk = parcelRequire("7f4tk");
// Get all groups (including ones user is not a member of)
const $76137711d5dac9f8$var$MAX_GROUPS = 5;
const $76137711d5dac9f8$export$dc22b2cc8b5a1431 = (baseUrl)=>`${baseUrl}/rest/api/2/groups/picker`;
const $76137711d5dac9f8$var$getAllGroupsUrl = (baseUrl, query, maxResults = $76137711d5dac9f8$var$MAX_GROUPS)=>`${$76137711d5dac9f8$export$dc22b2cc8b5a1431(baseUrl)}?maxResults=${maxResults}&query=${encodeURIComponent(query)}`;
const $76137711d5dac9f8$export$c243565349cba18c = (baseUrl, query = '', maxResults = $76137711d5dac9f8$var$MAX_GROUPS)=>(0, $7f4tk.default)($76137711d5dac9f8$var$getAllGroupsUrl(baseUrl, query, maxResults));
const $76137711d5dac9f8$export$a1f49428f96f52c7 = (baseUrl)=>`${baseUrl}/rest/api/3/user/groups`;
const $76137711d5dac9f8$var$getUserGroupsUrl = (baseUrl, accountId)=>`${$76137711d5dac9f8$export$a1f49428f96f52c7(baseUrl)}?accountId=${accountId}`;
const $76137711d5dac9f8$export$bda937ecc753b1f3 = (baseUrl, accountId)=>(0, $7f4tk.default)($76137711d5dac9f8$var$getUserGroupsUrl(baseUrl, accountId));

});

parcelRegister("48hcp", function(module, exports) {

$parcel$export(module.exports, "transformAllGroups", () => $aaa6afc95e0ce151$export$b53a6053f3a37f82);
$parcel$export(module.exports, "filterUserGroups", () => $aaa6afc95e0ce151$export$3803c0f966c39ffc);
$parcel$export(module.exports, "transformUserGroups", () => $aaa6afc95e0ce151$export$3e297671f207b321);
const $aaa6afc95e0ce151$export$b53a6053f3a37f82 = (response)=>response && response.groups && response.groups.map(({ name: name, groupId: groupId })=>({
            name: name,
            label: name,
            value: name,
            groupId: groupId
        }));
const $aaa6afc95e0ce151$export$3803c0f966c39ffc = (groupsRest, searchQuery)=>{
    if (!searchQuery) return groupsRest;
    return groupsRest.filter((group)=>group.name.includes(searchQuery || '')); // `|| ''` check is just for Flow
};
const $aaa6afc95e0ce151$export$3e297671f207b321 = (groupsRest)=>groupsRest.map(({ name: name, groupId: groupId })=>({
            name: name,
            label: name,
            value: name,
            groupId: groupId
        }));

});


parcelRegister("frWNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $62452bef71d985c7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $62452bef71d985c7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "group-picker.error",
        "defaultMessage": "We couldn't retrieve groups"
    },
    placeholder: {
        "id": "group-picker.placeholder",
        "defaultMessage": "Group"
    },
    labelText: {
        "id": "group-picker.label-text",
        "defaultMessage": "Group"
    }
});

});



parcelRegister("fs8YG", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f47b7198869b8c$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $59ECx = parcelRequire("59ECx");
var $90f47b7198869b8c$export$2e2bcd8739ae039 = (0, $8oe80.default)('ProjectPicker', {
    onChange: 'changed'
})((0, $59ECx.default));

});
parcelRegister("59ECx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af03db95f8cb63b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $4USKh = parcelRequire("4USKh");

var $az4zD = parcelRequire("az4zD");

var $4R6GH = parcelRequire("4R6GH");

var $5gPNV = parcelRequire("5gPNV");

var $2oK1T = parcelRequire("2oK1T");
class $1af03db95f8cb63b$export$a4519235a2ef9605 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            detailed: false,
            width: '200px',
            requireBrowsePermission: false,
            requireEditPermission: false,
            label: undefined,
            inputId: undefined,
            projectType: undefined
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedProject: this.props.selectedProject,
            projects: [],
            prevSelectedProject: this.props.selectedProject
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedProject: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (project)=>{
            const { avatarUrl: avatarUrl, name: name } = project;
            const avatar = this.props.renderAvatar ? this.props.renderAvatar(avatarUrl) : avatarUrl;
            return {
                avatar: avatar,
                label: name
            };
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = async (filter)=>{
            const projects = await (0, $5gPNV.requestProjects)(this.props.baseUrl, filter, {
                detailed: this.props.detailed,
                requireBrowsePermission: this.props.requireBrowsePermission,
                requireEditPermission: (0, $4R6GH.fg)('enable-project-picker-require-edit-permission') ? this.props.requireEditPermission : false,
                projectType: this.props.projectType
            });
            this.setState({
                projects: projects
            });
            return projects;
        };
        this.projectPickerId = `project-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentProjectId = props.selectedProject && props.selectedProject.value;
        const prevProjectId = state.prevSelectedProject && state.prevSelectedProject.value;
        if (currentProjectId !== prevProjectId) return {
            ...state,
            selectedProject: props.selectedProject,
            prevSelectedProject: props.selectedProject
        };
        return null;
    }
    componentDidMount() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    componentDidUpdate() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    fetchProject(selectedProject) {
        const { baseUrl: baseUrl } = this.props;
        const projectValue = selectedProject.value;
        // @ts-expect-error - TS7006 - Parameter 'newProject' implicitly has an 'any' type.
        const updateSelectedProject = (newProject)=>{
            const currentProject = this.state.selectedProject;
            const currentProjectValue = currentProject && currentProject.value;
            // Update the state only in case the project wasn't changed
            if (currentProjectValue === projectValue) {
                this.setState({
                    selectedProject: newProject
                });
                this.props.onChange(newProject);
            }
        };
        return (0, $5gPNV.requestProject)(baseUrl, projectValue).then((project)=>updateSelectedProject(project)).catch(()=>updateSelectedProject(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, selectedProject: selectedProject, onChange: onChange, ...props } = this.props;
        const { selectedProject: project, projects: projects } = this.state;
        // the selected option needs to have same object reference to be correctly announced by screen readers
        const selectedOptionWithObjectReference = projects?.find((projectInList)=>projectInList.value === project?.value);
        const selectedOption = selectedOptionWithObjectReference || (project && project.name ? project : null);
        return(// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $2oK1T.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.projectPickerId : this.props.inputId,
            errorMessage: formatMessage((0, $2oK1T.default).error),
            placeholder: this.props.placeholder || formatMessage((0, $2oK1T.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedOption,
            showFocusedAvatar: true
        }));
    }
}
var $1af03db95f8cb63b$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($1af03db95f8cb63b$export$a4519235a2ef9605);

});
parcelRegister("5gPNV", function(module, exports) {

$parcel$export(module.exports, "requestProjects", () => $cc6820a29e56f420$export$fd47004f2da106d6);
$parcel$export(module.exports, "requestProject", () => $cc6820a29e56f420$export$5fc96122a11240fa);

var $4SXEu = parcelRequire("4SXEu");

var $9V0kk = parcelRequire("9V0kk");
const $cc6820a29e56f420$export$fd47004f2da106d6 = (baseUrl, filter, { detailed: detailed, requireBrowsePermission: requireBrowsePermission, requireEditPermission: requireEditPermission, maxResults: maxResults, projectType: projectType })=>(0, $4SXEu.getProjects)(baseUrl, filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType).then((0, $9V0kk.transformProjects));
const $cc6820a29e56f420$export$5fc96122a11240fa = (baseUrl, projectId)=>(0, $4SXEu.getProject)(baseUrl, projectId).then((0, $9V0kk.transformProject));

});
parcelRegister("4SXEu", function(module, exports) {

$parcel$export(module.exports, "getProjects", () => $7b7f1e9303cf186f$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProject", () => $7b7f1e9303cf186f$export$637b60a42bb03f06);

var $7f4tk = parcelRequire("7f4tk");

var $4R6GH = parcelRequire("4R6GH");
const $7b7f1e9303cf186f$var$MAX_PROJECTS = 5;
const $7b7f1e9303cf186f$var$VALID_PROJECT_TYPES = [
    'business',
    'service_desk',
    'software'
];
const $7b7f1e9303cf186f$export$897983d170945c20 = (baseUrl)=>`${baseUrl}/rest/api/2/project/search`;
const $7b7f1e9303cf186f$export$40e632ede9793c84 = (baseUrl)=>`${baseUrl}/rest/api/2/project`;
const $7b7f1e9303cf186f$export$3675f59ca23820db = (baseUrl, filter, detailed, requireBrowsePermission, requireEditPermission, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('orderBy', 'NAME');
    urlSearchParams.set('startAt', '0');
    urlSearchParams.set('query', filter);
    urlSearchParams.set('maxResults', maxResults.toString());
    if (detailed) urlSearchParams.set('expand', 'lead,issueTypes');
    if ((0, $4R6GH.fg)('enable-project-picker-require-edit-permission')) {
        const actions = [];
        if (requireBrowsePermission) actions.push('browse');
        if (requireEditPermission) actions.push('edit');
        if (actions.length > 0) urlSearchParams.set('action', actions.join(','));
    } else if (requireBrowsePermission) urlSearchParams.set('action', 'browse');
    if ($7b7f1e9303cf186f$var$VALID_PROJECT_TYPES.includes(projectType)) urlSearchParams.set('typeKey', projectType);
    const urlParams = `?${urlSearchParams.toString()}`;
    return `${$7b7f1e9303cf186f$export$897983d170945c20(baseUrl)}${urlParams}`;
};
const $7b7f1e9303cf186f$export$42f2db4bad372151 = (baseUrl, projectId)=>`${$7b7f1e9303cf186f$export$40e632ede9793c84(baseUrl)}/${encodeURIComponent(projectId)}`;
const $7b7f1e9303cf186f$export$b00a271f69f3d728 = (baseUrl, filter = '', detailed = false, requireBrowsePermission = false, requireEditPermission = false, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>(0, $7f4tk.default)($7b7f1e9303cf186f$export$3675f59ca23820db(baseUrl, filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType));
const $7b7f1e9303cf186f$export$637b60a42bb03f06 = (baseUrl, projectId = '')=>(0, $7f4tk.default)($7b7f1e9303cf186f$export$42f2db4bad372151(baseUrl, projectId));

});

parcelRegister("9V0kk", function(module, exports) {

$parcel$export(module.exports, "transformProject", () => $6541540d335a62b4$export$e179869ce707f546);
$parcel$export(module.exports, "transformProjects", () => $6541540d335a62b4$export$227473965d2e27db);
const $6541540d335a62b4$var$transformLead = (leadResponse)=>leadResponse && {
        key: leadResponse.key,
        name: leadResponse.name,
        displayName: leadResponse.displayName,
        avatarUrl: leadResponse.avatarUrls['24x24']
    };
const $6541540d335a62b4$var$transformIssueTypes = (types)=>types.map((t)=>({
            id: t.id,
            name: t.name,
            description: t.description,
            iconUrl: t.iconUrl,
            subtask: t.subtask
        }));
const $6541540d335a62b4$var$transformDetails = (restResponse)=>({
        id: restResponse.id,
        key: restResponse.key,
        lead: $6541540d335a62b4$var$transformLead(restResponse.lead),
        issueTypes: restResponse.issueTypes ? $6541540d335a62b4$var$transformIssueTypes(restResponse.issueTypes) : [],
        projectTypeKey: restResponse.projectTypeKey,
        simplified: restResponse.simplified
    });
const $6541540d335a62b4$export$e179869ce707f546 = (restResponse)=>restResponse && {
        value: restResponse.id,
        name: restResponse.name,
        label: restResponse.name,
        avatarUrl: restResponse.avatarUrls['24x24'],
        details: $6541540d335a62b4$var$transformDetails(restResponse)
    };
const $6541540d335a62b4$export$227473965d2e27db = (restResponse)=>restResponse && restResponse.values && restResponse.values.map($6541540d335a62b4$export$e179869ce707f546);

});


parcelRegister("2oK1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2fad71e32e9ef5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a2fad71e32e9ef5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "project-picker.error",
        "defaultMessage": "We couldn't retrieve projects"
    },
    placeholder: {
        "id": "project-picker.placeholder",
        "defaultMessage": "Project"
    },
    labelText: {
        "id": "project-picker.label-text",
        "defaultMessage": "Project"
    }
});

});



parcelRegister("imOJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ffec577315758c$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $7ffSD = parcelRequire("7ffSD");
var $66ffec577315758c$export$2e2bcd8739ae039 = (0, $8oe80.default)('UserPicker', {
    onChange: 'changed'
})((0, $7ffSD.default));

});
parcelRegister("7ffSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ea91f281eaff85$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $4USKh = parcelRequire("4USKh");

var $2YZCu = parcelRequire("2YZCu");

var $az4zD = parcelRequire("az4zD");

var $6GCo0 = parcelRequire("6GCo0");

var $8jpCj = parcelRequire("8jpCj");
class $63ea91f281eaff85$export$83e0c73b09b3a9cd extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isClearableWithCrossIcon: false,
            isCompact: false,
            shouldFitContainer: false,
            width: '200px'
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedUser: this.props.selectedUser,
            prevSelectedUser: this.props.selectedUser
        }, this.onSelected = (selectedUser)=>{
            this.setState({
                selectedUser: selectedUser
            });
            this.props.onChange(selectedUser);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (user)=>({
                avatar: user.avatarUrl,
                label: user.displayName
            }), this.fetchOptions = (query)=>{
            const { baseUrl: baseUrl, suggestedAccountId: suggestedAccountId } = this.props;
            if (query) return (0, $6GCo0.requestUsers)(baseUrl, query);
            if (suggestedAccountId) return new Promise((resolve)=>{
                (0, $6GCo0.requestUser)(baseUrl, suggestedAccountId).then((user)=>resolve([
                        user
                    ])).catch(()=>resolve([]));
            });
            return Promise.resolve([]);
        };
        this.userPickerId = `group-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentAccountId = props.selectedUser && props.selectedUser.accountId;
        const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
        if (currentAccountId !== prevAccountId) return {
            ...state,
            selectedUser: props.selectedUser,
            prevSelectedUser: props.selectedUser
        };
        return null;
    }
    componentDidMount() {
        this.ensureSelectedUserInfoPresent();
    }
    componentDidUpdate(prevProps) {
        this.ensureSelectedUserInfoPresent();
        if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) // Good to know:
        // react-select caches resolved Promise value for an empty filter so
        // there is no way to change the suggestion other then replacing the component with a new one
        (0, $2YZCu.default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
    }
    ensureSelectedUserInfoPresent() {
        const { selectedUser: selectedUser } = this.state;
        if (!selectedUser || selectedUser.displayName) return;
        const { accountId: accountId } = selectedUser;
        // @ts-expect-error - TS7006 - Parameter 'newUser' implicitly has an 'any' type.
        const updateSelectedUser = (newUser)=>{
            const currentUser = this.state.selectedUser;
            const currentAccountId = currentUser && currentUser.accountId;
            // Update the state only in case the user wasn't changed
            if (currentAccountId === accountId) this.setState({
                selectedUser: newUser
            });
        };
        (0, $6GCo0.requestUser)(this.props.baseUrl, accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, $8jpCj.default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, isClearableWithCrossIcon: isClearableWithCrossIcon, ...props } = this.props;
        const { selectedUser: user } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $8jpCj.default).labelText) : undefined,
            inputId: this.userPickerId,
            ...props,
            errorMessage: formatMessage((0, $8jpCj.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: user && user.displayName ? user : null,
            width: shouldFitContainer ? undefined : width,
            isClearableWithCrossIcon: isClearableWithCrossIcon
        });
    }
}
var $63ea91f281eaff85$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($63ea91f281eaff85$export$83e0c73b09b3a9cd);

});
parcelRegister("6GCo0", function(module, exports) {

$parcel$export(module.exports, "requestUser", () => $c396037537d957cc$export$949646a1c1731536);
$parcel$export(module.exports, "requestUsers", () => $c396037537d957cc$export$55b721778f931cc1);

var $i4N0u = parcelRequire("i4N0u");

var $bQgxR = parcelRequire("bQgxR");
const $c396037537d957cc$export$949646a1c1731536 = (baseUrl, accountId)=>(0, $i4N0u.getUser)(baseUrl, accountId).then((0, $bQgxR.transformUser));
const $c396037537d957cc$export$55b721778f931cc1 = (baseUrl, query)=>(0, $i4N0u.getUsers)(baseUrl, query).then((0, $bQgxR.transformUsers));

});
parcelRegister("i4N0u", function(module, exports) {

$parcel$export(module.exports, "getUser", () => $de20a383ad0b74fc$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUsers", () => $de20a383ad0b74fc$export$925a4945a6cd0f3e);

var $7f4tk = parcelRequire("7f4tk");
const $de20a383ad0b74fc$export$e45b57f6c6c40475 = 5;
const $de20a383ad0b74fc$export$7eaa662f51e316ae = (baseUrl)=>`${baseUrl}/rest/api/2/user`;
const $de20a383ad0b74fc$export$8df721f926f55c9a = (baseUrl, accountId = '')=>`${$de20a383ad0b74fc$export$7eaa662f51e316ae(baseUrl)}?accountId=${encodeURIComponent(accountId)}`;
const $de20a383ad0b74fc$export$715964ba85b11e2b = (baseUrl)=>`${baseUrl}/rest/api/2/user/picker`;
const $de20a383ad0b74fc$export$977bdbd87001f83 = (baseUrl, query = '')=>`${$de20a383ad0b74fc$export$715964ba85b11e2b(baseUrl)}?showAvatar=true&maxResults=${$de20a383ad0b74fc$export$e45b57f6c6c40475}&query=${query}`;
const $de20a383ad0b74fc$export$7cbf767827cd68ba = (baseUrl, accountId = '')=>(0, $7f4tk.default)($de20a383ad0b74fc$export$8df721f926f55c9a(baseUrl, accountId));
const $de20a383ad0b74fc$export$925a4945a6cd0f3e = (baseUrl, query = '')=>(0, $7f4tk.default)($de20a383ad0b74fc$export$977bdbd87001f83(baseUrl, query));

});

parcelRegister("bQgxR", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $c04a8a4571b1f523$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformUsers", () => $c04a8a4571b1f523$export$fb8c90bfc4beaa59);
const $c04a8a4571b1f523$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrls['24x24']
    });
const $c04a8a4571b1f523$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));

});


parcelRegister("8jpCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a1beea71a0796f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2a1beea71a0796f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "user-picker.error",
        "defaultMessage": "We couldn't retrieve users"
    },
    placeholder: {
        "id": "user-picker.placeholder",
        "defaultMessage": "User"
    },
    labelText: {
        "id": "user-picker.label-text",
        "defaultMessage": "User"
    }
});

});



parcelRegister("cOGXp", function(module, exports) {

$parcel$export(module.exports, "default", () => $df375eedc711ef59$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $eCeGD = parcelRequire("eCeGD");

var $iQv12 = parcelRequire("iQv12");

var $az4zD = parcelRequire("az4zD");

var $afEZu = parcelRequire("afEZu");
function $df375eedc711ef59$export$47d037774b685574(props) {
    const { onClick: onClick, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClick,
        shouldFitContainer: true
    }, formatMessage((0, $afEZu.default).label));
}
var $df375eedc711ef59$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'clearFilters'
}), (0, $az4zD.injectIntlV2))($df375eedc711ef59$export$47d037774b685574);

});
parcelRegister("afEZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c003103d44ed418f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c003103d44ed418f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "directories.filters-v2.main.content.filter.clear.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("lNjU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fecacae643758aa8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $az4zD = parcelRequire("az4zD");

var $eneeA = parcelRequire("eneeA");

var $ijnJK = parcelRequire("ijnJK");

var $4R6GH = parcelRequire("4R6GH");

var $jA8tN = parcelRequire("jA8tN");
class $fecacae643758aa8$export$ec91da630f36d5ea extends (0, $5uXOq.Component) {
    render() {
        const { renderFilterSearch: renderFilterSearch, renderOwnerPicker: renderOwnerPicker, renderProjectPicker: renderProjectPicker, renderGroupPicker: renderGroupPicker, renderClear: renderClear, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eneeA.FilterBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), {
            expandOnSmall: true
        }, renderFilterSearch({
            onChange: this.onSearchChange,
            placeholder: (0, $4R6GH.fg)('blu-7151-filters-directory-search-field-a11y') ? formatMessage((0, $jA8tN.default).searchPlaceholder) : undefined
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, renderOwnerPicker({
            onChange: this.onOwnerChange,
            placeholder: formatMessage((0, $jA8tN.default).ownerPlaceholder)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, renderProjectPicker({
            onChange: this.onProjectChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), null, renderGroupPicker({
            onChange: this.onGroupChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnJK.FilterItem), {
            expandOnSmall: true
        }, renderClear({
            onClick: this.onClear
        })));
    }
    constructor(...args){
        super(...args), // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
        this.onSearchChange = (query, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                query: query
            }, analyticsEvent);
        }, this.onOwnerChange = (owner, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                owner: owner
            }, analyticsEvent);
        }, this.onProjectChange = (project, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                project: project
            }, analyticsEvent);
        }, this.onGroupChange = (group, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                group: group
            }, analyticsEvent);
        }, this.onClear = (analyticsEvent)=>{
            this.props.onChange({
                ...this.props.initialFilter
            }, analyticsEvent);
        };
    }
}
var $fecacae643758aa8$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($fecacae643758aa8$export$ec91da630f36d5ea);

});
parcelRegister("eneeA", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $b95c1e2c9fc07d20$export$56a20ec2552ffba2);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gJlZe = parcelRequire("gJlZe");

var $dCm1o = parcelRequire("dCm1o");

const $b95c1e2c9fc07d20$export$56a20ec2552ffba2 = ({ children: children })=>{
    const [containerWidth, setContainerWidth] = (0, $5uXOq.useState)(900);
    const handleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setContainerWidth, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b95c1e2c9fc07d20$var$relativeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: handleWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b95c1e2c9fc07d20$var$filterBarSharedStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $b95c1e2c9fc07d20$var$filterBarSharedStylesVisualRefresh,
            containerWidth > (0, $3ab203d2ecb98f35$export$9cc428d7e02a0e8b) && $b95c1e2c9fc07d20$var$filterBarLargeStyles,
            containerWidth <= (0, $3ab203d2ecb98f35$export$9cc428d7e02a0e8b) && containerWidth > (0, $3ab203d2ecb98f35$export$99041d531d62aef9) && $b95c1e2c9fc07d20$var$filterBarMidStyles,
            containerWidth <= (0, $3ab203d2ecb98f35$export$99041d531d62aef9) && containerWidth > (0, $3ab203d2ecb98f35$export$54280d191a58e9f6) && $b95c1e2c9fc07d20$var$filterBarSmallStyles
        ]
    }, children));
};
const $b95c1e2c9fc07d20$var$relativeWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $b95c1e2c9fc07d20$var$filterBarSharedStyles = (0, $8CUq3.xcss)({
    width: '100%',
    display: 'grid',
    columnGap: 'space.200',
    rowGap: 'space.100',
    alignItems: 'flex-end'
});
const $b95c1e2c9fc07d20$var$filterBarSharedStylesVisualRefresh = (0, $8CUq3.xcss)({
    columnGap: 'space.100'
});
const $b95c1e2c9fc07d20$var$filterBarSmallStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'repeat(2, 1fr)'
});
const $b95c1e2c9fc07d20$var$filterBarMidStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'repeat(3, 1fr)'
});
const $b95c1e2c9fc07d20$var$filterBarLargeStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexWrap: 'wrap'
});

});
const $3ab203d2ecb98f35$export$54280d191a58e9f6 = 420;
const $3ab203d2ecb98f35$export$99041d531d62aef9 = 640;
const $3ab203d2ecb98f35$export$9cc428d7e02a0e8b = 850;
const $3ab203d2ecb98f35$export$a4477e829bcd1e02 = 200;


parcelRegister("ijnJK", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $82ad612f888d18b7$export$3cf161fcd24b6b4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $82ad612f888d18b7$export$3cf161fcd24b6b4f = ({ expandOnSmall: expandOnSmall, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: expandOnSmall ? [
            $82ad612f888d18b7$var$filterItemContainerStyles,
            $82ad612f888d18b7$var$filterItemContainerExpandedStyles
        ] : $82ad612f888d18b7$var$filterItemContainerStyles
    }, children);
};
const $82ad612f888d18b7$var$filterItemContainerStyles = (0, $8CUq3.xcss)({
    // 200px is the width commonly used for directory filters, so including it here helps
    // to ensure consistency with the existing design and gives us predictability for responsive behaviour
    minWidth: '200px'
});
const $82ad612f888d18b7$var$filterItemContainerExpandedStyles = (0, $8CUq3.xcss)({
    gridColumn: '1 / -1'
});

});

parcelRegister("jA8tN", function(module, exports) {

$parcel$export(module.exports, "default", () => $736fe18408db0791$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $736fe18408db0791$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ownerPlaceholder: {
        "id": "directories.filters-v2.main.content.filter.owner-placeholder",
        "defaultMessage": "Owner"
    },
    searchPlaceholder: {
        "id": "directories.filters-v2.main.content.filter.search-placeholder",
        "defaultMessage": "Search filters"
    },
    searchFilterAriaSearchDescription: {
        "id": "directories.filters-v2.main.content.filter.search-filter-aria-search-description",
        "defaultMessage": "The table will be filtered below as you type into the field"
    }
});

});



parcelRegister("jTnv2", function(module, exports) {

$parcel$export(module.exports, "operationModals", () => $3e826f4478fcbffd$export$fee8081fa482dfbf);
$parcel$export(module.exports, "emptyFilterResultConfiguration", () => $3e826f4478fcbffd$export$972f54d0cb76a888);
$parcel$export(module.exports, "getHeaderConfiguration", () => $3e826f4478fcbffd$export$60b0ef02721854ed);
$parcel$export(module.exports, "getTableConfiguration", () => $3e826f4478fcbffd$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $3e826f4478fcbffd$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $3e826f4478fcbffd$export$64df75861e57fb7f);

var $dGvGJ = parcelRequire("dGvGJ");

var $epVKM = parcelRequire("epVKM");


var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $e9yg4 = parcelRequire("e9yg4");

var $hXBjD = parcelRequire("hXBjD");

var $d5Jh8 = parcelRequire("d5Jh8");

var $42upA = parcelRequire("42upA");

var $bQVVy = parcelRequire("bQVVy");

var $cC4iO = parcelRequire("cC4iO");

var $1pMLe = parcelRequire("1pMLe");

var $klPHH = parcelRequire("klPHH");

var $jUOiQ = parcelRequire("jUOiQ");

var $d1Eg6 = parcelRequire("d1Eg6");

var $kA97t = parcelRequire("kA97t");

var $2xUX2 = parcelRequire("2xUX2");

var $jwPQ3 = parcelRequire("jwPQ3");

var $1XGvI = parcelRequire("1XGvI");

var $dCHeQ = parcelRequire("dCHeQ");

var $h2X1I = parcelRequire("h2X1I");
const $3e826f4478fcbffd$export$fee8081fa482dfbf = {
    [(0, $088bf273559ead46$export$92f9e1ed9114d3a6)]: (0, $2xUX2.default),
    [(0, $088bf273559ead46$export$39d2a7fb21967424)]: (0, $kA97t.default),
    [(0, $088bf273559ead46$export$250171a898bf7ef)]: (0, $1XGvI.default),
    [(0, $088bf273559ead46$export$4bd2facc4a3e6aa1)]: (0, $jwPQ3.default)
};
const $3e826f4478fcbffd$export$972f54d0cb76a888 = {
    message: (0, $h2X1I.default).emptyFilterResultMessage
};
const $3e826f4478fcbffd$export$60b0ef02721854ed = ()=>({
        ActionsView: $d5Jh8.default,
        FilterView: $dCHeQ.default,
        caption: (0, $h2X1I.default).headerCaption
    });
const $3e826f4478fcbffd$export$6847365bea1c5392 = (0, $dGvGJ.createSelector)((0, $hXBjD.getAtlassianAccountId), (atlassianAccountId)=>[
        atlassianAccountId !== undefined ? {
            title: (0, $epVKM.default),
            Cell: (0, $1pMLe.default),
            sortField: (0, $e9yg4.FAVOURITED),
            width: (0, $dCm1o.isVisualRefreshEnabled)() ? 3 : 3.1,
            isIconOnlyHeader: (0, $dCm1o.isVisualRefreshEnabled)(),
            ascendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, $h2X1I.default).starredToUnstarredOrder : undefined,
            descendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, $h2X1I.default).unstarredToStarredOrder : undefined
        } : undefined,
        {
            title: (0, $h2X1I.default).filter,
            Cell: (0, $d1Eg6.default),
            sortField: (0, $e9yg4.NAME),
            // eslint-disable-next-line no-nested-ternary
            width: atlassianAccountId ? (0, $dCm1o.isVisualRefreshEnabled)() ? 23.6 : 22 : 25,
            ascendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, $h2X1I.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, $h2X1I.default).zToAOrder : undefined
        },
        atlassianAccountId !== undefined ? {
            title: (0, $h2X1I.default).owner,
            Cell: (0, $klPHH.default),
            sortField: (0, $e9yg4.OWNER),
            width: 20,
            ascendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, $h2X1I.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, $h2X1I.default).zToAOrder : undefined
        } : undefined,
        {
            title: (0, $h2X1I.default).viewers,
            Cell: (0, $42upA.default),
            width: atlassianAccountId ? 20 : 30
        },
        {
            title: (0, $h2X1I.default).editors,
            Cell: (0, $cC4iO.default),
            width: atlassianAccountId ? 20 : 30
        },
        {
            title: (0, $h2X1I.default).popularity,
            Cell: (0, $jUOiQ.default),
            sortField: (0, $e9yg4.POPULARITY),
            width: atlassianAccountId ? 10 : 15,
            ascendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, $h2X1I.default).lowestToHighestOrder : undefined,
            descendingSortTooltip: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? (0, $h2X1I.default).highestToLowestOrder : undefined
        },
        atlassianAccountId !== undefined ? {
            title: (0, $h2X1I.default).actions,
            Cell: (0, $bQVVy.default),
            width: 3.4,
            dataTestId: 'filters-main.content.headerCell.actions.container'
        } : undefined
    ].filter(Boolean));
const $3e826f4478fcbffd$export$b2d196af18e06ad6 = ()=>(0, $h2X1I.default).tableAriaLabel;
const $3e826f4478fcbffd$export$64df75861e57fb7f = ()=>(0, $h2X1I.default).filterResultsAnnouncement;

});
parcelRegister("epVKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b567d1c855c884$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAf5R = parcelRequire("dAf5R");

var $5IcUR = parcelRequire("5IcUR");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $75Uq1 = parcelRequire("75Uq1");
const $f7b567d1c855c884$var$StarTitleCell = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $dCm1o.isVisualRefreshEnabled)() && !(0, $4R6GH.fg)('visual-refresh_drop_6')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5IcUR))),
        LEGACY_size: "small",
        label: formatMessage((0, $75Uq1.messages).starred)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5IcUR))), {
        LEGACY_size: "small",
        label: formatMessage((0, $75Uq1.messages).starred)
    });
};
var $f7b567d1c855c884$export$2e2bcd8739ae039 = $f7b567d1c855c884$var$StarTitleCell;

});
parcelRegister("75Uq1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8eb82dc6fef00b40$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8eb82dc6fef00b40$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starred: {
        "id": "directories.common.components.star-title-cell.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("d5Jh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bb68f8de4f998d$export$2e2bcd8739ae039);

var $l2xCT = parcelRequire("l2xCT");

var $bC2fB = parcelRequire("bC2fB");

var $hXBjD = parcelRequire("hXBjD");
const $f1bb68f8de4f998d$var$mapStateToProps = (state)=>({
        baseUrl: (0, $hXBjD.getBaseUrl)(state)
    });
var $f1bb68f8de4f998d$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f1bb68f8de4f998d$var$mapStateToProps, {})((0, $l2xCT.default));

});
parcelRegister("l2xCT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ade654b56edd64f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $fVnbM = parcelRequire("fVnbM");

var $iQv12 = parcelRequire("iQv12");

var $8RXs9 = parcelRequire("8RXs9");

var $hjSul = parcelRequire("hjSul");

var $3s2qa = parcelRequire("3s2qa");
const $4ade654b56edd64f$export$6d3c345ce7c38fd9 = ({ onClick: onClick, intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        onClick: onClick,
        appearance: "primary",
        // @ts-expect-error - TS2322 - Type '{ children: string; href: string; onClick: (() => void) | undefined; appearance: "primary"; externalId: string; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        externalId: "directory.filters-v2.create-button",
        component: (0, $hjSul.Link)
    }, formatMessage((0, $3s2qa.default).createFilter));
var $4ade654b56edd64f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'createFilter'
}), (0, $8RXs9.default))($4ade654b56edd64f$export$6d3c345ce7c38fd9);

});
parcelRegister("3s2qa", function(module, exports) {

$parcel$export(module.exports, "default", () => $82baf4f5409c8685$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82baf4f5409c8685$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createFilter: {
        "id": "create-filter-button.create-filter",
        "defaultMessage": "Create filter"
    }
});

});



parcelRegister("42upA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcc7362652b343e6$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $b9OA0 = parcelRequire("b9OA0");

var $5V4zU = parcelRequire("5V4zU");
const $dcc7362652b343e6$var$mapStateToProps = ()=>(state, ownProps)=>({
            shares: (0, $b9OA0.getShares)(state, ownProps.id)
        });
var $dcc7362652b343e6$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($dcc7362652b343e6$var$mapStateToProps, {})((0, $5V4zU.default));

});
parcelRegister("5V4zU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6688a85a9f546f65$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $bP37O = parcelRequire("bP37O");

var $3G2gB = parcelRequire("3G2gB");

var $icDh5 = parcelRequire("icDh5");

var $kFO36 = parcelRequire("kFO36");

var $4GsX0 = parcelRequire("4GsX0");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $az4zD = parcelRequire("az4zD");


var $dCm1o = parcelRequire("dCm1o");

var $bNpnm = parcelRequire("bNpnm");
const $6688a85a9f546f65$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
class $6688a85a9f546f65$export$3026e5a52c747d2c extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            shares: []
        };
    }
    static renderAvatar(text, avatarUrl, idx, appearance = 'square', hasMultipleProjectRoles) {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            size: "small",
            src: avatarUrl,
            appearance: appearance
        })), (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: hasMultipleProjectRoles ? $6688a85a9f546f65$var$styles.textContainerMultipleRoles : $6688a85a9f546f65$var$styles.textContainerSingleRole
        }, text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$TextContainer, null, text));
        return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            key: idx,
            alignItems: "center",
            xcss: hasMultipleProjectRoles ? $6688a85a9f546f65$var$styles.avatarContainerMultipleRoles : $6688a85a9f546f65$var$styles.avatarContainerSingleRole
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$Container, {
            key: idx
        }, content);
    }
    static renderIcon(text, IconComponent, idx = 1) {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconComponent, {
            size: "medium",
            label: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$TextContainer, null, text));
        return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            key: idx,
            alignItems: "center",
            xcss: $6688a85a9f546f65$var$styles.iconContainerWrapper
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$Container, {
            key: idx
        }, content);
    }
    render() {
        const { shares: shares, intl: { formatMessage: formatMessage } } = this.props;
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shares.length > 0 ? shares.map((share, idx)=>{
            switch(share.type){
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    return $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $bNpnm.default).myOrganizationAccess), (0, (/*@__PURE__*/$parcel$interopDefault($icDh5))), idx);
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    return $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $bNpnm.default).publicAccess), (0, (/*@__PURE__*/$parcel$interopDefault($4GsX0))), idx);
                case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    return $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(share.group.name || '', (0, (/*@__PURE__*/$parcel$interopDefault($kFO36))), idx);
                case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                    {
                        const roleName = share.role ? share.role.name : formatMessage((0, $bNpnm.default).allProjectRoles);
                        const text = `${share.project.name}, ${roleName}`;
                        return $6688a85a9f546f65$export$3026e5a52c747d2c.renderAvatar(text, share.project.avatarUrl, idx, 'square', shares.length > 1);
                    }
                case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                    return $6688a85a9f546f65$export$3026e5a52c747d2c.renderAvatar(share.user.displayName, share.user.avatarUrl, idx, 'circle', false);
                case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    return $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $bNpnm.default).unknownProject), (0, (/*@__PURE__*/$parcel$interopDefault($bP37O))), idx);
                default:
                    $6688a85a9f546f65$var$assertUnreachable(share);
                    return null;
            }
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $bNpnm.default).privateAccess), (0, (/*@__PURE__*/$parcel$interopDefault($3G2gB)))));
        return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            direction: "column"
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$CellContainer, null, content);
    }
}
var $6688a85a9f546f65$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($6688a85a9f546f65$export$3026e5a52c747d2c);
const $6688a85a9f546f65$var$styles = {
    avatarContainerMultipleRoles: "_n3tdu2gc _4t3i1wug",
    avatarContainerSingleRole: "_n3tdze3t _4t3i1ylp",
    iconContainerWrapper: "_4t3i1ylp",
    textContainerMultipleRoles: "_1reo15vq _18m915vq _slp31hna _16jlkb7n",
    textContainerSingleRole: "_1reo15vq _18m915vq _slp31hna _16jlkb7n _1bto1l2s _o5721q9c"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6688a85a9f546f65$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6688a85a9f546f65$var$AvatarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3u2gc _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6688a85a9f546f65$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv77o _u5f3utpp _n3tdv77o _19bvv77o _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6688a85a9f546f65$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _slp31hna _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6688a85a9f546f65$var$CellContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q12x7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});


parcelRegister("icDh5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d407d01834f2f44a$var$_react = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d407d01834f2f44a$var$_officeBuilding = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("4bTdk")));
function $d407d01834f2f44a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d407d01834f2f44a$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $d407d01834f2f44a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
    }, props, {
        newIcon: $d407d01834f2f44a$var$_officeBuilding.default
    }));
$d407d01834f2f44a$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $d407d01834f2f44a$var$_default = module.exports.default = $d407d01834f2f44a$var$OfficeBuildingIcon;

});
parcelRegister("4bTdk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30d304d6d8375db3$var$_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $30d304d6d8375db3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;

});


parcelRegister("4GsX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36918aadf9f6e08c$var$_react = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36918aadf9f6e08c$var$_globe = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("9x5pH")));
function $36918aadf9f6e08c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36918aadf9f6e08c$var$WorldIcon = (props)=>/*#__PURE__*/ $36918aadf9f6e08c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props, {
        newIcon: $36918aadf9f6e08c$var$_globe.default
    }));
$36918aadf9f6e08c$var$WorldIcon.displayName = 'WorldIcon';
var $36918aadf9f6e08c$var$_default = module.exports.default = $36918aadf9f6e08c$var$WorldIcon;

});

parcelRegister("bNpnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bb30c4c1fbe3078$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4bb30c4c1fbe3078$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    myOrganizationAccess: {
        "id": "directories.filters-v2.main.content.cells.access.my-organization-access",
        "defaultMessage": "My organization"
    },
    publicAccess: {
        "id": "directories.filters-v2.main.content.cells.access.public-access",
        "defaultMessage": "Public"
    },
    privateAccess: {
        "id": "directories.filters-v2.main.content.cells.access.private-access",
        "defaultMessage": "Private"
    },
    allProjectRoles: {
        "id": "directories.filters-v2.main.content.cells.access.all-project-roles",
        "defaultMessage": "All roles"
    },
    unknownProject: {
        "id": "directories.filters-v2.main.content.cells.access.unknown-project",
        "defaultMessage": "Unknown project"
    }
});

});



parcelRegister("bQVVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $538f3a4e79245c2a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");


var $bC2fB = parcelRequire("bC2fB");

var $4R6GH = parcelRequire("4R6GH");

var $kWgA3 = parcelRequire("kWgA3");

var $hXBjD = parcelRequire("hXBjD");

var $3t4xG = parcelRequire("3t4xG");

var $b9OA0 = parcelRequire("b9OA0");

var $hIjLa = parcelRequire("hIjLa");
const $538f3a4e79245c2a$var$mapStateToPropsFactory = ()=>{
    const onCopyFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$92f9e1ed9114d3a6)));
    const onEditFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$250171a898bf7ef)));
    const onChangeOwnerFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$39d2a7fb21967424)));
    const onDeleteFactory = (0, $8QpSo.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $088bf273559ead46$export$4bd2facc4a3e6aa1)));
    return (state, ownProps)=>({
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onEdit: onEditFactory(ownProps.onOperationRequested),
            onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            manageSubscriptionsUrl: (0, $b9OA0.manageSubscriptionsUrl)(state, ownProps.id),
            name: (0, $4R6GH.fg)('blu-6202-directories-a11y-fixes') ? (0, $b9OA0.getName)(state, ownProps.id) : undefined,
            owner: (0, $b9OA0.getOwner)(state, ownProps.id),
            atlassianAccountId: (0, $hXBjD.getAtlassianAccountId)(state),
            showSpinner: ownProps.isOperationInProgress,
            isCopyFilterModalOpen: (0, $3t4xG.isCopyFilterModalOpen)(state),
            isWritable: (0, $b9OA0.getIsWritable)(state, ownProps.id),
            isAdmin: (0, $hXBjD.getIsAdmin)(state)
        });
};
const $538f3a4e79245c2a$var$mapDispatchToProps = {
    onOpenCopyFilterModal: (0, $kWgA3.openCopyFilterModal)
};
var $538f3a4e79245c2a$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($538f3a4e79245c2a$var$mapStateToPropsFactory, $538f3a4e79245c2a$var$mapDispatchToProps)((0, $hIjLa.default));

});
parcelRegister("3t4xG", function(module, exports) {

$parcel$export(module.exports, "isCopyFilterModalOpen", () => $e76778399f10c63b$export$d4543442696c05ca);
const $e76778399f10c63b$export$d4543442696c05ca = (state)=>state.copyFilterModal.isCopyFilterModalOpen;

});

parcelRegister("hIjLa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d4d760a041a480$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $iQv12 = parcelRequire("iQv12");

var $8oe80 = parcelRequire("8oe80");

var $8RXs9 = parcelRequire("8RXs9");

var $4R6GH = parcelRequire("4R6GH");

var $lu5k0 = parcelRequire("lu5k0");

var $7mPT9 = parcelRequire("7mPT9");

var $lM5Su = parcelRequire("lM5Su");
const $d9d4d760a041a480$var$styles = {
    container: "_1e0c1txw _1bahesu3 _ca0q1b66 _u5f3v77o _n3tdze3t _19bvze3t",
    spinnerContainer: "_4t3i7vkz _1bsb1tcg"
};
const $d9d4d760a041a480$var$DropdownMenuWithAnalytics = (0, $8oe80.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $BLPHT.default));
const $d9d4d760a041a480$var$DropdownItemWithAnalytics = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default)); // eslint-disable-next-line jira/react/no-class-components
class $d9d4d760a041a480$var$Actions extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isWritable: false,
            defaultOpen: false,
            showSpinner: false,
            manageSubscriptionsUrl: '',
            name: undefined,
            owner: null,
            onCopy: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeOwner: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            setReturnFocusTo: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isCopyFilterModalOpen && this.state.isCopyFilterModalOpen && !this.props.isCopyFilterModalOpen) this.setState({
            isCopyFilterModalOpen: false
        }, ()=>{
            if (this.triggerButtonRef && this.triggerButtonRef.current) this.triggerButtonRef.current.focus();
        });
    }
    delayedClose() {
        setTimeout(()=>this.setState(()=>({
                    isOpen: false
                })));
    }
    render() {
        const { showSpinner: showSpinner, intl: { formatMessage: formatMessage }, manageSubscriptionsUrl: manageSubscriptionsUrl, atlassianAccountId: atlassianAccountId, name: name, owner: owner, isWritable: isWritable, isAdmin: isAdmin } = this.props;
        const isOwner = owner && owner.accountId === atlassianAccountId;
        const { isOpen: isOpen } = this.state; // @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
        const triggerFunction = ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                ref: (0, $7mPT9.mergeRefs)(triggerRef, this.triggerButtonRef),
                isLoading: showSpinner,
                label: name && (0, $4R6GH.fg)('blu-6202-directories-a11y-fixes') ? formatMessage((0, $lM5Su.default).tooltipWithName, {
                    name: name
                }) : formatMessage((0, $lM5Su.default).tooltip)
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $d9d4d760a041a480$var$styles.container
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownMenuWithAnalytics // @ts-expect-error - Type '{ children: Element; position: string; isOpen: boolean; onOpenChange: ({ isOpen }: { isOpen: any; }) => void; trigger: ({ triggerRef, ...props }: { [x: string]: any; triggerRef: any; }) => Element; }' is not assignable to type 'IntrinsicAttributes & Omit<{ appearance?: "default" | "tall" | undefined; autoFocus?: boolean | undefined; children?: ReactNode; isLoading?: boolean | undefined; ... 11 more ...; label?: string | undefined; }, keyof WithAnalyticsEventsProps>'.
        , {
            position: "bottom right",
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: (0, $4R6GH.fg)('blu-6202-directories-a11y-fixes')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
            href: manageSubscriptionsUrl,
            onClick: this.onManageSubscriptionsClick
        }, formatMessage((0, $lM5Su.default).manageAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
            onClick: this.onCopyFilterClick
        }, formatMessage((0, $lM5Su.default).copyAction)), (isWritable || isOwner === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
            onClick: this.onEditFilterClick
        }, formatMessage((0, $lM5Su.default).editFilter)), (isOwner === true || isAdmin === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
            onClick: this.onChangeOwnerFilterClick
        }, formatMessage((0, $lM5Su.default).changeOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
            onClick: this.onDeleteFilterClick
        }, formatMessage((0, $lM5Su.default).deleteFilter))))));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: this.props.defaultOpen,
            isCopyFilterModalOpen: false
        }, this.triggerButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)() // @ts-expect-error - TS7031 - Binding element 'isOpen' implicitly has an 'any' type.
        , this.onOpenChange = ({ isOpen: isOpen })=>{
            this.setState(()=>({
                    isOpen: isOpen
                }));
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onCopyFilterClick = (e, analytics)=>{
            this.props.onCopyFilterClick(analytics);
            this.props.onCopy();
            this.props.onOpenCopyFilterModal();
            this.setState(()=>({
                    isCopyFilterModalOpen: true
                }));
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onManageSubscriptionsClick = (e, analytics)=>{
            this.props.onManageSubscriptionsClick(analytics);
            this.delayedClose();
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onEditFilterClick = (e, analytics)=>{
            this.props.onEditFilterClick(analytics);
            this.props.onEdit();
            this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onChangeOwnerFilterClick = (e, analytics)=>{
            this.props.onChangeOwnerFilterClick(analytics);
            this.props.onChangeOwner();
            if ((0, $4R6GH.fg)('jfp_a11y_fix_filters_change_owner_modal_focus')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onDeleteFilterClick = (e, analytics)=>{
            this.props.onDeleteFilterClick(analytics);
            this.props.onDelete();
            this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        } /**
      * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
      * In its current implementation if we close the menu right away it won't open the focused `href`.
      * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
      * @see https://ecosystem.atlassian.net/browse/AK-4467
      */ ;
    }
}
const $d9d4d760a041a480$var$ActionsWithReturnToFocus = (props)=>{
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$Actions, {
        ...props,
        setReturnFocusTo: setReturnFocusTo
    });
};
var $d9d4d760a041a480$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8RXs9.default), (0, $iQv12.default)({
    onManageSubscriptionsClick: 'manageSubscriptions',
    onCopyFilterClick: 'copy',
    onChangeOwnerFilterClick: 'changeOwner',
    onEditFilterClick: 'edit',
    onDeleteFilterClick: 'delete'
}))($d9d4d760a041a480$var$ActionsWithReturnToFocus);

});
parcelRegister("lu5k0", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $5f429bdcb9dbbc95$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $49R2H = parcelRequire("49R2H");

var $a3Qjd = parcelRequire("a3Qjd");

var $kIxMH = parcelRequire("kIxMH");
const $5f429bdcb9dbbc95$var$Store = (0, $iXqE5.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $49R2H.initialState,
    actions: $a3Qjd.actions
});
const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, $3sQ5x.createActionsHook)($5f429bdcb9dbbc95$var$Store);
const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, $3sQ5x.createStateHook)($5f429bdcb9dbbc95$var$Store, {
    selector: (0, $kIxMH.getReturnFocusTo)
});

});
parcelRegister("49R2H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $1a3a816977643252$export$d4c72bab9d6cc13a);
const $1a3a816977643252$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("a3Qjd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1886bc9c17d47b9b$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $1886bc9c17d47b9b$export$e324594224ef24da = {
    setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
};

});

parcelRegister("kIxMH", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $cd4eb273a1fc9e15$export$d5f8692765ccd209);
const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});


parcelRegister("lM5Su", function(module, exports) {

$parcel$export(module.exports, "default", () => $2340d0326caef0c6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2340d0326caef0c6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyAction: {
        "id": "directories.filters-v2.main.content.cells.actions.copy-action",
        "defaultMessage": "Copy filter"
    },
    editFilter: {
        "id": "directories.filters-v2.main.content.cells.actions.edit-filter",
        "defaultMessage": "Edit"
    },
    changeOwner: {
        "id": "directories.filters-v2.main.content.cells.actions.change-owner",
        "defaultMessage": "Change owner"
    },
    deleteFilter: {
        "id": "directories.filters-v2.main.content.cells.actions.delete-filter",
        "defaultMessage": "Delete"
    },
    manageAction: {
        "id": "directories.filters-v2.main.content.cells.actions.manage-action",
        "defaultMessage": "Manage subscriptions"
    },
    tooltip: {
        "id": "directories.filters-v2.main.content.cells.actions.tooltip",
        "defaultMessage": "More"
    },
    tooltipWithName: {
        "id": "directories.filters-v2.main.content.cells.actions.tooltip-with-name",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("cC4iO", function(module, exports) {

$parcel$export(module.exports, "default", () => $26019ad53a262e9c$export$2e2bcd8739ae039);

var $3pUkE = parcelRequire("3pUkE");

var $bC2fB = parcelRequire("bC2fB");

var $b9OA0 = parcelRequire("b9OA0");
const $26019ad53a262e9c$var$mapStateToProps = (state, ownProps)=>({
        shares: (0, $b9OA0.getEdits)(state, ownProps.id)
    });
var $26019ad53a262e9c$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($26019ad53a262e9c$var$mapStateToProps, // We attempted to fix the below FixFlowMe but ran into issue with cross package dependencies which we do not want
// to introduce. We believe the unused fields in Props causes the below issue.
{})((0, $3pUkE.default));

});
parcelRegister("3pUkE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f5f0405f4933c54$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3G2gB = parcelRequire("3G2gB");

var $icDh5 = parcelRequire("icDh5");

var $kFO36 = parcelRequire("kFO36");

var $4GsX0 = parcelRequire("4GsX0");

var $az4zD = parcelRequire("az4zD");


var $3pSGI = parcelRequire("3pSGI");
const $6f5f0405f4933c54$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
class $6f5f0405f4933c54$export$3026e5a52c747d2c extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            shares: []
        };
    }
    static renderAvatar(text, avatarUrl, idx, appearance) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$Container, {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            size: "small",
            src: avatarUrl,
            appearance: appearance
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$TextContainer, null, text));
    }
    static renderIcon(text, IconComponent, idx = 1) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$Container, {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconComponent, {
            label: "",
            size: "medium"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$TextContainer, null, text));
    }
    render() {
        const { shares: shares, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$CellContainer, null, shares.length > 0 ? shares.map((share, idx)=>{
            switch(share.type){
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $3pSGI.default).myOrganizationAccess), // @ts-expect-error - TS2345 - Argument of type 'typeof default' is not assignable to parameter of type 'ComponentType<{ size: "medium"; label: ""; }>'.
                    (0, (/*@__PURE__*/$parcel$interopDefault($icDh5))), idx);
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $3pSGI.default).publicAccess), // @ts-expect-error - TS2345 - Argument of type 'typeof default' is not assignable to parameter of type 'ComponentType<{ size: "medium"; label: ""; }>'.
                    (0, (/*@__PURE__*/$parcel$interopDefault($4GsX0))), idx);
                case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                    // @ts-expect-error - TS2345 - Argument of type 'typeof default' is not assignable to parameter of type 'ComponentType<{ size: "medium"; label: ""; }>'.
                    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                    return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(share.group.name, (0, (/*@__PURE__*/$parcel$interopDefault($kFO36))), idx);
                case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                    return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderAvatar(share.user.displayName, share.user.avatarUrl, idx, 'circle');
                case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                    {
                        const roleName = share.role ? share.role.name : formatMessage((0, $3pSGI.default).allProjectRoles);
                        const text = `${share.project.name}, ${roleName}`;
                        return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderAvatar(text, share.project.avatarUrl, idx, 'square');
                    }
                case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                    return null;
                // hide from the list
                default:
                    $6f5f0405f4933c54$var$assertUnreachable(share);
                    return null;
            }
        }) : // @ts-expect-error - TS2345 - Argument of type 'typeof default' is not assignable to parameter of type 'ComponentType<{ size: "medium"; label: ""; }>'.
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $3pSGI.default).privateAccess), (0, (/*@__PURE__*/$parcel$interopDefault($3G2gB)))));
    }
}
var $6f5f0405f4933c54$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($6f5f0405f4933c54$export$3026e5a52c747d2c);
const $6f5f0405f4933c54$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f5f0405f4933c54$var$AvatarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3u2gc _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f5f0405f4933c54$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv77o _u5f3utpp _n3tdv77o _19bvv77o _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f5f0405f4933c54$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _slp31hna _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f5f0405f4933c54$var$CellContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q12x7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3pSGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7c2aa888a93a27$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9b7c2aa888a93a27$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    myOrganizationAccess: {
        "id": "directories.common.components.access-cell.my-organization-access",
        "defaultMessage": "My organization"
    },
    publicAccess: {
        "id": "directories.common.components.access-cell.public-access",
        "defaultMessage": "Public"
    },
    privateAccess: {
        "id": "directories.common.components.access-cell.private-access",
        "defaultMessage": "Private"
    },
    allProjectRoles: {
        "id": "directories.common.components.access-cell.all-project-roles",
        "defaultMessage": "All roles"
    }
});

});



parcelRegister("1pMLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc6f54e837af54bb$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");

var $jzjy1 = parcelRequire("jzjy1");

var $in0Fz = parcelRequire("in0Fz");

var $bC2fB = parcelRequire("bC2fB");

var $b9OA0 = parcelRequire("b9OA0");
const $bc6f54e837af54bb$var$mapStateToPropsFactory = ()=>{
    const onClickFactory = (0, $8QpSo.default)((state, id)=>(analyticsEvent)=>{
            const changeFavorite = (0, $b9OA0.getChangeFavorite)(state);
            return changeFavorite ? changeFavorite({
                id: id,
                type: 'filters',
                value: !(0, $b9OA0.isFavorite)(state, id)
            }, analyticsEvent) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        });
    return (state, ownProps)=>({
            isFavorite: (0, $b9OA0.isFavorite)(state, ownProps.id),
            favoriteItemName: (0, $b9OA0.getName)(state, ownProps.id),
            id: ownProps.id,
            onClick: onClickFactory(state, ownProps.id),
            pending: (0, $b9OA0.isPending)(state, ownProps.id),
            isShownInList: true
        });
};
var $bc6f54e837af54bb$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)('filter'), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $bC2fB.connect)($bc6f54e837af54bb$var$mapStateToPropsFactory, {}))((0, $in0Fz.FavoriteCellView));

});
parcelRegister("in0Fz", function(module, exports) {

$parcel$export(module.exports, "FavoriteCellView", () => $6abb13e9102dee85$export$7e4dcb8ef4c4afcd);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hcObS = parcelRequire("hcObS");

var $dCm1o = parcelRequire("dCm1o");
const $6abb13e9102dee85$var$styles = {
    root: "_1e0c1txw _1bah1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $6abb13e9102dee85$export$7e4dcb8ef4c4afcd(props) {
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6abb13e9102dee85$var$rootStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $6abb13e9102dee85$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), props));
}
$6abb13e9102dee85$export$7e4dcb8ef4c4afcd.defaultProps = {
    isFavorite: undefined
};
const $6abb13e9102dee85$var$rootStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingInline: 'space.050',
    paddingBlock: 'space.100',
    alignItems: 'center',
    height: '40px',
    width: '32px'
});

});


parcelRegister("klPHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $069f9742a580df5e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7dpkb = parcelRequire("7dpkb");

var $bC2fB = parcelRequire("bC2fB");

var $b9OA0 = parcelRequire("b9OA0");
const $069f9742a580df5e$var$mapStateToProps = (state, ownProps)=>({
        user: (0, $b9OA0.getOwner)(state, ownProps.id)
    });
const $069f9742a580df5e$var$UserCell = (props)=>{
    const { user: user } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7dpkb.default), {
        user: user
    });
};
$069f9742a580df5e$var$UserCell.defaultProps = {
    onClick: null
};
var // @ts-expect-error - TS2345 - Argument of type '{ (props: UserCellProps): JSX.Element; defaultProps: { onClick: null; }; }' is not assignable to parameter of type 'Component<EntityCellProps & Props>'.
$069f9742a580df5e$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($069f9742a580df5e$var$mapStateToProps, {})($069f9742a580df5e$var$UserCell);

});
parcelRegister("7dpkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b027fe8ebdaa54a8$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $dqcdn = parcelRequire("dqcdn");
var $b027fe8ebdaa54a8$export$2e2bcd8739ae039 = (0, $iQv12.default)({
    onClick: 'userProfile'
})((0, $dqcdn.default));

});
parcelRegister("dqcdn", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1d1c3ed200d230$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2QW4M = parcelRequire("2QW4M");

var $4R6GH = parcelRequire("4R6GH");

var $9nJ7V = parcelRequire("9nJ7V");
function $dc1d1c3ed200d230$export$2e2bcd8739ae039(props) {
    const { user: user, isDeleting: isDeleting } = props;
    if (!user) return null;
    const { accountId: accountId, displayName: displayName, avatarUrl: avatarUrl } = user;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nJ7V.default), {
        displayName: displayName,
        avatarUrl: avatarUrl,
        isDeleting: isDeleting
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QW4M.AsyncProfileCardNext), {
        accountId: accountId,
        prepopulatedData: (0, $4R6GH.fg)('blu-7425-update-avatar-cell-aria-label') ? {
            fullName: displayName
        } : undefined
    }, content);
}

});
parcelRegister("2QW4M", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $155c7596e61d6af0$export$a3c0845f856d4292);
$parcel$export(module.exports, "default", () => $155c7596e61d6af0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $155c7596e61d6af0$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("cRK6J")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/ui/profilecard/index.tsx"
});
const $155c7596e61d6af0$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($155c7596e61d6af0$var$LazyComponent, props)));
var $155c7596e61d6af0$export$2e2bcd8739ae039 = $155c7596e61d6af0$export$a3c0845f856d4292;

});
parcelRegister("gcl1l", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $ecfe970d67067a10$export$c7209ce2e0d060ea);

var $bCf8q = parcelRequire("bCf8q");
const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $bCf8q.isLoaderError)(error)
    });

});

parcelRegister("cRK6J", function(module, exports) {

let $95de334630c2579a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $95de334630c2579a$var$load("ffQaD"),
    $95de334630c2579a$var$load("kvRbA"),
    $95de334630c2579a$var$load("76n7a"),
    $95de334630c2579a$var$load("l253H"),
    $95de334630c2579a$var$load("czifk")
]).then(()=>parcelRequire('kKeZ6'));

});


parcelRegister("9nJ7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $37198d620d9c114f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $7caFU = parcelRequire("7caFU");
const $37198d620d9c114f$var$styles = {
    avatarContainer: "_16jlidpf _1o9zidpf _i0dl1wug _u5f3u2gc _vwz4idpf",
    avatarContainerNew: "_4cvr1h6o",
    container: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0q12x7 _n3td12x7 _1e0c1txw",
    contentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bsb1osq",
    contentContainerOld: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
    accessibleContentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0qu2gc _n3tdu2gc _1e0c1txw _4cvr1h6o _1bsb1osq",
    link: "_1bsb1osq",
    textContainer: "_1reo15vq _18m915vq _slp31hna _o5721q9c _1bto1l2s"
};
function $37198d620d9c114f$export$2e2bcd8739ae039(props) {
    const { avatarUrl: avatarUrl, displayName: displayName, href: href, appearance: appearance, isDeleting: isDeleting, onClick: onClick } = props;
    // To vertically align the avatar with the text and also change the height of the cell from 44px to 40px -  BLU-7380
    const applyVisualRefreshStyles = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('blu-7380-update-directory-table-cell-height');
    const content = !href && (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ $5uXOq.createElement((0, $kgoHi.default), {
        alignItems: applyVisualRefreshStyles ? 'center' : 'start',
        xcss: applyVisualRefreshStyles ? $37198d620d9c114f$var$contentWrapperStyles : $37198d620d9c114f$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.avatarContainer,
            applyVisualRefreshStyles && $37198d620d9c114f$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        xcss: !applyVisualRefreshStyles ? $37198d620d9c114f$var$inlineTextStyles : undefined
    }, isDeleting && (0, $4R6GH.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $5uXOq.createElement((0, $7caFU.default), null, displayName) : displayName)) : /*#__PURE__*/ $5uXOq.createElement($37198d620d9c114f$var$Content, null, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.avatarContainer,
            applyVisualRefreshStyles && $37198d620d9c114f$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.textContainer
        ])
    }, isDeleting && (0, $4R6GH.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $5uXOq.createElement((0, $7caFU.default), null, displayName, " ") : displayName));
    if (href) return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.container
        ])
    }, isDeleting && (0, $4R6GH.fg)('hix-6302_project_delete_improvements') ? content : /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.link
        ])
    }, (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: applyVisualRefreshStyles ? $37198d620d9c114f$var$contentWrapperStyles : $37198d620d9c114f$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: displayName,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $41j30.default), {
        href: href,
        onClick: onClick
    }, content))) : /*#__PURE__*/ $5uXOq.createElement((0, $41j30.default), {
        href: href,
        onClick: onClick
    }, content)));
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? $37198d620d9c114f$var$styles.contentContainer : $37198d620d9c114f$var$styles.contentContainerOld
        ])
    }, content);
}
$37198d620d9c114f$export$2e2bcd8739ae039.defaultProps = {
    avatarUrl: undefined,
    href: undefined,
    appearance: 'circle',
    onClick: undefined
};
const $37198d620d9c114f$var$Content = (props)=>{
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $37198d620d9c114f$var$accessibleContentContainerStyles
    }, props.children) : /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $37198d620d9c114f$var$styles.accessibleContentContainer
        ])
    }, props.children);
};
const $37198d620d9c114f$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.075'
});
const $37198d620d9c114f$var$contentWrapperStylesOld = (0, $8CUq3.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.100'
});
const $37198d620d9c114f$var$inlineTextStyles = (0, $8CUq3.xcss)({
    paddingBlockStart: 'space.025'
});
const $37198d620d9c114f$var$accessibleContentContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    width: '100%',
    height: '40px'
});

});
parcelRegister("7caFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a3f9892d56c955$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $45a3f9892d56c955$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $45a3f9892d56c955$var$disabledBoxStyles
    }, children);
}
const $45a3f9892d56c955$var$disabledBoxStyles = (0, $8CUq3.xcss)({
    display: 'contents',
    color: 'color.text.disabled',
    ':hover': {
        cursor: 'default'
    }
});

});





parcelRegister("jUOiQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $32cae55d1651d4bb$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $b9OA0 = parcelRequire("b9OA0");

var $iVFHn = parcelRequire("iVFHn");
const $32cae55d1651d4bb$var$mapStateToProps = ()=>(state, ownProps)=>({
            popularity: (0, $b9OA0.getPopularity)(state, ownProps.id)
        });
var $32cae55d1651d4bb$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($32cae55d1651d4bb$var$mapStateToProps, {})((0, $iVFHn.default));

});
parcelRegister("iVFHn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3a80abb914b0f96$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $fptXw = parcelRequire("fptXw");
function $b3a80abb914b0f96$var$Popularity(props) {
    const { popularity: popularity, intl: { formatMessage: formatMessage } } = props;
    const content = formatMessage((0, $fptXw.default).popularity, {
        popularity: popularity
    });
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        direction: "row",
        xcss: $b3a80abb914b0f96$var$styles.containerStyles
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3a80abb914b0f96$var$Container, null, content);
}
const $b3a80abb914b0f96$var$styles = {
    containerStyles: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1bsb1osq _o5721q9c _1bto1l2s _4t3i1ylp"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b3a80abb914b0f96$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});
var $b3a80abb914b0f96$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($b3a80abb914b0f96$var$Popularity);

});
parcelRegister("fptXw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4b1ef608e1b5649$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c4b1ef608e1b5649$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    popularity: {
        "id": "directories.filters-v2.main.content.cells.popularity.popularity",
        "defaultMessage": "{popularity, plural, one {{popularity} person} other {{popularity} people}}"
    }
});

});



parcelRegister("d1Eg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $913a97de0f9c06f2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $ff0tU = parcelRequire("ff0tU");

var $asoHC = parcelRequire("asoHC");

var $bC2fB = parcelRequire("bC2fB");

var $b9OA0 = parcelRequire("b9OA0");
const $913a97de0f9c06f2$var$TitleLink = ({ caption: caption, href: href, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoHC.TransitionComponent), {
        href: href,
        onClick: onClick
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ff0tU.default), {
            ...props,
            caption: caption
        }));
const $913a97de0f9c06f2$var$mapStateToProps = ()=>(state, ownProps)=>({
            caption: (0, $b9OA0.getName)(state, ownProps.id),
            href: (0, $b9OA0.getViewUrl)(state, ownProps.id)
        });
var $913a97de0f9c06f2$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: 'filter'
}), (0, $bC2fB.connect)($913a97de0f9c06f2$var$mapStateToProps, {}))($913a97de0f9c06f2$var$TitleLink);

});
parcelRegister("ff0tU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c2d361e5e2d6e3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");
function $c9c2d361e5e2d6e3$export$2e2bcd8739ae039({ caption: caption, href: href, onClick: onClick, ...props }) {
    const content = (0, $5uXOq.useMemo)(()=>{
        const innerContent = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
            href: href,
            onClick: onClick
        }, caption) : caption;
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c9c2d361e5e2d6e3$var$wrapperStyles
        }, innerContent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9c2d361e5e2d6e3$var$Container, props, innerContent);
    }, [
        caption,
        href,
        onClick,
        props
    ]);
    return (0, $4R6GH.fg)('blu-6080-directory-table-tooltips') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: caption,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, content) : content;
}
const $c9c2d361e5e2d6e3$var$containerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingBlock: 'space.100',
    flex: '1 1 auto',
    flexDirection: 'row',
    display: 'flex',
    height: '40px'
});
const $c9c2d361e5e2d6e3$var$wrapperStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.025',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $c9c2d361e5e2d6e3$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("asoHC", function(module, exports) {

$parcel$export(module.exports, "TransitionComponent", () => $f14567bdbac8ba9f$export$3c61ec5cd62a42f9);

var $5uXOq = parcelRequire("5uXOq");

var $5y0F0 = parcelRequire("5y0F0");
const $f14567bdbac8ba9f$export$3c61ec5cd62a42f9 = ({ children: children, onClick: onClick, href: href })=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push })=>{
        const clickHandler = (e, analyticsEvent)=>{
            if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return;
            e.preventDefault();
            onClick && onClick(e, analyticsEvent);
            push(href);
        };
        return children({
            href: href,
            onClick: clickHandler
        });
    }) : children({
        href: href,
        onClick: onClick
    });

});


parcelRegister("kA97t", function(module, exports) {

$parcel$export(module.exports, "default", () => $1943a67ef8b3aa01$export$2e2bcd8739ae039);

var $bSlMQ = parcelRequire("bSlMQ");

var $bC2fB = parcelRequire("bC2fB");
var $1943a67ef8b3aa01$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(state, ownProps)=>({
        id: ownProps.entityId,
        onCancel: ownProps.onCancel,
        onSuccess: ownProps.onUpdated,
        onInitiateSuccess: ownProps.onDialogShown,
        onInitiateFailed: ownProps.onDataRetrieveFailed
    }), {})((0, $bSlMQ.default));

});

parcelRegister("2xUX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2125cb47e79f5cf$export$2e2bcd8739ae039);

var $gN92f = parcelRequire("gN92f");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $bC2fB = parcelRequire("bC2fB");

var $kWgA3 = parcelRequire("kWgA3");

var $hXBjD = parcelRequire("hXBjD");

var $b9OA0 = parcelRequire("b9OA0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a2125cb47e79f5cf$var$mapStateToPropsOld = (state, ownProps)=>({
        baseUrl: (0, $hXBjD.getBaseUrl)(state),
        id: ownProps.entityId,
        isFavourite: (0, $b9OA0.isFavorite)(state, ownProps.entityId),
        onCancel: ownProps.onCancel,
        onInitiateSuccess: ()=>{
            ownProps.onDialogShown();
        },
        onDataRetrieveFailed: ()=>{
            ownProps.onDataRetrieveFailed();
        },
        onCopied: ()=>{
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        }
    });
const $a2125cb47e79f5cf$var$mapStateToPropsNew = (initialState, // eslint-disable-next-line @typescript-eslint/no-explicit-any
ownProps)=>{
    const onInitiateSuccess = ()=>{
        ownProps.onDialogShown();
    };
    const onDataRetrieveFailed = ()=>{
        ownProps.onDataRetrieveFailed();
    };
    const onCopied = ()=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        ownProps.onUpdated();
    };
    return (_)=>({
            baseUrl: '',
            id: ownProps.entityId,
            onCancel: ownProps.onCancel,
            onInitiateSuccess: onInitiateSuccess,
            onDataRetrieveFailed: onDataRetrieveFailed,
            onCopied: onCopied
        });
};
var $a2125cb47e79f5cf$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('fix_unstable_selector_in_filter_directory'), $a2125cb47e79f5cf$var$mapStateToPropsNew, // @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
$a2125cb47e79f5cf$var$mapStateToPropsOld), {
    onCloseCopyFilterModal: (0, $kWgA3.closeCopyFilterModal)
})((0, $gN92f.default));

});
parcelRegister("gN92f", function(module, exports) {

$parcel$export(module.exports, "default", () => $af5be036c4f98f42$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");


var $jOazq = parcelRequire("jOazq");
function $af5be036c4f98f42$var$CreateModal(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraCopyFiltersModal",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jOazq.default), props))));
}
$af5be036c4f98f42$var$CreateModal.defaultProps = {
    onCopied: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $af5be036c4f98f42$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('copyFilter', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($af5be036c4f98f42$var$CreateModal);

});
parcelRegister("jOazq", function(module, exports) {

$parcel$export(module.exports, "default", () => $91cb2ec44f5649d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4041n = parcelRequire("4041n");

var $pa9q9 = parcelRequire("pa9q9");

var $aWse0 = parcelRequire("aWse0");

var $3HwlS = parcelRequire("3HwlS");

var $itmJb = parcelRequire("itmJb");

var $iHuZq = parcelRequire("iHuZq");

var $gzMQe = parcelRequire("gzMQe");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $91cb2ec44f5649d0$var$noop = ()=>{};
function $91cb2ec44f5649d0$var$CopyModal(props) {
    const { id: id, onDataRetrieveFailed: onDataRetrieveFailed } = props;
    const flagService = (0, $pa9q9.useFlagService)();
    const intl = (0, $aWse0.useIntlV2)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    let emitChangedFavorite = $91cb2ec44f5649d0$var$noop;
    if ((0, $3HwlS.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const hookValue = (0, $4041n.useChangeFavorite)();
        emitChangedFavorite = hookValue.emitChangedFavorite;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iHuZq.default), {
        id: id,
        flagService: flagService,
        onDataRetrieveFailed: onDataRetrieveFailed,
        isAdmin: isAdmin
    }, ({ error: error, data: data })=>{
        if (error) return null;
        return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzMQe.default), {
            emitChangedFavorite: emitChangedFavorite,
            intl: intl,
            flagService: flagService,
            filter: data,
            isAdmin: isAdmin,
            ...props
        }) : null;
    });
}
var $91cb2ec44f5649d0$export$2e2bcd8739ae039 = $91cb2ec44f5649d0$var$CopyModal;

});
parcelRegister("iHuZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ff69060c3add28b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $ivMO1 = parcelRequire("ivMO1");
// eslint-disable-next-line jira/react/no-class-components
class $2ff69060c3add28b$var$FilterDataProvider extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.fetchData();
    }
    async fetchData() {
        const { id: id, isAdmin: isAdmin } = this.props;
        try {
            const data = await (0, $eusud.performGetRequest)(`/rest/api/2/filter/${id}${isAdmin ? '?overrideSharePermissions=true' : ''}`);
            this.setState({
                loading: false,
                error: undefined,
                data: data
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            this.setState({
                loading: false,
                error: e
            }, ()=>{
                this.showErrorFlag();
            });
        }
    }
    showErrorFlag() {
        const { flagService: flagService, onDataRetrieveFailed: onDataRetrieveFailed } = this.props;
        flagService.showFlag((0, $ivMO1.default)());
        onDataRetrieveFailed();
    }
    render() {
        const { children: children } = this.props;
        const { loading: loading, error: error, data: data } = this.state;
        return children({
            loading: loading,
            error: error,
            data: data
        });
    }
    constructor(...args){
        super(...args), this.state = {
            loading: true,
            error: undefined,
            data: undefined
        };
    }
}
var $2ff69060c3add28b$export$2e2bcd8739ae039 = $2ff69060c3add28b$var$FilterDataProvider;

});
parcelRegister("ivMO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2065fd0a676d6fa1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $2065fd0a676d6fa1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "copy-filters-modal.common.flags.filter-loading-failed.title",
        "defaultMessage": "Filter loading failed."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2065fd0a676d6fa1$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $2065fd0a676d6fa1$var$messages.title,
        isAutoDismiss: true,
        messageId: 'copy-filters-modal.common.ui.flags.filter-loading-failed.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("gzMQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f42f9be9f2d36e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hZHze = parcelRequire("hZHze");

var $hhweD = parcelRequire("hhweD");

var $akuTQ = parcelRequire("akuTQ");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");

var $70IFa = parcelRequire("70IFa");


var $6325A = parcelRequire("6325A");

var $d6KcG = parcelRequire("d6KcG");

var $2ZmUc = parcelRequire("2ZmUc");

var $54Uq9 = parcelRequire("54Uq9");
const $9f42f9be9f2d36e7$var$getServerSideValidationErrors = (0, $akuTQ.createServerSideValidationErrorsGetter)({
    filterName: (0, $99958954cd57b065$export$b85469cbf362db42),
    shares: (0, $99958954cd57b065$export$378fd4cd7d69440f),
    edit_permissions: (0, $99958954cd57b065$export$fb465a1f4d511f87)
});
// eslint-disable-next-line jira/react/no-class-components
class $9f42f9be9f2d36e7$var$CopyModal extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onInitiateSuccess();
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { name: name, description: description, editPermissions: editPermissions, sharePermissions: sharePermissions } = this.props.filter;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70IFa.SharingPermissionAwareShareableEntityModal), {
            sharingPermissionType: "filter",
            avoidInitialPublicSharePermission: true,
            sharePermissions: sharePermissions,
            editPermissions: editPermissions,
            title: formatMessage((0, $54Uq9.default).header, {
                name: name
            }),
            actionButtonCaption: formatMessage((0, $54Uq9.default).saveButtonCaption),
            initialName: name,
            initialDescription: description,
            initialOwner: undefined,
            onCancel: this.onCancel,
            onOperationSucceed: this.onOperationSucceed,
            onOperationFailed: this.onOperationFailed,
            getServerSideValidationErrors: $9f42f9be9f2d36e7$var$getServerSideValidationErrors,
            operation: this.onOperation
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null));
    }
    constructor(...args){
        super(...args), this.onOperation = (filter)=>{
            const { isAdmin: isAdmin, filter: { favourite: favourite, jql: jql } } = this.props;
            return (0, $2ZmUc.default)(filter, jql, favourite, isAdmin);
        }, this.onOperationSucceed = (filter, result, analyticsEvent)=>{
            const { flagService: flagService, onCopied: onCopied, id: id } = this.props;
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'copiedFilter', {
                isViewerPrivate: filter.sharePermissions.length === 0,
                isEditorPrivate: filter.editPermissions && filter.editPermissions.length === 0
            });
            flagService.showFlag((0, $d6KcG.default)(filter.name));
            // Emit an event to notify consumers that there is a newly favourited entity
            if (result.favourite) this.props.emitChangedFavorite({
                id: result?.id,
                type: 'filters',
                value: result.favourite
            });
            onCopied();
            (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
                action: 'copied',
                actionSubjectId: `${id}`
            });
            this.props.onCloseCopyFilterModal();
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOperationFailed = (error, analyticsEvent)=>{
            const { flagService: flagService, id: id } = this.props;
            const isValidationError = error.name && error.name === (0, $jJZqs.VALIDATION_ERROR_NAME);
            if (!isValidationError) (0, $2YZCu.default).safeErrorWithoutCustomerData('directories.filters.copy-modal.submit', `copy filter has failed, id=${id}`, error);
            flagService.showFlag((0, $6325A.default)());
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'copy failed', id, {
                isValidationError: isValidationError
            });
        }, this.onCancel = ()=>{
            this.props.onCancel();
            this.props.onCloseCopyFilterModal();
        };
    }
}
var $9f42f9be9f2d36e7$export$2e2bcd8739ae039 = $9f42f9be9f2d36e7$var$CopyModal;

});
parcelRegister("akuTQ", function(module, exports) {

$parcel$export(module.exports, "createServerSideValidationErrorsGetter", () => $641c8e591e94e209$export$eba34c1c9e48e66a);

var $e5RQM = parcelRequire("e5RQM");
const $641c8e591e94e209$export$eba34c1c9e48e66a = (errorFieldToFormFieldDictionary)=>(validationError)=>{
        if (!validationError.errors) // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
        return {};
        // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return validationError.errors.reduce((validationErrors, error)=>{
            const formFieldName = errorFieldToFormFieldDictionary[error.field];
            if (formFieldName) // Assigning is fine in .reduce() from a new object
            // eslint-disable-next-line no-param-reassign
            validationErrors[formFieldName] = (0, $e5RQM.toServerValidationError)(error.error);
            return validationErrors;
        }, {});
    };

});
parcelRegister("e5RQM", function(module, exports) {

$parcel$export(module.exports, "toServerValidationError", () => $1e019e7acbd94ec5$export$567171750b320ae6);
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1e019e7acbd94ec5$var$FilterSharingPermissionKey = 'filter';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1e019e7acbd94ec5$var$DashboardSharingPermissionKey = 'dashboard';
const $1e019e7acbd94ec5$export$567171750b320ae6 = (value)=>value;

});


parcelRegister("70IFa", function(module, exports) {

$parcel$export(module.exports, "SharingPermissionAwareShareableEntityDialog", () => $aa7bbc74c826116d$export$da33277a49efaed2);
$parcel$export(module.exports, "SharingPermissionAwareShareableEntityModal", () => $aa7bbc74c826116d$export$e563fb6c5adbcd15);

var $5uXOq = parcelRequire("5uXOq");

var $7NYq5 = parcelRequire("7NYq5");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $9fuVs = parcelRequire("9fuVs");

var $1ppIJ = parcelRequire("1ppIJ");

var $cSD7y = parcelRequire("cSD7y");

var $kMQVm = parcelRequire("kMQVm");

var $2JOo9 = parcelRequire("2JOo9");

var $1irmd = parcelRequire("1irmd");

var $gp761 = parcelRequire("gp761");



const $aa7bbc74c826116d$var$ModalDialog = (0, $cSD7y.componentWithFG)('jfp_a11y_fix_dashboard_actions_modal_accessibility', (0, $1ppIJ.ModalDialog), (0, $7NYq5.JiraModal));
// eslint-disable-next-line jira/react/no-class-components
class $aa7bbc74c826116d$var$ShareableEntityDialog extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isNameReadOnly: false,
            isShareScopeLoading: false,
            initialOwner: undefined,
            shareeOptions: $kMQVm.shareeOptions,
            editOptions: $kMQVm.editOptions
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gp761.default), this.props)));
    }
}
const $aa7bbc74c826116d$export$da33277a49efaed2 = ({ avoidInitialPublicSharePermission: avoidInitialPublicSharePermission = false, sharingPermissionType: sharingPermissionType, sharePermissions: sharePermissions = [], viewersCustomMessage: viewersCustomMessage = '', nameTooltip: nameTooltip = '', allowSharePublicOrganizationOnly: allowSharePublicOrganizationOnly = false, editPermissions: editPermissions = [], forceHideEditors: forceHideEditors = false, isShareScopeLoading: isShareScopeLoading = false, isNameReadOnly: isNameReadOnly = false, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JOo9.default), null, ({ data: data, sharedObjectsPermission: sharedObjectsPermission, loading: loading })=>{
        const shareeOptionsFiltered = (0, $1irmd.getShareeOptions)({
            data: data,
            sharedObjectsPermission: sharedObjectsPermission,
            loading: loading
        }, sharePermissions, sharingPermissionType, allowSharePublicOrganizationOnly);
        const entitySharePermissions = (0, $1irmd.getSharePermissions)({
            data: data,
            sharedObjectsPermission: sharedObjectsPermission,
            loading: loading
        }, sharePermissions, avoidInitialPublicSharePermission);
        const canCreateSharedObjectsPermission = (0, $1irmd.isCreateSharedObjectsPermission)(sharedObjectsPermission);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa7bbc74c826116d$var$ShareableEntityDialog, {
            ...props,
            isEditorListShown: !forceHideEditors && (sharingPermissionType === 'dashboard' || sharingPermissionType === 'filter'),
            isNameReadOnly: isNameReadOnly,
            sharePermissions: entitySharePermissions,
            viewersCustomMessage: viewersCustomMessage,
            nameTooltip: nameTooltip,
            shareeOptions: shareeOptionsFiltered,
            editPermissions: canCreateSharedObjectsPermission === false || loading ? [] : editPermissions,
            editOptions: (0, $kMQVm.editOptions),
            isShareScopeLoading: isShareScopeLoading || loading
        });
    });
const $aa7bbc74c826116d$export$e563fb6c5adbcd15 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa7bbc74c826116d$var$ModalDialog, {
        messageId: "shareable-entity-dialog.modal-dialog",
        messageType: "transactional",
        width: "medium",
        onClose: props.onCancel,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aa7bbc74c826116d$export$da33277a49efaed2, props)));
var $aa7bbc74c826116d$export$2e2bcd8739ae039 = $aa7bbc74c826116d$var$ShareableEntityDialog;

});
parcelRegister("1ppIJ", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $8fbdebf88f199b98$export$1fa217be60c2f188);

var $5uXOq = parcelRequire("5uXOq");

var $7NYq5 = parcelRequire("7NYq5");

var $lu5k0 = parcelRequire("lu5k0");
const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});

parcelRegister("kMQVm", function(module, exports) {

$parcel$export(module.exports, "isPublicOrOpenOrPrivate", () => $f0bf949584737870$export$e08b925cf70f767b);
$parcel$export(module.exports, "areSharePermissionsEqual", () => $f0bf949584737870$export$8c0ff6f403e15e9c);
$parcel$export(module.exports, "mapAccessTypeFromPermissions", () => $f0bf949584737870$export$1c2ded3e2d5331b3);
$parcel$export(module.exports, "allShareTypesProperties", () => $f0bf949584737870$export$4de258fee4f5aca0);
$parcel$export(module.exports, "shareeOptions", () => $f0bf949584737870$export$9db6e6707f968cf1);
$parcel$export(module.exports, "editOptions", () => $f0bf949584737870$export$dfc3fbb12e12e5a2);
$parcel$export(module.exports, "shareeOptionsWithPublicAccessDisabled", () => $f0bf949584737870$export$c47f666f037e39f1);
$parcel$export(module.exports, "shareeOptionsWithoutPublicAccess", () => $f0bf949584737870$export$927a4a38aa2e02e7);
$parcel$export(module.exports, "sharingTypeToPermissionsMap", () => $f0bf949584737870$export$fba0af8514fddf9f);

var $5uXOq = parcelRequire("5uXOq");

var $3NMrl = parcelRequire("3NMrl");

var $8QpSo = parcelRequire("8QpSo");

var $fwpGE = parcelRequire("fwpGE");

var $jRceo = parcelRequire("jRceo");

var $ckyDP = parcelRequire("ckyDP");

var $e16Mp = parcelRequire("e16Mp");

var $guOIy = parcelRequire("guOIy");



var $cCoT9 = parcelRequire("cCoT9");
const $f0bf949584737870$export$e08b925cf70f767b = (type)=>// @ts-expect-error - TS2345 - Argument of type 'ShareType' is not assignable to parameter of type '"loggedin" | "global" | "private"'.
    [
        (0, $a889b3091d5309c7$export$86517eb0163ef745),
        (0, $99958954cd57b065$export$52e14e112503bf52),
        (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)
    ].includes(type);
const $f0bf949584737870$export$8c0ff6f403e15e9c = (share1, share2)=>{
    if (share1.type !== share2.type) return false;
    if (share1.type === (0, $99958954cd57b065$export$52e14e112503bf52) || share1.type === (0, $a889b3091d5309c7$export$86517eb0163ef745) || share1.type === (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)) return true;
    if (share1.type === (0, $a889b3091d5309c7$export$b02d7412182d1bce) && share2.type === (0, $a889b3091d5309c7$export$b02d7412182d1bce)) {
        if (share1.group.groupId && share2.group.groupId) return share1.group.groupId === share2.group.groupId;
        // second check is just for flow
        return share1.group.name === share2.group.name;
    }
    if (share1.type === (0, $a889b3091d5309c7$export$aea0835048e1c730) && share2.type === (0, $a889b3091d5309c7$export$aea0835048e1c730)) // second check is just for flow
    return share1.user.accountId === share2.user.accountId;
    if (share1.type === (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6) && share2.type === (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6)) return share1.project.id === share2.project.id && (share1.role && share1.role.id) === (share2.role && share2.role.id);
    return false;
};
const $f0bf949584737870$export$1c2ded3e2d5331b3 = (0, $8QpSo.default)((sharePermissions)=>{
    if (sharePermissions.length === 0) return 0, $99958954cd57b065$export$52e14e112503bf52;
    return sharePermissions.length === 1 ? sharePermissions[0].type // PUBLIC_SHARE or OPEN_SHARE,
     : undefined;
});
const $f0bf949584737870$export$4de258fee4f5aca0 = {
    [(0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6)]: {
        messageDescriptor: (0, $cCoT9.default).project,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwpGE))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $a889b3091d5309c7$export$487da0972e3459fe)]: {
        messageDescriptor: (0, $cCoT9.default).unknownProject,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwpGE))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $a889b3091d5309c7$export$b02d7412182d1bce)]: {
        messageDescriptor: (0, $cCoT9.default).group,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)]: {
        messageDescriptor: (0, $cCoT9.default).myOrganization,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRceo))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $a889b3091d5309c7$export$86517eb0163ef745)]: {
        messageDescriptor: (0, $cCoT9.default).public,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($guOIy))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $a889b3091d5309c7$export$aea0835048e1c730)]: {
        messageDescriptor: (0, $cCoT9.default).user,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e16Mp))), {
            spacing: "spacious",
            label: ""
        })
    },
    [(0, $99958954cd57b065$export$52e14e112503bf52)]: {
        messageDescriptor: (0, $cCoT9.default).private,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e16Mp))), {
            spacing: "spacious",
            label: ""
        })
    }
};
const $f0bf949584737870$export$9b1f09fb42db6641 = (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))($f0bf949584737870$export$4de258fee4f5aca0, (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6), (0, $a889b3091d5309c7$export$b02d7412182d1bce), (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269), (0, $a889b3091d5309c7$export$86517eb0163ef745), (0, $a889b3091d5309c7$export$aea0835048e1c730), (0, $99958954cd57b065$export$52e14e112503bf52));
const $f0bf949584737870$export$d26c8129d623af6c = (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))($f0bf949584737870$export$4de258fee4f5aca0, (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6), (0, $a889b3091d5309c7$export$b02d7412182d1bce), (0, $a889b3091d5309c7$export$aea0835048e1c730), (0, $99958954cd57b065$export$52e14e112503bf52));
const $f0bf949584737870$export$9db6e6707f968cf1 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
Object.keys($f0bf949584737870$export$9b1f09fb42db6641).map((shareType)=>({
        ...$f0bf949584737870$export$9b1f09fb42db6641[shareType],
        isDisabled: false,
        value: shareType
    }));
const $f0bf949584737870$export$dfc3fbb12e12e5a2 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
Object.keys($f0bf949584737870$export$d26c8129d623af6c).map((shareType)=>({
        ...$f0bf949584737870$export$d26c8129d623af6c[shareType],
        isDisabled: false,
        value: shareType
    }));
const $f0bf949584737870$export$c47f666f037e39f1 = $f0bf949584737870$export$9db6e6707f968cf1.map((option)=>({
        ...option,
        isDisabled: option.value === (0, $a889b3091d5309c7$export$86517eb0163ef745)
    }));
const $f0bf949584737870$export$927a4a38aa2e02e7 = $f0bf949584737870$export$9db6e6707f968cf1.filter((option)=>option.value !== (0, $a889b3091d5309c7$export$86517eb0163ef745));
const $f0bf949584737870$export$fba0af8514fddf9f = {
    filter: 'globalsharing',
    dashboard: 'globalsharing'
};

});
parcelRegister("jRceo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7f55381552b3bb050a399d88ef8b3fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e74c746303d0418a$var$_react = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e74c746303d0418a$var$_officeBuilding = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("4bTdk")));

var $e74c746303d0418a$var$_officeBuilding2 = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("icDh5")));
function $e74c746303d0418a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e74c746303d0418a$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $e74c746303d0418a$var$_react.default.createElement($e74c746303d0418a$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $e74c746303d0418a$var$_officeBuilding2.default
    }, props));
$e74c746303d0418a$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $e74c746303d0418a$var$_default = module.exports.default = $e74c746303d0418a$var$OfficeBuildingIcon;

});

parcelRegister("guOIy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfa480f43d6d2cb52a0e0ba9712304a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c026ca20e9e43a09$var$_react = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c026ca20e9e43a09$var$_globe = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("9x5pH")));

var $c026ca20e9e43a09$var$_world = $c026ca20e9e43a09$var$_interopRequireDefault((parcelRequire("4GsX0")));
function $c026ca20e9e43a09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GlobeIcon.
 * This component is GlobeIcon, with `UNSAFE_fallbackIcon` set to "WorldIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c026ca20e9e43a09$var$GlobeIcon = (props)=>/*#__PURE__*/ $c026ca20e9e43a09$var$_react.default.createElement($c026ca20e9e43a09$var$_globe.default, Object.assign({
        LEGACY_fallbackIcon: $c026ca20e9e43a09$var$_world.default
    }, props));
$c026ca20e9e43a09$var$GlobeIcon.Name = 'GlobeIconMigration';
var $c026ca20e9e43a09$var$_default = module.exports.default = $c026ca20e9e43a09$var$GlobeIcon;

});

const $99958954cd57b065$export$52e14e112503bf52 = 'private';
const $99958954cd57b065$export$b85469cbf362db42 = 'name';
const $99958954cd57b065$export$a1d4ae33ba772a5b = 'description';
const $99958954cd57b065$export$378fd4cd7d69440f = 'sharePermissions';
const $99958954cd57b065$export$fb465a1f4d511f87 = 'editPermissions';

parcelRegister("cCoT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7978393c0dce22b9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7978393c0dce22b9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    group: {
        "id": "shareable-entity-dialog.model.group",
        "defaultMessage": "Group"
    },
    project: {
        "id": "shareable-entity-dialog.model.project",
        "defaultMessage": "Project"
    },
    private: {
        "id": "shareable-entity-dialog.model.private",
        "defaultMessage": "Private"
    },
    user: {
        "id": "shareable-entity-dialog.model.user",
        "defaultMessage": "User"
    },
    myOrganization: {
        "id": "shareable-entity-dialog.model.my-organization",
        "defaultMessage": "My organization"
    },
    public: {
        "id": "shareable-entity-dialog.model.public",
        "defaultMessage": "Public"
    },
    unknownProject: {
        "id": "shareable-entity-dialog.model.unknown-project",
        "defaultMessage": "Unknown project"
    }
});

});


parcelRegister("2JOo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $343b8babc2950638$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
class $343b8babc2950638$export$471356de977a9b27 extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.fetchData();
        this.fetchPermissions();
    }
    render() {
        const { children: children } = this.props;
        const { loading: loading, error: error, data: data, sharedObjectsPermission: sharedObjectsPermission, sharedObjectError: sharedObjectError, sharedObjectPermissionLoading: sharedObjectPermissionLoading } = this.state;
        return children({
            loading: loading || sharedObjectPermissionLoading,
            error: error,
            data: data,
            sharedObjectError: sharedObjectError,
            sharedObjectsPermission: sharedObjectsPermission
        });
    }
    constructor(...args){
        super(...args), this.state = {
            loading: false,
            error: undefined,
            data: undefined,
            sharedObjectError: undefined,
            sharedObjectPermissionLoading: false,
            sharedObjectsPermission: undefined
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming, jira/react-no-unneeded-arrow-function-properties
        this.fetchData = async ()=>{
            this.setState({
                loading: true
            });
            try {
                const url = '/rest/internal/2/sharing-permissions';
                const permissions = await (0, $eusud.performGetRequest)(url);
                this.setState({
                    loading: false,
                    error: undefined,
                    data: permissions
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                this.setState({
                    loading: false,
                    error: e,
                    data: undefined
                });
                const event = this.props.createAnalyticsEvent({});
                (0, $jcw0u.default)({
                    error: e,
                    event: event,
                    meta: {
                        id: 'fetchData',
                        packageName: 'jiraShareableEntityDialog'
                    }
                });
            }
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming, jira/react-no-unneeded-arrow-function-properties
        this.fetchPermissions = async ()=>{
            this.setState({
                sharedObjectPermissionLoading: true
            });
            try {
                const sharedObjectsPermission = await (0, $eusud.performGetRequest)('/rest/api/3/mypermissions?permissions=CREATE_SHARED_OBJECTS');
                this.setState({
                    sharedObjectPermissionLoading: false,
                    sharedObjectError: undefined,
                    sharedObjectsPermission: sharedObjectsPermission
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                this.setState({
                    sharedObjectPermissionLoading: false,
                    sharedObjectError: e,
                    sharedObjectsPermission: undefined
                });
                const event = this.props.createAnalyticsEvent({});
                (0, $jcw0u.default)({
                    event: event,
                    error: e,
                    meta: {
                        id: 'fetchPermissions',
                        packageName: 'jiraShareableEntityDialog'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
    }
}
var $343b8babc2950638$export$2e2bcd8739ae039 = (0, $cb25w.default)()($343b8babc2950638$export$471356de977a9b27);

});

parcelRegister("1irmd", function(module, exports) {

$parcel$export(module.exports, "isCreateSharedObjectsPermission", () => $d87451c3878a5bc2$export$af4fc7cee18c1f8a);
$parcel$export(module.exports, "getSharePermissions", () => $d87451c3878a5bc2$export$96717b662cf0e6e8);
$parcel$export(module.exports, "getShareeOptions", () => $d87451c3878a5bc2$export$2b470b7fa9b9f6ca);



var $kMQVm = parcelRequire("kMQVm");
const $d87451c3878a5bc2$var$getShareeOptionsIfPublicSharingDisabled = (isEntitySharePermissionSetAsPublic)=>isEntitySharePermissionSetAsPublic ? (0, $kMQVm.shareeOptionsWithPublicAccessDisabled) : (0, $kMQVm.shareeOptionsWithoutPublicAccess);
const $d87451c3878a5bc2$var$getShareOptionsPublicOrganizationOnly = (isPublicSharingEnabled, isEntitySharePermissionSetAsPublic)=>{
    const publicOrganizationOnlyShareOptions = (0, $kMQVm.shareeOptions).filter((option)=>option.value === (0, $a889b3091d5309c7$export$86517eb0163ef745) || option.value === (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269));
    if (isPublicSharingEnabled === true) return publicOrganizationOnlyShareOptions;
    return isEntitySharePermissionSetAsPublic ? publicOrganizationOnlyShareOptions.map((option)=>({
            ...option,
            isDisabled: option.value === (0, $a889b3091d5309c7$export$86517eb0163ef745)
        })) : publicOrganizationOnlyShareOptions.filter((option)=>option.value !== (0, $a889b3091d5309c7$export$86517eb0163ef745));
};
const $d87451c3878a5bc2$export$56bc389f739d17f8 = (sharePermissions)=>Boolean((0, $kMQVm.mapAccessTypeFromPermissions)(sharePermissions) === (0, $a889b3091d5309c7$export$86517eb0163ef745));
const $d87451c3878a5bc2$export$af4fc7cee18c1f8a = (sharedObjectsPermission)=>sharedObjectsPermission?.permissions?.CREATE_SHARED_OBJECTS?.havePermission;
const $d87451c3878a5bc2$export$96717b662cf0e6e8 = ({ sharedObjectsPermission: sharedObjectsPermission, loading: loading }, sharePermissions, avoidInitialPublicSharePermission = false)=>{
    if ($d87451c3878a5bc2$export$af4fc7cee18c1f8a(sharedObjectsPermission) === false || loading) return [];
    const isEntitySharePermissionSetAsPublic = (0, $kMQVm.mapAccessTypeFromPermissions)(sharePermissions) === (0, $a889b3091d5309c7$export$86517eb0163ef745);
    return isEntitySharePermissionSetAsPublic && avoidInitialPublicSharePermission ? [] : sharePermissions;
};
const $d87451c3878a5bc2$export$2b470b7fa9b9f6ca = ({ data: data, sharedObjectsPermission: sharedObjectsPermission, loading: loading }, sharePermissions, sharingPermissionType, allowSharePublicOrganizationOnly = false)=>{
    const isPublicSharingEnabled = data && data[(0, $kMQVm.sharingTypeToPermissionsMap)[sharingPermissionType]];
    const isEntitySharePermissionSetAsPublic = $d87451c3878a5bc2$export$56bc389f739d17f8(sharePermissions);
    let dialogShareeOptions;
    if (allowSharePublicOrganizationOnly) dialogShareeOptions = $d87451c3878a5bc2$var$getShareOptionsPublicOrganizationOnly(isPublicSharingEnabled, isEntitySharePermissionSetAsPublic);
    else dialogShareeOptions = isPublicSharingEnabled === true ? (0, $kMQVm.shareeOptions) : $d87451c3878a5bc2$var$getShareeOptionsIfPublicSharingDisabled(isEntitySharePermissionSetAsPublic);
    if ($d87451c3878a5bc2$export$af4fc7cee18c1f8a(sharedObjectsPermission) === false || loading) return dialogShareeOptions.filter((option)=>option.value === (allowSharePublicOrganizationOnly ? (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269) : (0, $99958954cd57b065$export$52e14e112503bf52)));
    return dialogShareeOptions;
};

});

parcelRegister("gp761", function(module, exports) {

$parcel$export(module.exports, "default", () => $e26c74732d0b6af6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iQv12 = parcelRequire("iQv12");

var $jJZqs = parcelRequire("jJZqs");


var $imOJb = parcelRequire("imOJb");


var $eNz6S = parcelRequire("eNz6S");

var $iJRxf = parcelRequire("iJRxf");
const $e26c74732d0b6af6$var$UserPickerWithAnalytics = (0, $iQv12.default)({
    onChange: 'owner'
})((0, $imOJb.default));
const $e26c74732d0b6af6$var$isNameEmpty = (name)=>!name.trim();
const $e26c74732d0b6af6$var$transformToUser = ({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl, label: label })=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrl: avatarUrl,
        label: label
    });
class $e26c74732d0b6af6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.nameInputRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.onNameChange = (event)=>{
            const name = event.target.value;
            this.setState({
                name: name,
                isNameRequiredError: $e26c74732d0b6af6$var$isNameEmpty(name),
                serverValidationErrors: {
                    ...this.state.serverValidationErrors,
                    // @ts-expect-error(PARTIAL_RECORD) TS2418 - Type of computed property's value is 'undefined', which is not assignable to type 'string'.
                    [(0, $99958954cd57b065$export$b85469cbf362db42)]: undefined
                }
            });
        }, this.onDescriptionChange = (event)=>{
            this.setState({
                description: event.target.value,
                serverValidationErrors: {
                    ...this.state.serverValidationErrors,
                    // @ts-expect-error(PARTIAL_RECORD) TS2418 - Type of computed property's value is 'undefined', which is not assignable to type 'string'.
                    [(0, $99958954cd57b065$export$a1d4ae33ba772a5b)]: undefined
                }
            });
        }, this.onOwnerChange = (selectedUser)=>{
            const { initialOwner: initialOwner } = this.props;
            const owner = selectedUser ? $e26c74732d0b6af6$var$transformToUser(selectedUser) : initialOwner;
            this.setState({
                owner: owner
            });
        }, this.onAction = (event, analyticsEvent)=>{
            const { operation: operation, onOperationSucceed: onOperationSucceed, onOperationFailed: onOperationFailed, getServerSideValidationErrors: getServerSideValidationErrors } = this.props;
            const { name: name, description: description, owner: owner, sharePermissions: sharePermissions, editPermissions: editPermissions } = this.state;
            this.setState({
                isPending: true
            });
            // Filter out project unknown shares as they cannot be saved. Filters backend ignores them,
            // while dashboards backend throws a 400 error.
            const filteredSharePermissions = sharePermissions.filter((share)=>share.type !== (0, $a889b3091d5309c7$export$487da0972e3459fe));
            const filteredEditPermissions = editPermissions.filter((share)=>share.type !== (0, $a889b3091d5309c7$export$487da0972e3459fe));
            const operationData = {
                name: name,
                description: description,
                owner: owner,
                sharePermissions: filteredSharePermissions,
                editPermissions: filteredEditPermissions
            };
            operation(operationData).then((operationResult)=>{
                this.setStateIfMounted({
                    isPending: false,
                    // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
                    serverValidationErrors: {}
                });
                onOperationSucceed(operationData, operationResult, analyticsEvent);
            }, (error)=>{
                this.setStateIfMounted({
                    isPending: false
                });
                if (error instanceof (0, $jJZqs.ValidationError)) {
                    const newServerValidationErrors = getServerSideValidationErrors(error);
                    this.setStateIfMounted({
                        serverValidationErrors: newServerValidationErrors // set or reset
                    });
                    // setting the focus to name field on error (implemented as a part of JCA11Y-1635)
                    if (newServerValidationErrors.name) requestAnimationFrame(()=>this.nameInputRef.current?.focus());
                }
                onOperationFailed(error, analyticsEvent);
            });
        }, this.onSharePermissionChange = (sharePermissions)=>{
            this.setState({
                sharePermissions: sharePermissions,
                serverValidationErrors: {
                    ...this.state.serverValidationErrors,
                    // @ts-expect-error(PARTIAL_RECORD) TS2418 - Type of computed property's value is 'undefined', which is not assignable to type 'string'.
                    [(0, $99958954cd57b065$export$378fd4cd7d69440f)]: undefined
                }
            });
        }, this.onEditPermissionChange = (editPermissions)=>{
            this.setState({
                editPermissions: editPermissions,
                serverValidationErrors: {
                    ...this.state.serverValidationErrors,
                    // @ts-expect-error(PARTIAL_RECORD) TS2418 - Type of computed property's value is 'undefined', which is not assignable to type 'string'.
                    [(0, $99958954cd57b065$export$fb465a1f4d511f87)]: undefined
                }
            });
        };
        const { initialName: initialName, initialDescription: initialDescription, initialOwner: initialOwner, sharePermissions: sharePermissions, editPermissions: editPermissions, viewersCustomMessage: viewersCustomMessage, nameTooltip: nameTooltip } = props;
        this.state = {
            name: initialName || '',
            description: initialDescription || '',
            owner: initialOwner,
            isPending: false,
            isNameRequiredError: false,
            // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
            serverValidationErrors: {},
            sharePermissions: sharePermissions || [],
            viewersCustomMessage: viewersCustomMessage || '',
            nameTooltip: nameTooltip || '',
            editPermissions: editPermissions || []
        };
    }
    componentDidMount() {
        this.isComponentMounted = true;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isShareScopeLoading && !this.props.isShareScopeLoading) this.setState({
            // @ts-expect-error - TS2322 - Type 'SharePermission[] | undefined' is not assignable to type 'SharePermission[]'.
            sharePermissions: this.props.sharePermissions,
            // @ts-expect-error - TS2322 - Type 'SharePermission[] | undefined' is not assignable to type 'SharePermission[]'.
            editPermissions: this.props.editPermissions
        });
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    setStateIfMounted(stateUpdates) {
        if (this.isComponentMounted) // @ts-expect-error - TS2345 - Argument of type 'Partial<State>' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<AppProps<OR>>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
        this.setState(stateUpdates);
    }
    render() {
        const { isShareScopeLoading: isShareScopeLoading, onCancel: onCancel, title: title, headingTitleLevel: headingTitleLevel, shareeOptions: shareeOptions, editOptions: editOptions, actionButtonCaption: actionButtonCaption, isEditorListShown: isEditorListShown, isNameReadOnly: isNameReadOnly } = this.props;
        const { name: name, description: description, owner: owner, isPending: isPending, isNameRequiredError: isNameRequiredError, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, nameTooltip: nameTooltip, editPermissions: editPermissions, serverValidationErrors: serverValidationErrors } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJRxf.default), {
            isPending: isPending,
            isNameRequiredError: isNameRequiredError,
            isShareScopeLoading: isShareScopeLoading,
            title: title,
            headingTitleLevel: headingTitleLevel,
            shareeOptions: shareeOptions,
            editOptions: editOptions,
            name: name,
            nameTooltip: nameTooltip,
            description: description,
            owner: owner,
            serverValidationErrors: serverValidationErrors,
            actionButtonCaption: actionButtonCaption,
            // @ts-expect-error - Type 'WithUIAnalyticsEvent<Omit<{ baseUrl: string; label: string | undefined; placeholder: string | undefined; suggestedAccountId: string | undefined; selectedUser: User | undefined; onChange: (arg1: User | undefined, args_1: UIAnalyticsEvent) => void; ... 6 more ...; forwardedRef?: Ref<...> | undefined; }, keyof WithAnal...' is not assignable to type 'ComponentType<{ selectedUser: User; ariaLabel?: string | undefined; ariaLabelledby?: string | undefined; onChange: (arg1: User) => void; }>'.
            UserPicker: $e26c74732d0b6af6$var$UserPickerWithAnalytics,
            Access: (0, $eNz6S.default),
            isEditorListShown: isEditorListShown,
            isNameReadOnly: isNameReadOnly,
            onNameChange: this.onNameChange,
            onDescriptionChange: this.onDescriptionChange,
            onOwnerChange: this.onOwnerChange,
            onAction: this.onAction,
            onCancel: onCancel,
            sharePermissions: sharePermissions,
            viewersCustomMessage: viewersCustomMessage,
            editPermissions: editPermissions,
            onSharePermissionChange: this.onSharePermissionChange,
            onEditPermissionChange: this.onEditPermissionChange,
            nameInputRef: this.nameInputRef
        });
    }
}
const $e26c74732d0b6af6$export$f99395d0d1e1a10e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1i6y _18u010v4 _n3tdv77o",
            __cmplp.className
        ])
    });
});
const $e26c74732d0b6af6$export$1005c9f9ab7599e8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1i6y _2hwx10v4 _ca0qv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eNz6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf86bf462330f63$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $7O4UO = parcelRequire("7O4UO");

var $dqoiX = parcelRequire("dqoiX");

var $dOvpK = parcelRequire("dOvpK");

var $az4zD = parcelRequire("az4zD");



var $kMQVm = parcelRequire("kMQVm");

var $9Aocd = parcelRequire("9Aocd");

var $lDzQy = parcelRequire("lDzQy");
const $cbf86bf462330f63$export$b704bccf33aa8fc7 = (0, $8QpSo.default)((sharePermissions)=>{
    const accessType = (0, $kMQVm.mapAccessTypeFromPermissions)(sharePermissions);
    const sharePermissionRows = accessType === (0, $99958954cd57b065$export$52e14e112503bf52) ? [
        {
            type: (0, $99958954cd57b065$export$52e14e112503bf52)
        }
    ] : [
        ...sharePermissions
    ];
    return {
        accessType: accessType,
        sharePermissionRows: sharePermissionRows
    };
});
const $cbf86bf462330f63$export$42cefa6463604ece = (0, $8QpSo.default)((sharePermissions)=>{
    const editAccessType = (0, $kMQVm.mapAccessTypeFromPermissions)(sharePermissions);
    const editPermissionRows = editAccessType === (0, $99958954cd57b065$export$52e14e112503bf52) ? [
        {
            type: (0, $99958954cd57b065$export$52e14e112503bf52)
        }
    ] : [
        ...sharePermissions
    ];
    return {
        editAccessType: editAccessType,
        editPermissionRows: editPermissionRows
    };
});
// eslint-disable-next-line jira/react/no-class-components
class $cbf86bf462330f63$var$AccessWrapper extends (0, $5uXOq.Component) {
    setSharePermission(sharePermission, analyticsEvent) {
        const { onSharePermissionChange: onSharePermissionChange } = this.props;
        const { type: type } = sharePermission;
        const attributes = {
            shareeType: type,
            shareesCount: undefined,
            allRoles: undefined
        };
        switch(sharePermission.type){
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                onSharePermissionChange([
                    sharePermission
                ]);
                break;
            case 0, $99958954cd57b065$export$52e14e112503bf52:
                onSharePermissionChange([]);
                break;
            default:
                {
                    const newPermissions = this.props.sharePermissions.filter((element)=>!(0, $kMQVm.isPublicOrOpenOrPrivate)(element.type)) // remove possible PUBLIC_SHARE or OPEN_SHARE permissions
                    .concat(sharePermission);
                    // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'undefined'.
                    attributes.shareesCount = newPermissions.length;
                    // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'undefined'.
                    attributes.allRoles = sharePermission.type === (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6) ? !sharePermission.role : undefined; // If it is a project, we may want to know if all roles where given access
                    onSharePermissionChange(newPermissions);
                }
                break;
        }
        (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
            name: 'shareeRowAddButton',
            attributes: attributes
        });
    }
    setEditPermission(sharePermission, analyticsEvent) {
        const { onEditPermissionChange: onEditPermissionChange } = this.props;
        const { type: type } = sharePermission;
        const attributes = {
            shareeType: type,
            shareesCount: undefined,
            allRoles: undefined
        };
        switch(sharePermission.type){
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                onEditPermissionChange([
                    sharePermission
                ]);
                break;
            case 0, $99958954cd57b065$export$52e14e112503bf52:
                onEditPermissionChange([]);
                break;
            default:
                {
                    const newPermissions = this.props.editPermissions.filter((element)=>!(0, $kMQVm.isPublicOrOpenOrPrivate)(element.type)) // remove possible PUBLIC_SHARE or OPEN_SHARE permissions
                    .concat(sharePermission);
                    // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'undefined'.
                    attributes.shareesCount = newPermissions.length;
                    // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'undefined'.
                    attributes.allRoles = sharePermission.type === (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6) ? !sharePermission.role : undefined; // If it is a project, we may want to know if all roles where given access
                    onEditPermissionChange(newPermissions);
                }
                break;
        }
        (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
            name: 'editorRowAddButton',
            attributes: attributes
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, shareeOptions: shareeOptions, editOptions: editOptions, editPermissions: editPermissions, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, isShareScopeLoading: isShareScopeLoading, isEditorListShown: isEditorListShown, sharePermissionsServerValidationError: sharePermissionsServerValidationError, editPermissionsServerValidationError: editPermissionsServerValidationError } = this.props;
        const { accessType: accessType, sharePermissionRows: sharePermissionRows } = $cbf86bf462330f63$export$b704bccf33aa8fc7(sharePermissions);
        const { editAccessType: editAccessType, editPermissionRows: editPermissionRows } = $cbf86bf462330f63$export$42cefa6463604ece(editPermissions);
        const { duplicatedIndex: duplicatedIndex, duplicatedEditIndex: duplicatedEditIndex, revokePermissionMessage: revokePermissionMessage } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "polite",
            "data-testid": "shareable-entity-dialog.access.screen"
        }, revokePermissionMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $9Aocd.default).access),
            // @ts-expect-error - TS2322 - Type '{ children: () => Element; label: string; isInvalid: boolean; invalidMessage: string; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
            isInvalid: !!sharePermissionsServerValidationError,
            invalidMessage: sharePermissionsServerValidationError,
            name: "access"
        }, ({ fieldProps: { //  @ts-expect-error - TS7053: Element implicitly has an 'any' type because expression of type '"aria-label"' can't be used to index type 'FieldProps<string, HTMLInputElement>'.
        'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lDzQy.default), {
                ariaLabel: ariaLabel,
                ariaLabelledby: ariaLabelledby,
                type: accessType,
                duplicatedIndex: duplicatedIndex,
                isShareScopeLoading: isShareScopeLoading,
                shareeOptions: shareeOptions,
                customMessage: viewersCustomMessage,
                sharePermissionRows: sharePermissionRows,
                onAddSharePermission: this.onAddSharePermission,
                onRemove: this.onRemove,
                errorMessage: sharePermissionsServerValidationError
            })), ' ', isEditorListShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $9Aocd.default).editor),
            // @ts-expect-error - TS2322 - Type '{ children: () => Element; label: string; isInvalid: boolean; invalidMessage: string; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
            isInvalid: !!editPermissionsServerValidationError,
            invalidMessage: editPermissionsServerValidationError,
            name: "editor"
        }, ({ fieldProps: { //  @ts-expect-error - TS7053: Element implicitly has an 'any' type because expression of type '"aria-label"' can't be used to index type 'FieldProps<string, HTMLInputElement>'.
        'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lDzQy.default), {
                ariaLabel: ariaLabel,
                ariaLabelledby: ariaLabelledby,
                isEditorList: true,
                type: editAccessType,
                duplicatedIndex: duplicatedEditIndex,
                isShareScopeLoading: isShareScopeLoading,
                shareeOptions: editOptions,
                sharePermissionRows: editPermissionRows,
                onAddSharePermission: this.onAddEditPermission,
                onRemove: this.onEditRemove,
                errorMessage: editPermissionsServerValidationError
            })));
    }
    constructor(...args){
        super(...args), this.state = {
            duplicatedIndex: undefined,
            duplicatedEditIndex: undefined,
            revokePermissionMessage: undefined
        }, this.onRemove = (index, analyticsEvent)=>{
            const { sharePermissions: sharePermissions, onSharePermissionChange: onSharePermissionChange } = this.props;
            const newPermissions = sharePermissions.filter((_, i)=>i !== index);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const permission = sharePermissions[index];
            const { type: type } = permission;
            (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
                name: 'shareeRowRemoveButton',
                attributes: {
                    shareeType: type,
                    shareeIndex: index,
                    shareesRemaining: newPermissions.length
                }
            });
            this.setState({
                duplicatedIndex: undefined,
                duplicatedEditIndex: undefined
            });
            const { formatMessage: formatMessage } = this.props.intl;
            let title;
            switch(type){
                case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                    title = permission.group.name;
                    break;
                case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                    title = permission.project.name;
                    break;
                case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                    title = formatMessage((0, $kMQVm.allShareTypesProperties)[type].messageDescriptor);
                    break;
                case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                    title = permission.user.displayName;
                    break;
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                case 0, $99958954cd57b065$export$52e14e112503bf52:
                    title = formatMessage((0, $kMQVm.allShareTypesProperties)[type].messageDescriptor);
                    break;
                default:
                    title = 'none';
            }
            this.setState({
                revokePermissionMessage: formatMessage((0, $9Aocd.default).permissionsRevoke, {
                    title: title
                })
            });
            onSharePermissionChange(newPermissions);
        }, this.onEditRemove = (index, analyticsEvent)=>{
            const { editPermissions: editPermissions, onEditPermissionChange: onEditPermissionChange } = this.props;
            const newPermissions = editPermissions.filter((_, i)=>i !== index);
            (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
                name: 'editorRowRemoveButton',
                attributes: {
                    shareeType: editPermissions[index].type,
                    shareeIndex: index,
                    shareesRemaining: newPermissions.length
                }
            });
            this.setState({
                duplicatedIndex: undefined,
                duplicatedEditIndex: undefined
            });
            onEditPermissionChange(newPermissions);
        }, this.onAddSharePermission = (sharePermission, analyticsEvent)=>{
            const { sharePermissions: sharePermissions, editPermissions: editPermissions, isEditorListShown: isEditorListShown } = this.props;
            const { type: type } = sharePermission;
            this.setState({
                duplicatedIndex: undefined
            });
            if ((0, $kMQVm.isPublicOrOpenOrPrivate)(type)) this.setSharePermission(sharePermission, analyticsEvent);
            else {
                // If the sharePermission already exists in sharePermissions then it should not be added.
                const duplicatedIndex = sharePermissions.findIndex((element)=>(0, $kMQVm.areSharePermissionsEqual)(sharePermission, element));
                if (duplicatedIndex >= 0) this.setState({
                    duplicatedIndex: duplicatedIndex
                });
                else if (isEditorListShown) {
                    // If the sharePermission already exists in editPermissions then it should not be added.
                    const duplicatedEditIndex = editPermissions.findIndex((element)=>(0, $kMQVm.areSharePermissionsEqual)(sharePermission, element));
                    if (duplicatedEditIndex >= 0) this.setState({
                        duplicatedEditIndex: duplicatedEditIndex
                    });
                    else this.setSharePermission(sharePermission, analyticsEvent);
                } else this.setSharePermission(sharePermission, analyticsEvent);
            }
        }, this.onAddEditPermission = (sharePermission, analyticsEvent)=>{
            const { sharePermissions: sharePermissions, editPermissions: editPermissions } = this.props;
            const { type: type } = sharePermission;
            this.setState({
                duplicatedIndex: undefined
            });
            if ((0, $kMQVm.isPublicOrOpenOrPrivate)(type)) this.setEditPermission(sharePermission, analyticsEvent);
            else {
                // If the editPermissions take preference over editPermissions.
                const duplicatedIndex = sharePermissions.findIndex((element)=>(0, $kMQVm.areSharePermissionsEqual)(sharePermission, element));
                if (duplicatedIndex >= 0) this.onRemove(duplicatedIndex, analyticsEvent);
                // If the sharePermission already exists in editPermissions, then it should not be added.
                const duplicatedEditIndex = editPermissions.findIndex((element)=>(0, $kMQVm.areSharePermissionsEqual)(sharePermission, element));
                if (duplicatedEditIndex >= 0) this.setState({
                    duplicatedEditIndex: duplicatedEditIndex
                });
                else this.setEditPermission(sharePermission, analyticsEvent);
            }
        };
    }
}
var $cbf86bf462330f63$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($cbf86bf462330f63$var$AccessWrapper);

});
parcelRegister("7O4UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e20204ce79b642c$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $dRN65 = parcelRequire("dRN65");

var $efXp3 = parcelRequire("efXp3");

var $2x3Cb = parcelRequire("2x3Cb");

var $kxqHl = parcelRequire("kxqHl");

var $6cAn5 = parcelRequire("6cAn5");
const $7e20204ce79b642c$var$fieldWrapperStyles = null;
function $7e20204ce79b642c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7e20204ce79b642c$var$isFunction(x) {
    return typeof x === 'function';
}
function $7e20204ce79b642c$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $efXp3.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $9KnKW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2x3Cb.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kxqHl.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("dRN65", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $706cd4dbd4574fd7$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $706cd4dbd4574fd7$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("efXp3", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $987e2ff089e89967$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $987e2ff089e89967$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $987e2ff089e89967$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $987e2ff089e89967$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $987e2ff089e89967$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = null;
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("kxqHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55ac25356e81a33$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d55ac25356e81a33$var$requiredIndicatorStyles = null;
function $d55ac25356e81a33$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("dqoiX", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $11827e0613b04108$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $11827e0613b04108$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $11827e0613b04108$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 * Styled copied from @atlaskit/visually-hidden
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $11827e0613b04108$export$8dd524ceb40e3d16 = {
    width: '1px',
    height: '1px',
    padding: 0,
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
const $11827e0613b04108$export$88fad6aa294f111c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});
const $11827e0613b04108$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dOvpK", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $8c2abcc805e894f7$export$4909253b5bf1eed7);

var $4f8Oj = parcelRequire("4f8Oj");

var $gvRPW = parcelRequire("gvRPW");

var $i4iBk = parcelRequire("i4iBk");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $8c2abcc805e894f7$var$isNotUndefined = (a)=>a !== undefined;
const $8c2abcc805e894f7$var$mapPayload = (payload)=>{
    const context = (0, $i4iBk.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $8c2abcc805e894f7$var$isNotUndefined);
};
const $8c2abcc805e894f7$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$8c2abcc805e894f7$var$mapPayload(payload),
        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
    }).fire();
};

});

parcelRegister("9Aocd", function(module, exports) {

$parcel$export(module.exports, "default", () => $09484d9a2d012b50$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $09484d9a2d012b50$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "shareable-entity-dialog.name",
        "defaultMessage": "Name"
    },
    description: {
        "id": "shareable-entity-dialog.description",
        "defaultMessage": "Description"
    },
    access: {
        "id": "shareable-entity-dialog.access",
        "defaultMessage": "Viewers"
    },
    editor: {
        "id": "shareable-entity-dialog.editor",
        "defaultMessage": "Editors"
    },
    owner: {
        "id": "shareable-entity-dialog.owner",
        "defaultMessage": "Owner"
    },
    nameIsRequired: {
        "id": "shareable-entity-dialog.name-is-required",
        "defaultMessage": "Name field is required"
    },
    permissionsRevoke: {
        "id": "shareable-entity-dialog.permissions-revoke",
        "defaultMessage": "Permission to share revoked for {title}"
    },
    requiredFieldsSummary: {
        "id": "shareable-entity-dialog.required-fields-summary",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});

parcelRegister("lDzQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7179c7fdb3a506d3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $6cSbZ = parcelRequire("6cSbZ");

var $2X0ZZ = parcelRequire("2X0ZZ");
class $7179c7fdb3a506d3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isEditorList: false,
            type: undefined,
            duplicatedIndex: undefined,
            customMessage: undefined,
            errorMessage: undefined
        };
    }
    render() {
        const { isEditorList: isEditorList, isShareScopeLoading: isShareScopeLoading, type: type, shareeOptions: shareeOptions, sharePermissionRows: sharePermissionRows, duplicatedIndex: duplicatedIndex, onRemove: onRemove, onAddSharePermission: onAddSharePermission, customMessage: customMessage, errorMessage: errorMessage, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
        const isOnlyPublicAndOrganization = shareeOptions.length === 2 && shareeOptions.every((i)=>i.value === (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269) || i.value === (0, $a889b3091d5309c7$export$86517eb0163ef745));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, customMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7179c7fdb3a506d3$var$CustomMessage, null, customMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2X0ZZ.default), {
            ariaLabel: ariaLabel,
            ariaLabelledby: ariaLabelledby,
            isEditorList: isEditorList,
            isShareScopeLoading: isShareScopeLoading,
            type: type,
            options: shareeOptions,
            onAddSharePermission: onAddSharePermission
        }), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $7179c7fdb3a506d3$var$errorMessageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, errorMessage)), isShareScopeLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7179c7fdb3a506d3$var$EmptyRow, null) : !!sharePermissionRows.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6cSbZ.default), {
            isEditorList: isEditorList,
            sharePermissionRows: sharePermissionRows,
            duplicatedIndex: duplicatedIndex,
            forceHideRemoveButton: isOnlyPublicAndOrganization,
            onRemove: onRemove
        }));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7179c7fdb3a506d3$var$EmptyRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz _4t3i1wpv",
            __cmplp.className
        ])
    });
});
const $7179c7fdb3a506d3$var$CustomMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _19pkidpf _syaz131l",
            __cmplp.className
        ])
    });
});
const $7179c7fdb3a506d3$var$errorMessageContainerStyles = (0, $8CUq3.xcss)({
    paddingBottom: 'space.100'
});

});
parcelRegister("qfj8c", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $b2d5b368fed948c9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $b2d5b368fed948c9$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $b2d5b368fed948c9$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $g4M8x = parcelRequire("g4M8x");

var $dRN65 = parcelRequire("dRN65");
const $b2d5b368fed948c9$var$messageStyles = null;
const $b2d5b368fed948c9$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $b2d5b368fed948c9$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $b2d5b368fed948c9$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $b2d5b368fed948c9$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4M8x))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $b2d5b368fed948c9$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("059q9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));

var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>/*#__PURE__*/ $00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
    }, props));
$00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;

});
parcelRegister("hAZqC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccf572dfbabebdf7$var$_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>/*#__PURE__*/ $ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;

});


parcelRegister("g4M8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));

var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb425bfe72dc5677$var$SuccessIcon = (props)=>/*#__PURE__*/ $bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
    }, props));
$bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;

});
parcelRegister("hs3k8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0347594f5084a834$var$_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0347594f5084a834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0347594f5084a834$var$SuccessIcon = (props)=>/*#__PURE__*/ $0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;

});

parcelRegister("kJ541", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $f16bf031974cd311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $f16bf031974cd311$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $f16bf031974cd311$var$_success.default
    }));
$f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;

});



parcelRegister("6cSbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $133853deadf5a9af$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $2Z8eU = parcelRequire("2Z8eU");
function $133853deadf5a9af$export$2e2bcd8739ae039(props) {
    const { sharePermissionRows: sharePermissionRows, onRemove: onRemove, duplicatedIndex: duplicatedIndex, forceHideRemoveButton: forceHideRemoveButton, isEditorList: isEditorList } = props;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, sharePermissionRows.map((sharePermission, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z8eU.default), {
            index: index,
            key: index,
            sharePermission: sharePermission,
            onRemove: onRemove,
            isDuplicated: duplicatedIndex === index,
            forceHideRemoveButton: forceHideRemoveButton,
            isEditorRow: isEditorList
        })));
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $133853deadf5a9af$var$shareeListStyles,
        role: "list"
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($133853deadf5a9af$var$ShareeListContainer, {
        role: "list"
    }, content);
}
$133853deadf5a9af$export$2e2bcd8739ae039.defaultProps = {
    duplicatedIndex: undefined,
    forceHideRemoveButton: false
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $133853deadf5a9af$var$ShareeListContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $133853deadf5a9af$var$shareeListStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100'
});

});
parcelRegister("2Z8eU", function(module, exports) {

$parcel$export(module.exports, "default", () => $db419ba2e74b286a$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $ed5lx = parcelRequire("ed5lx");
var $db419ba2e74b286a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $ed5lx.default));

});
parcelRegister("ed5lx", function(module, exports) {

$parcel$export(module.exports, "default", () => $847dd90ceba06adb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");


var $dCm1o = parcelRequire("dCm1o");


var $kMQVm = parcelRequire("kMQVm");

var $e0lqL = parcelRequire("e0lqL");

var $fEcPB = parcelRequire("fEcPB");

var $7cdJv = parcelRequire("7cdJv");

var $kzd4I = parcelRequire("kzd4I");

var $gAIjR = parcelRequire("gAIjR");

var $8VRWt = parcelRequire("8VRWt");

var $aVieu = parcelRequire("aVieu");
const $847dd90ceba06adb$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $847dd90ceba06adb$var$RemoveIcon = ({ sharePermission: sharePermission, isEditorRow: isEditorRow, intl: intl })=>{
    const { type: type } = sharePermission;
    let sharePermissionMessage;
    switch(type){
        case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
            sharePermissionMessage = intl.formatMessage((0, $7cdJv.default).groupPermission, {
                groupName: sharePermission.group.name
            });
            break;
        case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
            sharePermissionMessage = intl.formatMessage((0, $7cdJv.default).projectPermission, {
                projectName: sharePermission.project.name,
                projectRole: sharePermission.role?.name ?? intl.formatMessage((0, $kzd4I.default).allRoles)
            });
            break;
        case 0, $a889b3091d5309c7$export$aea0835048e1c730:
            sharePermissionMessage = intl.formatMessage((0, $7cdJv.default).userPermission, {
                displayName: sharePermission.user.displayName
            });
            break;
        case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
        case 0, $a889b3091d5309c7$export$86517eb0163ef745:
        case 0, $99958954cd57b065$export$52e14e112503bf52:
        case 0, $a889b3091d5309c7$export$487da0972e3459fe:
            sharePermissionMessage = intl.formatMessage((0, $kMQVm.allShareTypesProperties)[sharePermission.type].messageDescriptor);
            break;
        default:
            $847dd90ceba06adb$var$assertUnreachable(type);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
        spacing: "spacious",
        label: intl.formatMessage(isEditorRow ? (0, $7cdJv.default).removeEditorSharePermissionButton : (0, $7cdJv.default).removeViewerSharePermissionButton, {
            sharePermission: sharePermissionMessage
        })
    });
};
class $847dd90ceba06adb$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            forceHideRemoveButton: false
        };
    }
    renderSharePermission() {
        const { sharePermission: sharePermission, intl: intl } = this.props;
        const { type: type } = sharePermission;
        switch(type){
            case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEcPB.default), {
                    sharePermission: sharePermission
                });
            case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAIjR.default), {
                    sharePermission: sharePermission
                });
            case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8VRWt.default), null);
            case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVieu.default), {
                    sharePermission: sharePermission
                });
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
            case 0, $99958954cd57b065$export$52e14e112503bf52:
                {
                    const shareTypeProperties = (0, $kMQVm.allShareTypesProperties)[sharePermission.type];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0lqL.IconWrapper), null, shareTypeProperties.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0lqL.NameWrapper), null, intl.formatMessage(shareTypeProperties.messageDescriptor)));
                }
            default:
                $847dd90ceba06adb$var$assertUnreachable(type);
                return null;
        }
    }
    renderRow() {
        const shouldShowRemoveButton = !this.props.forceHideRemoveButton && this.props.sharePermission.type !== (0, $99958954cd57b065$export$52e14e112503bf52);
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1wug _zulpu2gc _1e0c1txw _4cvr1h6o _1ul9idpf"
            ])
        }, this.renderSharePermission()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$NameContainer, null, this.renderSharePermission()), shouldShowRemoveButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$RemoveButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$RemoveIcon, {
                intl: this.props.intl,
                isEditorRow: this.props.isEditorRow,
                sharePermission: this.props.sharePermission
            }),
            onClick: this.onRemove
        })));
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "shareable-entity-dialog.access.sharee-list.sharee-list-row.group-permission",
            role: "listitem",
            className: (0, $bwpsq.default)([
                "_1e0c1txw _4cvr1h6o _1tkexy5q"
            ])
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$RowContainer, {
            "data-testid": "shareable-entity-dialog.access.sharee-list.sharee-list-row.group-permission",
            role: "listitem"
        }, content);
    }
    render() {
        const { isDuplicated: isDuplicated } = this.props;
        const row = this.renderRow();
        return isDuplicated ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$BlinkWrapper, null, row) : row;
    }
    constructor(...args){
        super(...args), this.onRemove = (event, analyticsEvent)=>{
            const { index: index, onRemove: onRemove } = this.props;
            onRemove(index, analyticsEvent);
        };
    }
}
const $847dd90ceba06adb$var$groupPermissionStyles = null;
const $847dd90ceba06adb$var$sharePermissionStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $847dd90ceba06adb$var$RowContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $847dd90ceba06adb$var$NameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $847dd90ceba06adb$var$RemoveButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $847dd90ceba06adb$var$blinkKeyFrames = null;
// position: is specified for z-index to work. z-index is needed to show box-shadow on top of sibling elements
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $847dd90ceba06adb$var$BlinkWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _y44vcdbo _kqswh2mm _1pby15gg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e0lqL", function(module, exports) {

$parcel$export(module.exports, "NameWrapper", () => $918b0689b5ed9d88$export$45df02f361199409);
$parcel$export(module.exports, "IconWrapper", () => $918b0689b5ed9d88$export$be58b4326e23250f);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");
const $918b0689b5ed9d88$export$41fb1a16a8428b08 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _o5721q9c _1bto1l2s _18u0u2gc _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $918b0689b5ed9d88$var$NameWrapperNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $918b0689b5ed9d88$var$nameWrapperStyles
    }, children);
const $918b0689b5ed9d88$var$nameWrapperStyles = (0, $8CUq3.xcss)({
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    minWidth: '0'
});
const $918b0689b5ed9d88$export$45df02f361199409 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $918b0689b5ed9d88$var$NameWrapperNew, $918b0689b5ed9d88$export$41fb1a16a8428b08);
const $918b0689b5ed9d88$export$61485171f59c8ecb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            __cmplp.className
        ])
    });
});
const $918b0689b5ed9d88$var$IconWrapperNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $918b0689b5ed9d88$var$iconWrapperStyles
    }, children);
const $918b0689b5ed9d88$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flex: '0 0 auto',
    // Match the padding of the Avatar component
    padding: 'space.025'
});
const $918b0689b5ed9d88$export$be58b4326e23250f = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $918b0689b5ed9d88$var$IconWrapperNew, $918b0689b5ed9d88$export$61485171f59c8ecb);

});

parcelRegister("fEcPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $41d48efa411cbf93$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fptva = parcelRequire("fptva");

var $kFO36 = parcelRequire("kFO36");

var $e0lqL = parcelRequire("e0lqL");
function $41d48efa411cbf93$export$2e2bcd8739ae039({ sharePermission: { group: group } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0lqL.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
        label: "",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kFO36)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0lqL.NameWrapper), null, group.name));
}

});

parcelRegister("7cdJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74fed1ad0fcdbea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d74fed1ad0fcdbea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupPermission: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.group-permission",
        "defaultMessage": "Group {groupName}"
    },
    projectPermission: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.project-permission",
        "defaultMessage": "Project {projectName}, {projectRole}"
    },
    userPermission: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.user-permission",
        "defaultMessage": "User {displayName}"
    },
    removeViewerSharePermissionButton: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.remove-viewer-share-permission-button",
        "defaultMessage": "Remove viewer permission for {sharePermission}"
    },
    removeEditorSharePermissionButton: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.remove-editor-share-permission-button",
        "defaultMessage": "Remove editor permission for {sharePermission}"
    }
});

});

parcelRegister("kzd4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c660fd04fb607b64$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c660fd04fb607b64$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    allRoles: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.project-name.all-roles",
        "defaultMessage": "All roles"
    }
});

});

parcelRegister("gAIjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $71031e4fd465625a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3xTyb = parcelRequire("3xTyb");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $7XYc4 = parcelRequire("7XYc4");

var $wUom6 = parcelRequire("wUom6");

var $kzd4I = parcelRequire("kzd4I");
function $71031e4fd465625a$export$e9c1012e93a9bbb8(props) {
    const { intl: { formatMessage: formatMessage }, sharePermission: { project: project, role: role } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !project.avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $wUom6.AvatarIllustrationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3xTyb.default), {
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        src: project.avatarUrl,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($71031e4fd465625a$var$ProjectNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($71031e4fd465625a$var$ProjectNameWrapper, null, project.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($71031e4fd465625a$var$RoleNameWrapper, null, `, ${role && role.name || formatMessage((0, $kzd4I.default).allRoles)}`)));
}
var $71031e4fd465625a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($71031e4fd465625a$export$e9c1012e93a9bbb8);
const $71031e4fd465625a$var$ProjectNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $71031e4fd465625a$var$RoleNameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $71031e4fd465625a$var$ProjectNameWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $71031e4fd465625a$var$RoleNameWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $71031e4fd465625a$var$ProjectNameWrapper = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $71031e4fd465625a$var$RoleNameWrapper, $71031e4fd465625a$var$ProjectNameWrapperOld);

});
parcelRegister("3xTyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d92b5c1bcdeaec40$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $hQPzi = parcelRequire("hQPzi");
const $d92b5c1bcdeaec40$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($hQPzi)));
const $d92b5c1bcdeaec40$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($hQPzi)));
const $d92b5c1bcdeaec40$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: $d92b5c1bcdeaec40$export$abdf1e325e38b834,
    srcDark: $d92b5c1bcdeaec40$export$87ec2877821a8f12,
    autoDark: false
});
var $d92b5c1bcdeaec40$export$2e2bcd8739ae039 = $d92b5c1bcdeaec40$var$Illustration;
// for advanced use only
const $d92b5c1bcdeaec40$export$a179c88182cb9d56 = [
    0,
    0,
    256,
    145
];

});
parcelRegister("dCLgq", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $191b30bb5e9fa934$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $191b30bb5e9fa934$export$4d00e7be716a0093);

var $5uXOq = parcelRequire("5uXOq");

var $10ozQ = parcelRequire("10ozQ");
function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10ozQ.AsImg), props);
}
function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("10ozQ", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $b5af8835f639f069$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");
// suggested defaults, the consumer is free to override
const $b5af8835f639f069$var$defaultStyles = null;
const $b5af8835f639f069$var$fillStyles = null;
const $b5af8835f639f069$var$autoDarkModeStyles = null;
function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("hQPzi", function(module, exports) {
module.exports = new URL("default-project-avatar.6f6d91f9.svg", import.meta.url).toString();

});


parcelRegister("wUom6", function(module, exports) {

$parcel$export(module.exports, "AvatarIllustrationContainer", () => $9038c7ec9dbb687d$export$eb8ddf7dfea2a0d4);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $9038c7ec9dbb687d$export$eb8ddf7dfea2a0d4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9038c7ec9dbb687d$var$containerStyles
    }, children);
const $9038c7ec9dbb687d$var$containerStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.050',
    display: 'inline-block',
    height: '24px',
    margin: 'space.025',
    overflow: 'hidden',
    width: '24px'
});

});


parcelRegister("8VRWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5832cd7416c04198$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bU3PY = parcelRequire("bU3PY");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");


var $kMQVm = parcelRequire("kMQVm");

var $e0lqL = parcelRequire("e0lqL");

var $dRdD7 = parcelRequire("dRdD7");
const $5832cd7416c04198$export$9dc8ff4861a5b6ef = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _19bv1b66 _s7n4nkob",
            __cmplp.className
        ])
    });
});
const $5832cd7416c04198$var$UnknownProject = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const shareTypeProperties = (0, $kMQVm.allShareTypesProperties)[0, $a889b3091d5309c7$export$487da0972e3459fe];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0lqL.IconWrapper), null, shareTypeProperties.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0lqL.NameWrapper), null, formatMessage(shareTypeProperties.messageDescriptor), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $dRdD7.default).unknownProjectWarning),
        /* @ts-expect-error Incompatible ref type in tooltip */ tag: $5832cd7416c04198$export$9dc8ff4861a5b6ef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        label: formatMessage((0, $dRdD7.default).unknownProjectWarning),
        LEGACY_size: "medium",
        spacing: "spacious",
        color: "var(--ds-icon-accent-gray, #758195)"
    }))));
};
var $5832cd7416c04198$export$2e2bcd8739ae039 = $5832cd7416c04198$var$UnknownProject;

});
parcelRegister("dRdD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $27775c6f2dd74e16$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $27775c6f2dd74e16$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unknownProjectWarning: {
        "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.unknown-project.unknown-project-warning",
        "defaultMessage": "You do not have access to this project. Saving will remove this share."
    }
});

});


parcelRegister("aVieu", function(module, exports) {

$parcel$export(module.exports, "default", () => $31c1c6d556d26b70$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $e16Mp = parcelRequire("e16Mp");

var $dCm1o = parcelRequire("dCm1o");

var $7XYc4 = parcelRequire("7XYc4");

var $wUom6 = parcelRequire("wUom6");
const $31c1c6d556d26b70$var$UserName = (props)=>{
    const { sharePermission: { user: user } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !user.avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $wUom6.AvatarIllustrationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e16Mp))), {
        spacing: "spacious",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'circle' : 'square',
        src: user.avatarUrl,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31c1c6d556d26b70$var$UserNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31c1c6d556d26b70$var$UserNameWrapper, null, user.displayName)));
};
var $31c1c6d556d26b70$export$2e2bcd8739ae039 = $31c1c6d556d26b70$var$UserName;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31c1c6d556d26b70$var$UserNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $31c1c6d556d26b70$var$RoleNameWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $31c1c6d556d26b70$var$UserNameWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $31c1c6d556d26b70$var$RoleNameWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $31c1c6d556d26b70$var$UserNameWrapper = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $31c1c6d556d26b70$var$RoleNameWrapper, $31c1c6d556d26b70$var$UserNameWrapperOld);

});




parcelRegister("2X0ZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a3ed40679122bc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $h18n7 = parcelRequire("h18n7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07a3ed40679122bc$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { atlassianAccountId: atlassianAccountId, isAdmin: isAdmin } })=>atlassianAccountId != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h18n7.default), {
            accountId: (0, $g5X3G.toAccountId)(atlassianAccountId),
            isAdmin: isAdmin,
            ...props
        }));

});
parcelRegister("h18n7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0524d0793d201f28$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8QpSo = parcelRequire("8QpSo");

var $fVnbM = parcelRequire("fVnbM");

var $qfj8c = parcelRequire("qfj8c");

var $kgoHi = parcelRequire("kgoHi");

var $gwIPs = parcelRequire("gwIPs");

var $lMdZA = parcelRequire("lMdZA");

var $ousew = parcelRequire("ousew");

var $az4zD = parcelRequire("az4zD");

var $fs8YG = parcelRequire("fs8YG");

var $eMLW9 = parcelRequire("eMLW9");


var $imOJb = parcelRequire("imOJb");

var $dCm1o = parcelRequire("dCm1o");


var $96ZCx = parcelRequire("96ZCx");

var $4tJPV = parcelRequire("4tJPV");
const $0524d0793d201f28$var$mapToPickerProject = (0, $8QpSo.default)((project)=>{
    if (!project) return undefined;
    return {
        value: project.id,
        name: project.name,
        avatarUrl: project.avatarUrl
    };
});
const $0524d0793d201f28$var$mapFromPickerProject = (0, $8QpSo.default)((project)=>({
        id: project.value,
        name: project.name,
        avatarUrl: project.avatarUrl
    }));
const $0524d0793d201f28$var$defaultPickerType = (0, $a889b3091d5309c7$export$b02d7412182d1bce);
const $0524d0793d201f28$var$getStateChangesOnTypeChange = (type)=>({
        selectedType: type,
        selectedGroup: undefined,
        selectedProject: undefined,
        selectedRole: undefined,
        selectedUser: undefined
    }); // eslint-disable-next-line jira/react/no-class-components
class $0524d0793d201f28$export$aa7f7f1ebf5525ed extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            type: undefined
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { type: type } = props;
        const { selectedType: selectedType, previousPropsType: previousPropsType } = state;
        if (!type || type === previousPropsType || type === selectedType) return {
            previousPropsType: type
        };
        return {
            previousPropsType: type,
            ...$0524d0793d201f28$var$getStateChangesOnTypeChange(type || selectedType || $0524d0793d201f28$var$defaultPickerType) // type can be undefined e.g. when user clicked Add to add a new row. If it is not passed via props - preserve currently selected dropdown value
        };
    }
    getShareTypeHelperMessage() {
        const { selectedType: selectedType } = this.state;
        if (this.props.isShareScopeLoading) return (0, $96ZCx.default).shareScopeLoadingHelperMessage;
        switch(selectedType){
            case 0, $99958954cd57b065$export$52e14e112503bf52:
                return (0, $96ZCx.default).privateShareHelperMessage;
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                return (0, $96ZCx.default).safePublicShareHelperMessage;
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                return (0, $96ZCx.default).openShareHelperMessage;
            default:
                return undefined;
        }
    }
    getOptionsWithHelperMessage() {
        const { options: options, intl: { formatMessage: formatMessage } } = this.props;
        const { selectedType: selectedType } = this.state;
        const message = this.getShareTypeHelperMessage();
        return options.map((option)=>{
            if (message && option.value === selectedType) return {
                ...option,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                label: formatMessage(message, {
                    website: window.location.host
                })
            };
            return option;
        });
    }
    onKeyDown(event) {
        if (event.key === 'Escape') event.stopPropagation();
    }
    renderPicker() {
        const { accountId: accountId, isAdmin: isAdmin, intl: { formatMessage: formatMessage } } = this.props;
        const { selectedType: selectedType, selectedGroup: selectedGroup, selectedProject: selectedProject, selectedRole: selectedRole, selectedUser: selectedUser } = this.state;
        switch(selectedType){
            case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lMdZA.default), {
                    placeholder: formatMessage((0, $96ZCx.default).groupPlaceholderText),
                    baseUrl: "" // @ts-expect-error - Type '(value: SharePermissionGroup) => void' is not assignable to type '(arg1: Group | undefined, args_1: UIAnalyticsEvent) => void'.
                    ,
                    onChange: this.onGroupChange,
                    fetchOnce: false,
                    withMember: isAdmin ? undefined : accountId || undefined,
                    selectedGroup: selectedGroup,
                    width: (0, $gwIPs.gridSize) * 40,
                    isCompact: true,
                    onKeyDown: this.onKeyDown
                });
            case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imOJb.default), {
                    placeholder: formatMessage((0, $96ZCx.default).userPlaceholderText),
                    baseUrl: "" // @ts-expect-error - Type '(value: SharePermissionUser) => void' is not assignable to type '(arg1: User | undefined, args_1: UIAnalyticsEvent) => void'.
                    ,
                    onChange: this.onUserChange,
                    selectedUser: selectedUser,
                    width: (0, $gwIPs.gridSize) * 40,
                    isCompact: true,
                    onKeyDown: this.onKeyDown
                });
            case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ColumnWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fs8YG.default), {
                    placeholder: formatMessage((0, $96ZCx.default).projectPlaceholderText),
                    baseUrl: "" // @ts-expect-error - Type '(value?: PickedProject) => void' is not assignable to type '(arg1: Project | undefined, args_1: UIAnalyticsEvent) => void'.
                    ,
                    onChange: this.onProjectChange,
                    selectedProject: $0524d0793d201f28$var$mapToPickerProject(selectedProject),
                    width: (0, $gwIPs.gridSize) * 20,
                    isCompact: true,
                    requireBrowsePermission: !isAdmin,
                    onKeyDown: this.onKeyDown
                })), selectedProject ? /* passing key to rerender and therefore refetch options when new project is selected  */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ColumnWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMLW9.default // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
                ), {
                    key: selectedProject.id,
                    placeholder: formatMessage((0, $96ZCx.default).rolePlaceholderText),
                    baseUrl: "" // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
                    ,
                    projectId: selectedProject.id,
                    onChange: this.onRoleChange,
                    selectedRole: selectedRole,
                    width: (0, $gwIPs.gridSize) * 20,
                    isCompact: true,
                    isCurrentMember: !isAdmin,
                    onKeyDown: this.onKeyDown
                })) : null);
            default:
                return null;
        }
    }
    render() {
        const { intl: { formatMessage: formatMessage }, options: options, isShareScopeLoading: isShareScopeLoading, isEditorList: isEditorList, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
        const isOnlyPublicAndOrganization = options.length === 2 && options.every((i)=>i.value === (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269) || i.value === (0, $a889b3091d5309c7$export$86517eb0163ef745));
        const { selectedType: selectedType } = this.state;
        const shareTypeHelperMessage = this.getShareTypeHelperMessage();
        const optionsWithLabelsForScreenReader = this.getOptionsWithHelperMessage();
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$PickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ColumnWrapper, null, isEditorList ? /* @ts-expect-error - Property 'isEditorList' is missing in type '{ ariaLabel: string | undefined; ariaLabelledby: string | undefined; type: ShareType; isShareScopeLoading: boolean; options: Option[]; onChange: (type: ShareType) => void; }' but required in type 'Pick<Omit<{ isShareScopeLoading: boolean; isEditorList: boolean; ariaLabel?: string | undefined; ariaLabelledby?: string | undefined; } & Intl & { type: ShareType; options: Option[]; onChange: (arg1: ShareType, arg2: UIAnalyticsEvent) => void; }, "intl">, "onChange" | ... 5 more ... | "options">'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tJPV.EditorTypePicker), {
            ariaLabel: ariaLabel,
            ariaLabelledby: ariaLabelledby,
            type: selectedType,
            isShareScopeLoading: isShareScopeLoading,
            options: optionsWithLabelsForScreenReader,
            onChange: this.onTypeChange
        }) : /* @ts-expect-error - Property 'isEditorList' is missing in type '{ ariaLabel: string | undefined; ariaLabelledby: string | undefined; type: ShareType; isShareScopeLoading: boolean; options: Option[]; onChange: (type: ShareType) => void; }' but required in type 'Pick<Omit<{ isShareScopeLoading: boolean; isEditorList: boolean; ariaLabel?: string | undefined; ariaLabelledby?: string | undefined; } & Intl & { type: ShareType; options: Option[]; onChange: (arg1: ShareType, arg2: UIAnalyticsEvent) => void; }, "intl">, "onChange" | ... 5 more ... | "options">'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tJPV.default), {
            ariaLabel: ariaLabel,
            ariaLabelledby: ariaLabelledby,
            type: selectedType,
            isShareScopeLoading: isShareScopeLoading,
            options: optionsWithLabelsForScreenReader,
            onChange: this.onTypeChange
        })), shareTypeHelperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ColumnWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...shareTypeHelperMessage,
            values: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                website: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, window.location.host)
            }
        }))), !isShareScopeLoading && this.renderPicker()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$AddButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            isDisabled: isShareScopeLoading,
            onClick: this.onAdd,
            "aria-label": formatMessage(isEditorList ? (0, $96ZCx.default).addEditors : (0, $96ZCx.default).addViewers)
        }, isOnlyPublicAndOrganization ? formatMessage((0, $96ZCx.default).update) : formatMessage((0, $96ZCx.default).add))));
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center"
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ShareePickerContainer, null, content);
    }
    constructor(...args){
        super(...args), this.state = {
            // disabling unused state checks due to https://github.com/yannickcr/eslint-plugin-react/issues/1759
            previousPropsType: undefined,
            selectedType: $0524d0793d201f28$var$defaultPickerType,
            selectedGroup: undefined,
            selectedProject: undefined,
            selectedRole: undefined,
            selectedUser: undefined
        }, this.onTypeChange = (type)=>{
            // @ts-expect-error - TS2345 - Argument of type 'Partial<State>' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
            this.setState($0524d0793d201f28$var$getStateChangesOnTypeChange(type));
        }, this.onUserChange = (value)=>{
            this.setState({
                selectedUser: value
            });
        }, this.onGroupChange = (value)=>{
            this.setState({
                selectedGroup: value
            });
        }, this.onProjectChange = (value)=>{
            this.setState({
                selectedProject: value && $0524d0793d201f28$var$mapFromPickerProject(value),
                selectedRole: undefined
            });
        }, this.onRoleChange = (role)=>{
            this.setState({
                selectedRole: role
            });
        }, this.onAdd = (event, analyticsEvent)=>{
            const { onAddSharePermission: onAddSharePermission } = this.props;
            const { selectedType: selectedType, selectedGroup: selectedGroup, selectedProject: selectedProject, selectedRole: selectedRole, selectedUser: selectedUser } = this.state;
            switch(selectedType){
                case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                    if (selectedGroup) onAddSharePermission({
                        type: (0, $a889b3091d5309c7$export$b02d7412182d1bce),
                        group: selectedGroup
                    }, analyticsEvent);
                    break;
                case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                    if (selectedUser) onAddSharePermission({
                        type: (0, $a889b3091d5309c7$export$aea0835048e1c730),
                        user: selectedUser
                    }, analyticsEvent);
                    break;
                case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                    if (selectedProject) onAddSharePermission({
                        type: (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                        project: selectedProject,
                        role: selectedRole
                    }, analyticsEvent);
                    break;
                case 0, $99958954cd57b065$export$52e14e112503bf52:
                    onAddSharePermission({
                        type: (0, $99958954cd57b065$export$52e14e112503bf52)
                    }, analyticsEvent);
                    break;
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                    onAddSharePermission({
                        type: (0, $a889b3091d5309c7$export$86517eb0163ef745)
                    }, analyticsEvent);
                    break;
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    onAddSharePermission({
                        type: (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)
                    }, analyticsEvent);
                    break;
                default:
                    return undefined;
            }
            return undefined;
        };
    }
}
var $0524d0793d201f28$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($0524d0793d201f28$export$aa7f7f1ebf5525ed);
const $0524d0793d201f28$var$ShareePickerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0524d0793d201f28$var$PickerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0524d0793d201f28$var$ColumnWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0524d0793d201f28$var$AddButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eMLW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bdc4a2fd9010a2a$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $4GgYN = parcelRequire("4GgYN");
var $1bdc4a2fd9010a2a$export$2e2bcd8739ae039 = (0, $8oe80.default)('RolePicker', {
    onChange: 'changed'
})((0, $4GgYN.default));

});
parcelRegister("4GgYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7261cefebafe3f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $4U4qk = parcelRequire("4U4qk");

var $az4zD = parcelRequire("az4zD");

var $dTXVf = parcelRequire("dTXVf");

var $eyiiq = parcelRequire("eyiiq");
const $e7261cefebafe3f4$var$filterOptions = (filter = '')=>{
    const lowerCaseFilter = filter.toLowerCase();
    // @ts-expect-error - TS7006 - Parameter 'option' implicitly has an 'any' type.
    return (option)=>option.label && option.label.toLowerCase().includes(lowerCaseFilter);
};
const $e7261cefebafe3f4$var$transformRoleIntoOption = (role)=>role && {
        label: role.name,
        value: role.id,
        url: role.url,
        description: role.description
    };
const $e7261cefebafe3f4$var$transformOptionIntoRole = (option)=>option && {
        name: option.label,
        id: option.value,
        url: option.url,
        description: option.description
    };
class $e7261cefebafe3f4$export$fcd75734e151a80 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            isCurrentMember: true,
            width: 200
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedRole: $e7261cefebafe3f4$var$transformRoleIntoOption(this.props.selectedRole),
            prevSelectedRole: $e7261cefebafe3f4$var$transformRoleIntoOption(this.props.selectedRole),
            options: []
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedRole: selectedOption
            });
            this.props.onChange($e7261cefebafe3f4$var$transformOptionIntoRole(selectedOption));
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = (filter)=>{
            const { baseUrl: baseUrl, projectId: projectId, isCurrentMember: isCurrentMember } = this.props;
            const { options: options } = this.state;
            return new Promise((resolve, reject)=>{
                if (options.length) return resolve(options.filter($e7261cefebafe3f4$var$filterOptions(filter)));
                return (0, $dTXVf.requestRoles)(baseUrl, projectId, isCurrentMember).then((newOptions)=>{
                    this.setState({
                        options: newOptions
                    });
                    return resolve(newOptions.filter($e7261cefebafe3f4$var$filterOptions(filter)));
                }, reject);
            });
        };
        this.rolePickerId = `project-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const { selectedRole: selectedRole } = props;
        const currentRole = selectedRole && selectedRole.id;
        const prevRole = state.prevSelectedRole && state.prevSelectedRole.value;
        if (currentRole !== prevRole) {
            const selectedRoleOption = $e7261cefebafe3f4$var$transformRoleIntoOption(selectedRole);
            return {
                ...state,
                selectedRole: selectedRoleOption,
                prevSelectedRole: selectedRoleOption
            };
        }
        return null;
    }
    componentDidMount() {
        const { selectedRole: selectedRole } = this.state;
        if (selectedRole && !selectedRole.label) this.fetchRole(selectedRole);
    }
    componentDidUpdate() {
        const { selectedRole: selectedRole } = this.state;
        if (selectedRole && !selectedRole.label) this.fetchRole(selectedRole);
    }
    fetchRole(selectedRole) {
        const { baseUrl: baseUrl, projectId: projectId } = this.props;
        const optionValue = selectedRole.value;
        const updateSelectedRole = (newRole)=>{
            const currentRole = this.state.selectedRole;
            const currentRoleValue = currentRole && currentRole.value;
            // Update the state only in case the project wasn't changed
            if (currentRoleValue === optionValue) this.setState({
                selectedRole: newRole
            });
        };
        return (0, $dTXVf.requestRole)(baseUrl, projectId, optionValue).then((role)=>updateSelectedRole(role)).catch(()=>updateSelectedRole(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, onChange: onChange, projectId: projectId, selectedRole: selectedRole, ...props } = this.props;
        const { selectedRole: role } = this.state;
        return /* @ts-expect-error - Type '{ inputId: string; errorMessage: string; placeholder: string; onSelected: (selectedOption?: RoleOption | undefined) => void; options: (filter: string) => Promise<RoleOptions>; ... 8 more ...; "aria-label": string | undefined; }' is not assignable to type 'InexactPartial<Pick<Omit<ViewProps<RoleOption>, "intl">, "isRequired" | "isDisabled" | "isClearable" | "isCompact" | "label" | "width" | "isCreatable" | "isCheckbox" | ... 4 more ... | "noPortal">>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.default), {
            "aria-label": !this.props.label ? formatMessage((0, $eyiiq.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.rolePickerId : this.props.inputId,
            errorMessage: formatMessage((0, $eyiiq.default).error),
            placeholder: formatMessage((0, $eyiiq.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            value: role && role.label ? role : null
        });
    }
}
var $e7261cefebafe3f4$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($e7261cefebafe3f4$export$fcd75734e151a80);

});
parcelRegister("dTXVf", function(module, exports) {

$parcel$export(module.exports, "requestRoles", () => $6817e21b7afb963f$export$81b6bcb1593f7ad8);
$parcel$export(module.exports, "requestRole", () => $6817e21b7afb963f$export$258bff876f7723cb);

var $1K1Tu = parcelRequire("1K1Tu");

var $67oaB = parcelRequire("67oaB");
const $6817e21b7afb963f$export$81b6bcb1593f7ad8 = (baseUrl, projectId, isCurrentMember)=>(0, $1K1Tu.getRoles)(baseUrl, projectId, isCurrentMember).then((0, $67oaB.transformRoles));
const $6817e21b7afb963f$export$258bff876f7723cb = (baseUrl, projectId, RoleId)=>(0, $1K1Tu.getRole)(baseUrl, projectId, RoleId).then((0, $67oaB.transformRole));

});
parcelRegister("1K1Tu", function(module, exports) {

$parcel$export(module.exports, "getRoles", () => $fcf9bea3774b5ab1$export$57690667ea6b189b);
$parcel$export(module.exports, "getRole", () => $fcf9bea3774b5ab1$export$d1c3a5ff834adfa2);

var $7f4tk = parcelRequire("7f4tk");
const $fcf9bea3774b5ab1$export$29d3dfcf36fbbba5 = (baseUrl, projectId)=>`${baseUrl}/rest/api/2/project/${encodeURIComponent(projectId)}`;
const $fcf9bea3774b5ab1$export$1eec61a4fdaceca = (baseUrl, projectId, isCurrentMember)=>`${$fcf9bea3774b5ab1$export$29d3dfcf36fbbba5(baseUrl, projectId)}/roledetails${isCurrentMember ? '?currentMember=true' : ''}`;
const $fcf9bea3774b5ab1$export$177b7e5a782e5173 = (baseUrl, projectId, roleId)=>`${$fcf9bea3774b5ab1$export$29d3dfcf36fbbba5(baseUrl, projectId)}/role/${encodeURIComponent(roleId)}`;
const $fcf9bea3774b5ab1$export$57690667ea6b189b = (baseUrl, projectId, isCurrentMember)=>(0, $7f4tk.default)($fcf9bea3774b5ab1$export$1eec61a4fdaceca(baseUrl, projectId, isCurrentMember));
const $fcf9bea3774b5ab1$export$d1c3a5ff834adfa2 = (baseUrl, projectId, roleId)=>(0, $7f4tk.default)($fcf9bea3774b5ab1$export$177b7e5a782e5173(baseUrl, projectId, roleId));

});

parcelRegister("67oaB", function(module, exports) {

$parcel$export(module.exports, "transformRole", () => $b107ae56f6577753$export$4f8aa0fda592cc8e);
$parcel$export(module.exports, "transformRoles", () => $b107ae56f6577753$export$18407dd0d4132046);
const $b107ae56f6577753$export$4f8aa0fda592cc8e = (role)=>({
        value: role.id,
        label: role.name,
        description: role.description,
        url: role.self
    });
const $b107ae56f6577753$export$18407dd0d4132046 = (roles)=>roles && roles.map($b107ae56f6577753$export$4f8aa0fda592cc8e) || [];

});


parcelRegister("eyiiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18db9d0f15e57bec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $18db9d0f15e57bec$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "role-picker.error",
        "defaultMessage": "We couldn't retrieve roles"
    },
    placeholder: {
        "id": "role-picker.placeholder",
        "defaultMessage": "All roles"
    },
    labelText: {
        "id": "role-picker.label-text",
        "defaultMessage": "Role"
    }
});

});



parcelRegister("96ZCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b1d0778f6b8c17$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f5b1d0778f6b8c17$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    add: {
        "id": "shareable-entity-dialog.access.sharee-picker.add",
        "defaultMessage": "Add"
    },
    update: {
        "id": "shareable-entity-dialog.access.sharee-picker.update",
        "defaultMessage": "Update"
    },
    openShareHelperMessage: {
        "id": "shareable-entity-dialog.access.sharee-picker.open-share-helper-message",
        "defaultMessage": "Any logged in user on {website}"
    },
    safePublicShareHelperMessage: {
        "id": "shareable-entity-dialog.access.sharee-picker.safe-public-share-helper-message",
        "defaultMessage": "Anyone on the internet. No sign-in required"
    },
    privateShareHelperMessage: {
        "id": "shareable-entity-dialog.access.sharee-picker.private-share-helper-message",
        "defaultMessage": "Only you"
    },
    shareScopeLoadingHelperMessage: {
        "id": "shareable-entity-dialog.access.sharee-picker.share-scope-loading-helper-message",
        "defaultMessage": "Checking for the default user preference"
    },
    addViewers: {
        "id": "shareable-entity-dialog.access.sharee-picker.add-viewers",
        "defaultMessage": "Add viewers"
    },
    addEditors: {
        "id": "shareable-entity-dialog.access.sharee-picker.add-editors",
        "defaultMessage": "Add editors"
    },
    projectPlaceholderText: {
        "id": "shareable-entity-dialog.access.sharee-picker.project-placeholder-text",
        "defaultMessage": "Select project"
    },
    userPlaceholderText: {
        "id": "shareable-entity-dialog.access.sharee-picker.user-placeholder-text",
        "defaultMessage": "Select user"
    },
    groupPlaceholderText: {
        "id": "shareable-entity-dialog.access.sharee-picker.group-placeholder-text",
        "defaultMessage": "Select group"
    },
    rolePlaceholderText: {
        "id": "shareable-entity-dialog.access.sharee-picker.role-placeholder-text",
        "defaultMessage": "Select role"
    }
});

});

parcelRegister("4tJPV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0652ef7cc6a18d8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EditorTypePicker", () => $c0652ef7cc6a18d8$export$79b74763bbaf2964);

var $iQv12 = parcelRequire("iQv12");

var $8xVQG = parcelRequire("8xVQG");
var $c0652ef7cc6a18d8$export$2e2bcd8739ae039 = (0, $iQv12.default)({
    onChange: 'pickShareeType'
})((0, $8xVQG.default));
const $c0652ef7cc6a18d8$export$79b74763bbaf2964 = (0, $iQv12.default)({
    onChange: 'pickEditorType'
})((0, $8xVQG.default));

});
parcelRegister("8xVQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a3c798582ea2821$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $4USKh = parcelRequire("4USKh");

var $gwIPs = parcelRequire("gwIPs");

var $az4zD = parcelRequire("az4zD");


var $coL5i = parcelRequire("coL5i");
const $0a3c798582ea2821$var$getOption = (options, type)=>options.find((option)=>option.value === type) || options[0];
const $0a3c798582ea2821$var$getNormalizedOptions = (0, $8QpSo.default)((options, formatMessage)=>options.map((option)=>{
        const returnOption = {
            ...option,
            label: formatMessage(option.messageDescriptor)
        };
        if (!returnOption.isDisabled) return returnOption;
        if (returnOption.value === (0, $a889b3091d5309c7$export$86517eb0163ef745)) return {
            ...returnOption,
            disableReason: formatMessage((0, $coL5i.default).globalDisableReason)
        };
        return returnOption;
    }));
class $0a3c798582ea2821$export$60cbee36e1a5d2a2 extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        const { options: options, type: type } = props;
        if (state.selectedOption && state.selectedOption.value === type) return null;
        return {
            selectedOption: $0a3c798582ea2821$var$getOption(options, type)
        };
    }
    render() {
        const { isShareScopeLoading: isShareScopeLoading, options: options, intl: { formatMessage: formatMessage }, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
        const normalizedOptions = $0a3c798582ea2821$var$getNormalizedOptions(options, formatMessage);
        const normalizedSelectOption = $0a3c798582ea2821$var$getOption(normalizedOptions, this.props.type);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatarAndAnalytics), {
            // @ts-expect-error - Type '(option: Option, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(arg1: unknown, arg2: UIAnalyticsEvent | undefined, args_2: UIAnalyticsEvent) => any'.
            onSelected: this.onChange,
            options: normalizedOptions,
            // @ts-expect-error - Type '(option: Option) => { avatar: React.ReactNode; label: string; }' is not assignable to type 'FormatOptionDataTransformer<unknown>'.
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            // @ts-expect-error - Type 'number' is not assignable to type 'string'.
            width: (0, $gwIPs.gridSize) * 20,
            listItemCustomStyles: {
                // Custom internal styling API for PickerWithAvatarAndAnalytics
                marginBottom: 2
            },
            isRequired: false,
            isDisabled: isShareScopeLoading,
            isClearable: false,
            isCompact: true,
            ...isShareScopeLoading ? {
                placeholder: ''
            } : {
                value: normalizedSelectOption
            },
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            getOptionLabel: this.screenReaderLabelForOption,
            // @ts-expect-error - Type '(event: KeyboardEvent<HTMLDivElement>) => void' is not assignable to type '(arg1: KeyboardEvent<HTMLElement>) => void'.
            onKeyDown: this.onKeyDown
        });
    }
    constructor(...args){
        super(...args), this.state = {
            selectedOption: $0a3c798582ea2821$var$getOption(this.props.options, this.props.type)
        }, this.onChange = (option, analyticsEvent)=>{
            const { onChange: onChange } = this.props;
            onChange(option.value, analyticsEvent);
        }, this.onKeyDown = (event)=>{
            if (event.key === 'Escape') event.stopPropagation();
        }, // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.screenReaderLabelForOption = (option)=>{
            const { options: options } = this.props;
            const currentOption = options?.length && options.find((optionFromList)=>optionFromList.value === option.value);
            if (currentOption && currentOption.label) return `${option.label}, ${currentOption.label}`;
            return option.label;
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (option)=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return {
                avatar: option.icon,
                label: formatMessage(option.messageDescriptor)
            };
        };
    }
}
var $0a3c798582ea2821$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($0a3c798582ea2821$export$60cbee36e1a5d2a2);

});
parcelRegister("coL5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $daaec463f6cc4d92$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $daaec463f6cc4d92$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    globalDisableReason: {
        "id": "shareable-entity-dialog.access.sharee-picker.sharee-type-picker.global-disable-reason",
        "defaultMessage": "This option has been disabled by your Jira administrator"
    }
});

});







parcelRegister("iJRxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $31fb5dc919182b4f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8QpSo = parcelRequire("8QpSo");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $kxqHl = parcelRequire("kxqHl");

var $7QSqG = parcelRequire("7QSqG");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $6LCpJ = parcelRequire("6LCpJ");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $hZHze = parcelRequire("hZHze");

var $az4zD = parcelRequire("az4zD");

var $4R6GH = parcelRequire("4R6GH");


var $6lbCM = parcelRequire("6lbCM");

var $7iGYR = parcelRequire("7iGYR");

var $9Aocd = parcelRequire("9Aocd");
const $31fb5dc919182b4f$export$f3336396f1d7e7f0 = 'shareable-entity-dialog.input-name';
const $31fb5dc919182b4f$export$4ec563c550ebe302 = 'shareable-entity-dialog.text-field';
const $31fb5dc919182b4f$var$toPickerUser = (0, $8QpSo.default)(({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrl
    })); // eslint-disable-next-line jira/react/no-class-components
class $31fb5dc919182b4f$export$4e8eacd46550c748 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isPending: false,
            isEditorListShown: false,
            isNameReadOnly: false,
            owner: undefined
        };
    }
    renderFooter() {
        const { onCancel: onCancel, actionButtonCaption: actionButtonCaption, onAction: onAction, isPending: isPending, isNameRequiredError: isNameRequiredError, isShareScopeLoading: isShareScopeLoading = false } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iGYR.default), {
            isActionEnabled: !isPending && !isNameRequiredError && !isShareScopeLoading,
            isActionInProgress: isPending,
            actionButtonCaption: actionButtonCaption,
            onAction: onAction,
            onCancel: onCancel
        });
    }
    renderModalBody() {
        const { isNameRequiredError: isNameRequiredError, isShareScopeLoading: isShareScopeLoading = false, intl: { formatMessage: formatMessage }, isEditorListShown: isEditorListShown, isNameReadOnly: isNameReadOnly, editOptions: editOptions, editPermissions: editPermissions, name: name, nameInputRef: nameInputRef, nameTooltip: nameTooltip, description: description, owner: owner, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, UserPicker: UserPicker, Access: Access, onDescriptionChange: onDescriptionChange, onEditPermissionChange: onEditPermissionChange, onNameChange: onNameChange, onOwnerChange: onOwnerChange, onSharePermissionChange: onSharePermissionChange, shareeOptions: shareeOptions, serverValidationErrors: serverValidationErrors } = this.props;
        const nameServerValidationError = serverValidationErrors[0, $99958954cd57b065$export$b85469cbf362db42];
        const descriptionServerValidationError = serverValidationErrors[0, $99958954cd57b065$export$a1d4ae33ba772a5b];
        const sharePermissionsServerValidationError = serverValidationErrors[0, $99958954cd57b065$export$378fd4cd7d69440f];
        const editPermissionsServerValidationError = serverValidationErrors[0, $99958954cd57b065$export$fb465a1f4d511f87];
        const nameValidationErrorMessage = isNameRequiredError ? formatMessage((0, $9Aocd.default).nameIsRequired) : nameServerValidationError;
        const renderNameField = (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                testId: $31fb5dc919182b4f$export$4ec563c550ebe302,
                value: name,
                isDisabled: isNameReadOnly,
                onChange: onNameChange,
                isInvalid: !!nameValidationErrorMessage,
                ref: nameInputRef,
                "aria-describedby": `${$31fb5dc919182b4f$export$f3336396f1d7e7f0}-error`
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $9Aocd.default).name),
            isRequired: true,
            name: "name",
            id: $31fb5dc919182b4f$export$f3336396f1d7e7f0
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, nameTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: nameTooltip
            }, renderNameField(fieldProps)) : renderNameField(fieldProps), nameValidationErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, nameValidationErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $9Aocd.default).description),
            name: "description"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
                ...fieldProps,
                value: description,
                onChange: onDescriptionChange,
                isInvalid: !!descriptionServerValidationError
            }), descriptionServerValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, descriptionServerValidationError))), owner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $9Aocd.default).owner),
            name: "owner"
        }, ({ fieldProps: { //  @ts-expect-error - TS7053: Element implicitly has an 'any' type because expression of type '"aria-label"' can't be used to index type 'FieldProps<string, HTMLInputElement>'.
        'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(UserPicker, {
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledby,
                selectedUser: $31fb5dc919182b4f$var$toPickerUser(owner),
                onChange: onOwnerChange
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Access, {
            isShareScopeLoading: isShareScopeLoading,
            shareeOptions: shareeOptions,
            editOptions: editOptions,
            sharePermissions: sharePermissions,
            viewersCustomMessage: viewersCustomMessage,
            editPermissions: editPermissions,
            onSharePermissionChange: onSharePermissionChange,
            onEditPermissionChange: onEditPermissionChange,
            isEditorListShown: isEditorListShown,
            sharePermissionsServerValidationError: sharePermissionsServerValidationError,
            editPermissionsServerValidationError: editPermissionsServerValidationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null));
    }
    render() {
        const { title: title, headingTitleLevel: headingTitleLevel, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, title && (headingTitleLevel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lbCM.default), {
            headingLevel: headingTitleLevel,
            title: title
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, (0, $4R6GH.fg)('blu-7175-shareable-entity-instruction-aria') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31fb5dc919182b4f$var$RequiredMessage, null, intl.formatMessage((0, $9Aocd.default).requiredFieldsSummary), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxqHl.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31fb5dc919182b4f$var$RequiredMessage, {
            "aria-hidden": "true"
        }, intl.formatMessage((0, $9Aocd.default).requiredFieldsSummary), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxqHl.default), null)), this.renderModalBody()), this.renderFooter());
    }
}
var $31fb5dc919182b4f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($31fb5dc919182b4f$export$4e8eacd46550c748);
const $31fb5dc919182b4f$var$RequiredMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});

parcelRegister("kY99m", function(module, exports) {

$parcel$export(module.exports, "default", () => $509076ff0c6afa78$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $509076ff0c6afa78$var$containerMedia = {
    invalid: "_srjtgir2",
    disabled: "_6up518qt"
};
const $509076ff0c6afa78$var$inputMediaDisabled = null;
const $509076ff0c6afa78$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $509076ff0c6afa78$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $509076ff0c6afa78$var$invalidStyle = null;
const $509076ff0c6afa78$var$focusWithinStyle = {
    standard: "_ochr1p6i _195er01l _bqhtq049",
    subtle: "_ochr1p6i _195er01l _bqhtq049",
    none: "_ochr3acm _195e18uv _bqhtnruj"
};
const $509076ff0c6afa78$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $509076ff0c6afa78$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _srjtgir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _srjtgir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _srjtgir2"
};
const $509076ff0c6afa78$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $509076ff0c6afa78$var$getMaxWidth = (width)=>!width ? `100%` : width in $509076ff0c6afa78$var$widthMap ? `${$509076ff0c6afa78$var$widthMap[width]}px` : `${+width}px`;
const $509076ff0c6afa78$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $509076ff0c6afa78$var$containerStyles = null;
const $509076ff0c6afa78$var$inputDisabledStyle = null;
const $509076ff0c6afa78$var$inputCompactStyleWithFg = null;
const $509076ff0c6afa78$var$inputCompactStyle = null;
const $509076ff0c6afa78$var$inputMonospacedStyle = null;
const $509076ff0c6afa78$var$inputFontStyleWithFG = null;
const $509076ff0c6afa78$var$inputStyleMonospacedWithFg = null;
const $509076ff0c6afa78$var$inputStyleNotDataCompactWithFG = null;
const $509076ff0c6afa78$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $509076ff0c6afa78$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$509076ff0c6afa78$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $509076ff0c6afa78$var$getContainerTextBgAndBorderColor[appearance],
            $509076ff0c6afa78$var$containerStyleAppearance[appearance],
            !isDisabled && $509076ff0c6afa78$var$focusWithinStyle[appearance],
            !isDisabled && $509076ff0c6afa78$var$hoverStyle[appearance],
            isDisabled && $509076ff0c6afa78$var$containerMedia.disabled,
            isDisabled && $509076ff0c6afa78$var$disabledStyle[appearance],
            isInvalid && $509076ff0c6afa78$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _10j7r01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;

});

parcelRegister("6lbCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5097d73619a780fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $5097d73619a780fd$var$ActionModalCustomHeader = ({ headingLevel: headingLevel = 1, title: title })=>{
    // Dynamically render the heading tag based on the level
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const Heading = `h${headingLevel}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5097d73619a780fd$var$CustomHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5097d73619a780fd$var$DynamicHeading, {
        as: Heading
    }, title));
};
var $5097d73619a780fd$export$2e2bcd8739ae039 = $5097d73619a780fd$var$ActionModalCustomHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5097d73619a780fd$var$DynamicHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8lodh",
            __cmplp.className
        ])
    });
});
const $5097d73619a780fd$var$headerStyles = {
    display: 'flex',
    padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"} 22px`,
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5097d73619a780fd$var$CustomHeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4npc0 _1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7iGYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa11b5fbf0de6c62$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $ldJSL = parcelRequire("ldJSL");

var $juxqI = parcelRequire("juxqI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $5OJD6 = parcelRequire("5OJD6");
function $fa11b5fbf0de6c62$export$1784e93004806671(props) {
    const { isActionEnabled: isActionEnabled, isActionInProgress: isActionInProgress, actionButtonCaption: actionButtonCaption, actionButtonAppearance: actionButtonAppearance, onCancel: onCancel, onAction: onAction, intl: { formatMessage: formatMessage } } = props;
    const SaveBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: actionButtonAppearance,
        type: "submit",
        isDisabled: !isActionEnabled,
        onClick: onAction
    }, actionButtonCaption);
    const CancelBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        isDisabled: isActionInProgress,
        onClick: onCancel
    }, formatMessage((0, $5OJD6.default).cancelButtonCaption));
    const footerGroup = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, CancelBtn, SaveBtn) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, SaveBtn, CancelBtn);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa11b5fbf0de6c62$var$Container, null, isActionInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $fa11b5fbf0de6c62$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, footerGroup)));
}
$fa11b5fbf0de6c62$export$1784e93004806671.defaultProps = {
    isActionEnabled: true,
    isActionInProgress: false,
    actionButtonAppearance: 'primary',
    onAction: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $fa11b5fbf0de6c62$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($fa11b5fbf0de6c62$export$1784e93004806671);
const $fa11b5fbf0de6c62$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $fa11b5fbf0de6c62$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.200'
});

});
parcelRegister("5OJD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1955ef7db7bf7b0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d1955ef7db7bf7b0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cancelButtonCaption: {
        "id": "shareable-entity-dialog.action-modal-footer.cancel-button-caption",
        "defaultMessage": "Cancel"
    }
});

});





parcelRegister("6325A", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb76d6dda2992ec$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $bdb76d6dda2992ec$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "copy-filters-modal.common.flags.error.title",
        "defaultMessage": "We couldn't copy a filter"
    },
    description: {
        "id": "copy-filters-modal.common.flags.error.description",
        "defaultMessage": "There was an error, please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdb76d6dda2992ec$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $bdb76d6dda2992ec$var$messages.title,
        description: $bdb76d6dda2992ec$var$messages.description,
        messageId: 'copy-filters-modal.common.ui.flags.error',
        messageType: 'transactional'
    });

});

parcelRegister("d6KcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c32dd25ef56dad3d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c32dd25ef56dad3d$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "copy-filters-modal.common.flags.success.title",
        "defaultMessage": "A copy of {name} was successfully created."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c32dd25ef56dad3d$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        title: [
            $c32dd25ef56dad3d$var$messages.title,
            {
                name: name
            }
        ],
        isAutoDismiss: true,
        messageId: 'copy-filters-modal.common.ui.flags.success',
        messageType: 'transactional'
    });

});

parcelRegister("2ZmUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ecc35357e7f45af$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");

var $dnOue = parcelRequire("dnOue");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ecc35357e7f45af$export$2e2bcd8739ae039 = (filter, jql, isFavourite, overrideSharePermissions)=>{
    const body = (0, $dnOue.transformCopyFilter)(filter, jql, isFavourite);
    return (0, $eusud.performPostRequest)(`/rest/api/2/filter${overrideSharePermissions ? '?overrideSharePermissions=true' : ''}`, {
        body: JSON.stringify(body)
    });
};

});
parcelRegister("dnOue", function(module, exports) {

$parcel$export(module.exports, "transformCopyFilter", () => $8b07381dc62d94d1$export$bf8cb54494b88c10);

var $knvh6 = parcelRequire("knvh6");
const $8b07381dc62d94d1$export$bf8cb54494b88c10 = (filter, jql, isFavourite)=>{
    const { description: description, name: name, owner: owner, editPermissions: editPermissions, sharePermissions: sharePermissions } = filter;
    const result = {
        name: name,
        description: description,
        favourite: isFavourite,
        jql: jql,
        sharePermissions: (0, $knvh6.transformSharePermissionsToServer)(sharePermissions || [], true),
        editPermissions: (0, $knvh6.transformSharePermissionsToServer)(editPermissions || [], true)
    };
    if (owner) result.owner = {
        accountId: owner.accountId
    };
    return result;
};

});


parcelRegister("54Uq9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fab1748318121f9d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fab1748318121f9d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "copy-filters-modal.content.header",
        "defaultMessage": "Copy filter {name}"
    },
    saveButtonCaption: {
        "id": "copy-filters-modal.content.save-button-caption",
        "defaultMessage": "Copy"
    }
});

});





parcelRegister("jwPQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fa266e21ecf613$export$2e2bcd8739ae039);

var $eM3no = parcelRequire("eM3no");

var $bC2fB = parcelRequire("bC2fB");

var $99OGQ = parcelRequire("99OGQ");

var $hXBjD = parcelRequire("hXBjD");

var $b9OA0 = parcelRequire("b9OA0");
const $e3fa266e21ecf613$var$mapStateToProps = (state, ownProps)=>({
        baseUrl: (0, $hXBjD.getBaseUrl)(state),
        filter: (0, $b9OA0.getFilter)(state, ownProps.entityId)
    });
const $e3fa266e21ecf613$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onInitialised: ownProps.onDialogShown,
        onFilterDeleted: (filter)=>{
            dispatch((0, $99OGQ.deleted)(filter.name));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        },
        onFilterDeleteFailed: (filter)=>dispatch((0, $99OGQ.deleteFailed)(filter.name)),
        onFilterInitiateFailed: (filter)=>{
            dispatch((0, $99OGQ.deleteFailed)(filter.name));
            ownProps.onDataRetrieveFailed();
        },
        onCancel: ownProps.onCancel
    });
var // @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'Filter'.
$e3fa266e21ecf613$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($e3fa266e21ecf613$var$mapStateToProps, $e3fa266e21ecf613$var$mapDispatchToProps)((0, $eM3no.default));

});

parcelRegister("1XGvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a67d3a83e2814c56$export$2e2bcd8739ae039);

var $l6Ke4 = parcelRequire("l6Ke4");

var $7XYc4 = parcelRequire("7XYc4");
var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $bC2fB = parcelRequire("bC2fB");

var $6KXPO = parcelRequire("6KXPO");

var $hXBjD = parcelRequire("hXBjD");

var $b9OA0 = parcelRequire("b9OA0");
const $a67d3a83e2814c56$var$mapStateToPropsOld = (state, ownProps)=>({
        baseUrl: (0, $hXBjD.getBaseUrl)(state),
        id: ownProps.entityId,
        name: (0, $b9OA0.getName)(state, ownProps.entityId),
        description: (0, $b9OA0.getDescription)(state, ownProps.entityId),
        // owner: getOwner(state, ownProps.entityId), // send only when backend supports changing owner
        sharePermissions: (0, $b9OA0.getShares)(state, ownProps.entityId),
        editPermissions: (0, $b9OA0.getEdits)(state, ownProps.entityId),
        onCancel: ownProps.onCancel,
        onInitiateSuccess: ()=>{
            ownProps.onDialogShown();
        },
        // onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
        onEdited: (_updatedData)=>{
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        }
    });
const $a67d3a83e2814c56$var$mapStateToPropsNew = (initialState, ownProps)=>{
    const onEdited = (_updatedData)=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        ownProps.onUpdated();
    };
    const onInitiateSuccess = ()=>{
        ownProps.onDialogShown();
    };
    return (state)=>({
            baseUrl: (0, $hXBjD.getBaseUrl)(state),
            id: ownProps.entityId,
            name: (0, $b9OA0.getName)(state, ownProps.entityId),
            description: (0, $b9OA0.getDescription)(state, ownProps.entityId),
            sharePermissions: (0, $b9OA0.getShares)(state, ownProps.entityId),
            editPermissions: (0, $b9OA0.getEdits)(state, ownProps.entityId),
            onCancel: ownProps.onCancel,
            onInitiateSuccess: onInitiateSuccess,
            onEdited: // onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
            onEdited
        });
};
const $a67d3a83e2814c56$var$mapStateToPropsNewModal = (initialState, ownProps)=>{
    const onEdited = (_updatedData)=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        ownProps.onUpdated();
    };
    return ()=>({
            onDialogShown: ownProps.onDialogShown,
            filterId: ownProps.entityId,
            onClose: ownProps.onCancel,
            onSuccess: onEdited,
            // onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
            isOpen: true
        });
};
const $a67d3a83e2814c56$var$FilterDialog = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $6KXPO.AsyncUpdateFilterDialog), (0, $l6Ke4.default));
const $a67d3a83e2814c56$var$mapStateToProps = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('fix_unstable_selector_in_filter_directory'), // @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
(0, $e5wyW.functionWithCondition)((0, $3HwlS.getWillShowNav4), $a67d3a83e2814c56$var$mapStateToPropsNewModal, $a67d3a83e2814c56$var$mapStateToPropsNew), // @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
$a67d3a83e2814c56$var$mapStateToPropsOld);
var $a67d3a83e2814c56$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($a67d3a83e2814c56$var$mapStateToProps, {})($a67d3a83e2814c56$var$FilterDialog);

});
parcelRegister("l6Ke4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c35f0b79aa6dfc3d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");


var $itmJb = parcelRequire("itmJb");

var $fL8H8 = parcelRequire("fL8H8");
function $c35f0b79aa6dfc3d$var$EditFilterModal(props) {
    const isAdmin = (0, $itmJb.useIsAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraEditFiltersModal",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fL8H8.default), {
        isAdmin: isAdmin,
        ...props
    }))));
}
$c35f0b79aa6dfc3d$var$EditFilterModal.defaultProps = {
    onEdited: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onEditFailed: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $c35f0b79aa6dfc3d$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('editFilter', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))((0, $jzjy1.AnalyticsSubject)('filter')($c35f0b79aa6dfc3d$var$EditFilterModal));

});
parcelRegister("fL8H8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a390f8fb17161711$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hhweD = parcelRequire("hhweD");

var $akuTQ = parcelRequire("akuTQ");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");


var $3Wfkl = parcelRequire("3Wfkl");

var $55cx0 = parcelRequire("55cx0");

var $3Ght4 = parcelRequire("3Ght4");

var $hMYMm = parcelRequire("hMYMm");
const $a390f8fb17161711$var$getServerSideValidationErrors = (0, $akuTQ.createServerSideValidationErrorsGetter)({
    filterName: (0, $99958954cd57b065$export$b85469cbf362db42),
    shares: (0, $99958954cd57b065$export$378fd4cd7d69440f),
    edit_permissions: (0, $99958954cd57b065$export$fb465a1f4d511f87)
});
class $a390f8fb17161711$export$c4b945a6bafc6ddb extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onInitiateSuccess();
    }
    render() {
        const { baseUrl: baseUrl, onCancel: onCancel, name: name, description: description, editPermissions: editPermissions, sharePermissions: sharePermissions, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hMYMm.default), {
            baseUrl: baseUrl,
            intl: intl,
            onCancel: onCancel,
            name: name,
            description: description,
            sharePermissions: sharePermissions,
            editPermissions: editPermissions,
            operation: this.onOperation,
            onOperationSucceed: this.onOperationSucceed,
            onOperationFailed: this.onOperationFailed,
            getServerSideValidationErrors: $a390f8fb17161711$var$getServerSideValidationErrors
        });
    }
    constructor(...args){
        super(...args), this.onOperation = (filter)=>{
            const { id: id, isAdmin: isAdmin } = this.props;
            return (0, $3Ght4.default)(id, filter, isAdmin);
        }, this.onOperationSucceed = (filter, _, analyticsEvent)=>{
            const { id: id, onEdited: onEdited, flagService: flagService } = this.props;
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'editedFilter', {
                isViewerPrivate: filter.sharePermissions.length === 0,
                isEditorPrivate: filter.editPermissions && filter.editPermissions.length === 0
            });
            flagService.showFlag((0, $55cx0.default)(filter.name));
            (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
                action: 'updated',
                actionSubjectId: `${id}`
            });
            onEdited(filter);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOperationFailed = (error, analyticsEvent)=>{
            const { id: id, onEditFailed: onEditFailed, flagService: flagService } = this.props;
            (0, $2YZCu.default).safeErrorWithoutCustomerData('directories.filters.edit-modal.submit', `edit filter has failed, id=${this.props.id}`, error);
            if (!(error instanceof (0, $jJZqs.ValidationError))) flagService.showFlag((0, $3Wfkl.default)());
            onEditFailed();
            (0, $jcw0u.default)({
                event: analyticsEvent,
                error: error,
                meta: {
                    id: 'operationFailedHandler',
                    packageName: 'jiraEditFiltersModal',
                    teamName: 'jira-cosmos'
                },
                attributes: {
                    action: 'updated',
                    actionSubjectId: `${id}`
                }
            });
        };
    }
}
var $a390f8fb17161711$export$2e2bcd8739ae039 = (0, $34Vv8.default)((0, $az4zD.injectIntlV2)($a390f8fb17161711$export$c4b945a6bafc6ddb));

});
parcelRegister("34Vv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $827c4d80e4d41b48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $pa9q9.flagService)
        });
};
var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;

});

parcelRegister("3Wfkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ccaec7baa697fdd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7ccaec7baa697fdd$var$messages = (0, $7VHMR.defineMessages)({
    genericTitle: {
        "id": "directories.filters-v2.edit-modal.flags.error.generic-title",
        "defaultMessage": "There was an error, please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7ccaec7baa697fdd$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $7ccaec7baa697fdd$var$messages.genericTitle,
        messageId: 'edit-filters-modal.flags.error',
        messageType: 'transactional'
    });

});

parcelRegister("55cx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5c875dfc0997fca$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $e5c875dfc0997fca$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.edit-modal.flags.success.title",
        "defaultMessage": "{name} was successfully updated."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e5c875dfc0997fca$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        title: [
            $e5c875dfc0997fca$var$messages.title,
            {
                name: name
            }
        ],
        isAutoDismiss: true,
        messageId: 'edit-filters-modal.flags.success',
        messageType: 'transactional'
    });

});

parcelRegister("3Ght4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6c86337ac53e96$export$2e2bcd8739ae039);

var $fsh9d = parcelRequire("fsh9d");


var $6YLvv = parcelRequire("6YLvv");

var $qazD0 = parcelRequire("qazD0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b6c86337ac53e96$export$2e2bcd8739ae039 = async (id, filter, overrideSharePermissions)=>{
    const body = (0, $qazD0.transformEditableFilter)(filter);
    try {
        await (0, $6YLvv.default)(id, body, overrideSharePermissions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.edit-modal.edit-filter', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
        throw error;
    }
};

});
parcelRegister("6YLvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $144b23851a5bf169$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
const $144b23851a5bf169$export$4a8805dc45e0d1a2 = (filterId, overrideSharePermissions)=>`/rest/api/3/filter/${filterId}${overrideSharePermissions ? '?overrideSharePermissions=true' : ''}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$144b23851a5bf169$export$2e2bcd8739ae039 = async (filterId, body, overrideSharePermissions)=>{
    const url = $144b23851a5bf169$export$4a8805dc45e0d1a2(filterId, overrideSharePermissions);
    return (0, $eusud.performPutRequest)(url, {
        body: JSON.stringify(body)
    });
};

});

parcelRegister("qazD0", function(module, exports) {

$parcel$export(module.exports, "transformEditableFilter", () => $5dcb7ead13405e08$export$29126713ffd80950);

var $knvh6 = parcelRequire("knvh6");
const $5dcb7ead13405e08$export$29126713ffd80950 = (filter)=>{
    const { description: description, name: name, owner: owner, sharePermissions: sharePermissions, editPermissions: editPermissions } = filter;
    const result = {
        name: name,
        description: description,
        sharePermissions: (0, $knvh6.transformSharePermissionsToServer)(sharePermissions || [], true),
        editPermissions: editPermissions ? (0, $knvh6.transformSharePermissionsToServer)(editPermissions, true) : undefined
    };
    if (owner) result.owner = {
        accountId: owner.accountId
    };
    return result;
};

});


parcelRegister("hMYMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $14ee0d3e2848c0ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $70IFa = parcelRequire("70IFa");

var $6aRCd = parcelRequire("6aRCd");
function $14ee0d3e2848c0ab$export$97b20acb2862c69e(props) {
    const { intl: { formatMessage: formatMessage }, name: name, description: description, onCancel: onCancel, ...restProps } = props;
    // Use sharing permission aware modal instead of one which doesn't respect global sharing setting
    return(// @ts-expect-error - TS2322 - Type '{ baseUrl: string; sharePermissions: SharePermission[]; editPermissions: SharePermission[]; getServerSideValidationErrors: (arg1: ValidationError) => Partial<...>; ... 10 more ...; onCancel: () => void; }' is not assignable to type 'Diff<AppProps<undefined>, { shareeOptions: Option[]; isEditorListShown: boolean; editOptions: Option[]; isShareScopeLoading?: boolean | undefined; }>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70IFa.SharingPermissionAwareShareableEntityModal), {
        sharingPermissionType: "filter",
        avoidInitialPublicSharePermission: false,
        title: formatMessage((0, $6aRCd.default).title),
        actionButtonCaption: formatMessage((0, $6aRCd.default).submitButtonCaption),
        initialName: name,
        initialDescription: description,
        initialOwner: undefined,
        onCancel: onCancel,
        ...restProps
    }));
}
var $14ee0d3e2848c0ab$export$2e2bcd8739ae039 = $14ee0d3e2848c0ab$export$97b20acb2862c69e;

});
parcelRegister("6aRCd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d6bc3753cd08742$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8d6bc3753cd08742$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "directories.filters-v2.edit-modal.title",
        "defaultMessage": "Edit filter"
    },
    submitButtonCaption: {
        "id": "directories.filters-v2.edit-modal.submit-button-caption",
        "defaultMessage": "Save"
    }
});

});





parcelRegister("h2X1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $90ba86016fcd46a7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $90ba86016fcd46a7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    headerCaption: {
        "id": "directories.filters-v2.main.header-caption",
        "defaultMessage": "Filters"
    },
    filter: {
        "id": "directories.filters-v2.main.filter",
        "defaultMessage": "Name"
    },
    popularity: {
        "id": "directories.filters-v2.main.popularity",
        "defaultMessage": "Starred by"
    },
    owner: {
        "id": "directories.filters-v2.main.owner",
        "defaultMessage": "Owner"
    },
    access: {
        "id": "directories.filters-v2.main.access",
        "defaultMessage": "Access"
    },
    viewers: {
        "id": "directories.filters-v2.main.viewers",
        "defaultMessage": "Viewers"
    },
    editors: {
        "id": "directories.filters-v2.main.editors",
        "defaultMessage": "Editors"
    },
    emptyFilterResultMessage: {
        "id": "directories.filters-v2.main.empty-filter-result-message",
        "defaultMessage": "No filters were found that match your search"
    },
    tableAriaLabel: {
        "id": "directories.filters-v2.main.table-aria-label",
        "defaultMessage": "Filters details"
    },
    filterResultsAnnouncement: {
        "id": "directories.filters-v2.main.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No filters were found that match your search} one {{itemCount} filter found} other {{itemCount} filters found}}"
    },
    actions: {
        "id": "directories.filters-v2.main.actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "directories.filters-v2.main.a-to-z-order",
        "defaultMessage": "Sort A to Z"
    },
    zToAOrder: {
        "id": "directories.filters-v2.main.z-to-a-order",
        "defaultMessage": "Sort Z to A"
    },
    starredToUnstarredOrder: {
        "id": "directories.filters-v2.main.starred-to-unstarred-order",
        "defaultMessage": "Sort starred to unstarred"
    },
    unstarredToStarredOrder: {
        "id": "directories.filters-v2.main.unstarred-to-starred-order",
        "defaultMessage": "Sort unstarred to starred"
    },
    lowestToHighestOrder: {
        "id": "directories.filters-v2.main.lowest-to-highest-order",
        "defaultMessage": "Sort lowest to highest"
    },
    highestToLowestOrder: {
        "id": "directories.filters-v2.main.highest-to-lowest-order",
        "defaultMessage": "Sort highest to lowest"
    }
});

});




parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("fhVq7", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $501f0ba909d41168$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $501f0ba909d41168$export$6d1402fb58384e4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");
const $501f0ba909d41168$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $501f0ba909d41168$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: (0, $dCm1o.isVisualRefreshEnabled)() ? 'space.300' : 'space.500'
    }, children);
const $501f0ba909d41168$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    const isVisualRefresh = (0, $dCm1o.isVisualRefreshEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: // eslint-disable-next-line no-nested-ternary
        hideMargin ? $501f0ba909d41168$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $501f0ba909d41168$var$pageLayoutWithMarginStyles : $501f0ba909d41168$var$pageLayoutWithMarginStylesOld
    }, children);
};
const $501f0ba909d41168$var$scrollablePageStyles = (0, $8CUq3.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithoutMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStylesOld = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStyles = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});

});

parcelRegister("cJXov", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryPageLoad", () => $925da641693c2c42$export$4545feeca18b385d);

var $dGrdR = parcelRequire("dGrdR");
const $925da641693c2c42$export$4545feeca18b385d = (0, $dGrdR.metrics).pageLoad({
    key: 'filters-directory',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-filters-directory.4cf868e7.js.map
